(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5778,9466,8022,635,1539,8185],{

/***/ 50381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(91706);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 19494:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit/map",
      function () {
        return __webpack_require__(70296);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22522);
/* harmony import */ var _constants_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26093);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64952);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70138);
/* harmony import */ var _types_magazine__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45162);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78287);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var BreadCrumbs = function(param) {
    var visible = param.visible, path = param.path, type = param.type, name = param.name, urlParameter = param.urlParameter;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var paths = path.split("/").filter(function(item) {
        return item !== "content";
    });
    var breadCrumbPath = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(detailPath) {
        if (detailPath === "") {
            return {
                label: "홈",
                url: "/",
                logName: "home"
            };
        }
        if (path.includes("community")) {
            if (detailPath === "setting") {
                return {
                    label: "설정",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.SETTING.path */ .Z6.COMMUNITY.SETTING.path),
                    logName: "community_setting"
                };
            }
            if (detailPath === "write") {
                return {
                    label: "글쓰기",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.WRITE.path */ .Z6.COMMUNITY.WRITE.path),
                    logName: "community_write"
                };
            }
            if (detailPath === "comment") {
                var pid = path.split("/");
                return {
                    label: "대댓글",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.COMMENT.path */ .Z6.COMMUNITY.COMMENT.path, "/").concat(pid[pid.length - 1]),
                    logName: "community_comment"
                };
            }
            if (detailPath === "community") {
                return {
                    label: "커뮤니티",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.LIST.path */ .Z6.COMMUNITY.LIST.path),
                    logName: "community_list"
                };
            }
            if (detailPath === "list") {
                return {
                    label: name,
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMUNITY.LIST.path */ .Z6.COMMUNITY.LIST.path).concat(urlParameter),
                    logName: "community_list_category"
                };
            }
        }
        if (detailPath === "qna") {
            return {
                label: "실시간 의료상담",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path,
                logName: "qna_list"
            };
        }
        if (detailPath === "realtime") {
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.REALTIME.path */ .Z6.QNA.REALTIME.path).concat(urlParameter),
                logName: "qna_list_category"
            };
        }
        if (detailPath === "write") {
            return {
                label: "질문 작성",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.WRITE.path */ .Z6.QNA.WRITE.path,
                logName: "qna_write"
            };
        }
        if (detailPath === "nps") {
            return {
                label: "의견 전하기",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.QNA.NPS.path */ .Z6.QNA.NPS.path,
                logName: "qna_nps"
            };
        }
        if (path.includes("author")) {
            if (detailPath === "author") {
                return {
                    label: "에디터",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.HOME.path */ .Z6.MAGAZINE.HOME.path,
                    logName: "magazine_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.AUTHOR.DETAIL.path */ .Z6.AUTHOR.DETAIL.path, "/").concat(urlParameter),
                logName: "magazine_list"
            };
        }
        if (path.includes("magazine")) {
            if (detailPath === "magazine") {
                return {
                    label: "건강 매거진",
                    url: _constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.Magazine */ .n.Magazine,
                    logName: "magazine_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.DETAIL.path */ .Z6.MAGAZINE.DETAIL.path, "/").concat(urlParameter),
                logName: "magazine_list"
            };
        }
        if (path.includes("faq")) {
            if (detailPath === "faq") {
                return {
                    label: "1분 FAQ",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.FAQ.LIST.path */ .Z6.FAQ.LIST.path,
                    logName: "faq_list"
                };
            }
            return {
                label: name,
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.FAQ.DETAIL.path */ .Z6.FAQ.DETAIL.path, "/").concat(urlParameter),
                logName: "faq_list"
            };
        }
        if (detailPath === "mypage") {
            return {
                label: "마이페이지",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.COMMON.MYPAGE.path */ .Z6.COMMON.MYPAGE.path,
                logName: "mypage"
            };
        }
        if (path.includes("hospitals")) {
            if (detailPath.includes("search")) {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.DETAIL.path */ .Z6.HOSPITAL.DETAIL.path).concat(detailPath),
                    logName: "hospitals_search"
                };
            }
            if (detailPath.includes("sub-category")) {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path, "/").concat(detailPath),
                    logName: "hospitals_subcategory"
                };
            }
            if (detailPath.includes("neighborhood")) {
                return {
                    label: "지역별 병원 정보",
                    url: path,
                    logName: "hospitals_neighborhood"
                };
            }
            return {
                label: "병원 찾기",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.HOSPITAL.HOME.path */ .Z6.HOSPITAL.HOME.path),
                logName: "hospitals"
            };
        }
        if (path.includes("medicine-dictionary")) {
            if (detailPath === "search") {
                return {
                    label: "검색 결과",
                    url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MEDICINE_DICTIONARY.SEARCH.path */ .Z6.MEDICINE_DICTIONARY.SEARCH.path),
                    logName: "medicine_dictionary_search_result"
                };
            }
            return {
                label: "의약품 사전",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MEDICINE_DICTIONARY.HOME.path */ .Z6.MEDICINE_DICTIONARY.HOME.path),
                logName: "medicine_dictionary_list"
            };
        }
        if (path.includes("disease-encyclopedia")) {
            if (detailPath === "select-subject") {
                return {
                    label: "과목 선택",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path */ .Z6.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path,
                    logName: "disease_encyclopedia_select_subject"
                };
            }
            if (detailPath === "total") {
                return {
                    label: "전체 질환",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path */ .Z6.DISEASE_ENCYCLOPEDIA.SELECT_SUBJECT.path,
                    logName: "disease_encyclopedia_select_subject"
                };
            }
            if (detailPath === "search") {
                return {
                    label: "검색 결과",
                    url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path */ .Z6.DISEASE_ENCYCLOPEDIA.SEARCH.path,
                    logName: "disease_encyclopedia_search"
                };
            }
            return {
                label: "질환백과",
                url: _types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path */ .Z6.DISEASE_ENCYCLOPEDIA.HOME.path,
                logName: "disease_encyclopedia_list"
            };
        }
        if (detailPath === "search") {
            return {
                label: "통합검색",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.SEARCH */ .Z6.SEARCH().HOME.path),
                logName: "integrated_search"
            };
        }
        if (detailPath === "list") {
            return {
                label: "전체",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.LIST.path */ .Z6.MAGAZINE.LIST.path, "/").concat(_types_magazine__WEBPACK_IMPORTED_MODULE_9__/* .MagazineType.INTERNAL */ .rL.INTERNAL),
                logName: "magazine_list"
            };
        }
        if (detailPath.includes("tag")) {
            var tag = detailPath.split("=");
            return {
                label: decodeURI(tag[1]),
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.HOME.path */ .Z6.MAGAZINE.HOME.path, "/").concat(detailPath),
                logName: "magazine_list_tags"
            };
        }
        if (detailPath === "non-benefit") {
            return {
                label: "우리동네 진료 가격",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.NON_BENEFIT.HOME.path */ .Z6.NON_BENEFIT.HOME.path),
                logName: "non_benefit_home"
            };
        }
        if (detailPath.includes("map")) {
            return {
                label: "최저가 약국 찾기",
                url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.NON_BENEFIT.MAP.path */ .Z6.NON_BENEFIT.MAP.path),
                logName: "non_benefit_map"
            };
        }
        if (name) {
            return {
                label: name,
                url: type === "qna" ? "".concat(_constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.QnaCategory */ .n.QnaCategory, "/").concat(detailPath) : "".concat(_constants_url__WEBPACK_IMPORTED_MODULE_6__/* .Urls.MagazineCategory */ .n.MagazineCategory, "/list/").concat(detailPath),
                logName: "ctg"
            };
        }
        return {
            label: decodeURI(decodeURIComponent(detailPath)),
            url: "".concat(_types_common__WEBPACK_IMPORTED_MODULE_8__/* .ROUTES.MAGAZINE.LIST.path */ .Z6.MAGAZINE.LIST.path, "/").concat(detailPath),
            logName: "magazine_list_tags"
        };
    }, [
        name,
        path,
        type
    ]);
    var breadCrumb = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return paths.map(function(path) {
            return breadCrumbPath(path);
        }).filter(function(item) {
            return item !== null;
        });
    }, [
        breadCrumbPath,
        paths
    ]);
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumb.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumb.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aec17bfc-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_12__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aec17bfc-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aec17bfc-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_7__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
BreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 84655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);




var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7642), __webpack_require__.e(3540)]).then(__webpack_require__.bind(__webpack_require__, 73540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73540)
            ];
        }
    }
});
var defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};
var CustomLottie = function(_param) {
    var width = _param.width, height = _param.height, style = _param.style, isStopped = _param.isStopped, _isClickToPauseDisabled = _param.isClickToPauseDisabled, isClickToPauseDisabled = _isClickToPauseDisabled === void 0 ? true : _isClickToPauseDisabled, eventListeners = _param.eventListeners, customOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "style",
        "isStopped",
        "isClickToPauseDisabled",
        "eventListeners"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Lottie, {
        options: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, defaultOptions, customOptions),
        width: width,
        height: height,
        isStopped: isStopped !== null && isStopped !== void 0 ? isStopped : false,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            margin: 0
        }, style),
        isClickToPauseDisabled: isClickToPauseDisabled,
        eventListeners: eventListeners
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLottie);


/***/ }),

/***/ 22522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BreadCrumbArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z",
            fill: "#A9AEB1"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbArrow);


/***/ }),

/***/ 2721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var Link = function(param) {
    var _hasWrapper = param.hasWrapper, hasWrapper = _hasWrapper === void 0 ? true : _hasWrapper;
    if (hasWrapper) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: "#DFE1E2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    clipPath: "url(#clip0_187_4288)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M19.5458 8.00944C19.1947 8.0585 18.8648 8.20877 18.5967 8.4418C18.5587 8.47482 17.9873 9.04759 17.3268 9.71463C16.6664 10.3817 15.8477 11.2082 15.5076 11.5514C15.0912 11.9715 14.8781 12.1911 14.8553 12.2234C14.7984 12.3041 14.7632 12.3831 14.7383 12.4858C14.725 12.5409 14.7269 12.7264 14.7414 12.7883C14.7857 12.9771 14.9043 13.1363 15.0787 13.2411C15.1368 13.276 15.1781 13.293 15.2546 13.3134C15.2983 13.3251 15.3236 13.3271 15.4274 13.3272C15.5407 13.3273 15.5533 13.3261 15.613 13.3096C15.6929 13.2875 15.7767 13.2463 15.844 13.196C15.8794 13.1695 16.4653 12.5823 17.7064 11.3294C18.7022 10.324 19.5315 9.49052 19.5492 9.47714C19.6175 9.42552 19.6965 9.40048 19.7922 9.40013C19.8869 9.39978 19.9553 9.41897 20.0248 9.46542C20.0495 9.48188 20.4235 9.85676 21.1084 10.5514C22.6644 12.1296 22.49 11.9488 22.524 12.0193C22.5565 12.0868 22.5666 12.1313 22.5666 12.2076C22.5666 12.2727 22.549 12.3435 22.5177 12.4046C22.4954 12.4481 22.3941 12.5508 20.656 14.2906C19.0524 15.8959 18.8135 16.1376 18.7826 16.185C18.7391 16.2519 18.7195 16.291 18.7024 16.345C18.6753 16.4307 18.6722 16.4546 18.6724 16.5754C18.6726 16.6755 18.6747 16.7018 18.6862 16.745C18.7065 16.8213 18.7236 16.8628 18.7585 16.9209C18.8634 17.0954 19.0225 17.2139 19.2114 17.2582C19.25 17.2673 19.2857 17.2697 19.373 17.2693C19.4731 17.2688 19.4918 17.267 19.549 17.2517C19.6244 17.2316 19.7003 17.1965 19.7686 17.1504C19.8071 17.1243 20.202 16.7332 21.5928 15.3439C22.5691 14.3686 23.4076 13.5283 23.4561 13.4765C23.5582 13.3675 23.6081 13.3053 23.6755 13.2026C23.7995 13.0141 23.8908 12.7922 23.9356 12.5709C23.964 12.4304 23.9712 12.3567 23.9712 12.2042C23.9712 12.0518 23.964 11.9781 23.9356 11.8375C23.8775 11.5505 23.7472 11.2775 23.5576 11.0453C23.5253 11.0058 23.297 10.7687 23.0501 10.5185C22.8032 10.2682 22.2652 9.72215 21.8545 9.30503C21.4438 8.88791 21.0739 8.51544 21.0324 8.47733C20.752 8.21971 20.4091 8.05847 20.0358 8.00876C19.9457 7.99676 19.6334 7.99719 19.5458 8.00944ZM18.1666 13.0562C18.0995 13.0626 18.0112 13.0863 17.9525 13.1136C17.8344 13.1685 17.9689 13.0373 15.5035 15.5027C13.0379 17.9682 13.1691 17.8337 13.1143 17.9517C13.0386 18.1149 13.0334 18.3373 13.1014 18.5071C13.1696 18.6773 13.3223 18.83 13.4926 18.8982C13.6623 18.9662 13.8847 18.961 14.0479 18.8853C14.1659 18.8305 14.0314 18.9617 16.4969 16.4962C18.9625 14.0306 18.8312 14.1651 18.886 14.0471C18.9615 13.8844 18.9668 13.6611 18.899 13.4918C18.8436 13.3535 18.7321 13.2256 18.5951 13.1433C18.4791 13.0737 18.3206 13.0414 18.1666 13.0562ZM12.5378 14.7295C12.4066 14.752 12.3215 14.7859 12.2242 14.8545C12.1919 14.8773 11.9722 15.0905 11.5522 15.5068C11.209 15.847 10.3824 16.6657 9.71538 17.3261C9.04834 17.9865 8.47557 18.558 8.44255 18.596C8.20667 18.8674 8.05682 19.199 8.00951 19.5542C7.99683 19.6494 7.99683 19.9399 8.00951 20.035C8.05773 20.3971 8.21085 20.7307 8.45672 21.0095C8.55327 21.1189 10.9877 23.5456 11.053 23.5975C11.3264 23.8146 11.6305 23.9456 11.9646 23.9901C12.0598 24.0028 12.3502 24.0028 12.4454 23.9901C12.8169 23.9406 13.1621 23.7791 13.4389 23.525C13.4787 23.4885 14.0387 22.9258 14.6833 22.2746C15.3279 21.6234 16.1391 20.8041 16.4861 20.4538C16.9475 19.9881 17.126 19.8038 17.1507 19.7678C17.1969 19.7004 17.2321 19.6243 17.2525 19.5482C17.2677 19.491 17.2696 19.4723 17.2701 19.3722C17.2705 19.285 17.268 19.2493 17.2589 19.2106C17.2146 19.0217 17.0961 18.8626 16.9216 18.7577C16.8636 18.7229 16.8223 18.7059 16.7458 18.6854C16.7021 18.6737 16.6768 18.6717 16.573 18.6716C16.4595 18.6715 16.4471 18.6727 16.3874 18.6893C16.3061 18.7119 16.2225 18.7529 16.1563 18.8027C16.1213 18.829 15.5146 19.4371 14.2918 20.6716C13.2949 21.678 12.4653 22.5116 12.4484 22.5241C12.3789 22.5751 12.3022 22.5986 12.205 22.5986C12.1264 22.5986 12.081 22.5883 12.013 22.5551C11.9661 22.5323 11.9357 22.5024 10.7164 21.2832C9.49722 20.064 9.46735 20.0335 9.4445 19.9866C9.41133 19.9186 9.40106 19.8732 9.40106 19.7946C9.40106 19.6958 9.42539 19.6179 9.47791 19.5484C9.49129 19.5307 10.3248 18.7014 11.3302 17.7056C12.5825 16.4651 13.1703 15.8786 13.1968 15.8432C13.247 15.776 13.2883 15.6922 13.3104 15.6122C13.3269 15.5526 13.3281 15.54 13.328 15.4266C13.3279 15.3229 13.3259 15.2975 13.3142 15.2538C13.2938 15.1774 13.2768 15.136 13.2419 15.078C13.1382 14.9055 12.9811 14.7875 12.7938 14.7415C12.7538 14.7316 12.5743 14.7233 12.5378 14.7295Z",
                        fill: "#3D4551"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_187_4288",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white",
                            transform: "translate(8 8)"
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_403_8651)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.5458 0.00943519C11.1947 0.0584976 10.8648 0.20877 10.5967 0.4418C10.5587 0.474818 9.98728 1.04759 9.32685 1.71463C8.6664 2.38167 7.84774 3.20823 7.50758 3.55143C7.09124 3.9715 6.87805 4.19112 6.85526 4.22343C6.79836 4.3041 6.76318 4.38305 6.73834 4.48583C6.72501 4.54093 6.72691 4.72638 6.74143 4.78826C6.78574 4.97713 6.90426 5.13626 7.07874 5.24113C7.13678 5.27601 7.17811 5.29301 7.25458 5.31345C7.29828 5.32512 7.32361 5.32714 7.42738 5.32723C7.5407 5.32732 7.55334 5.32613 7.61298 5.30962C7.69294 5.2875 7.77675 5.24629 7.84396 5.19604C7.87945 5.16951 8.46528 4.58234 9.70636 3.3294C10.7022 2.32405 11.5315 1.49052 11.5492 1.47714C11.6175 1.42552 11.6965 1.40048 11.7922 1.40013C11.8869 1.39978 11.9553 1.41897 12.0248 1.46542C12.0495 1.48188 12.4235 1.85676 13.1084 2.55139C14.6644 4.12964 14.49 3.9488 14.524 4.01933C14.5565 4.08678 14.5666 4.13127 14.5666 4.20759C14.5666 4.27274 14.549 4.34346 14.5177 4.40455C14.4954 4.44812 14.3941 4.55078 12.656 6.29063C11.0524 7.89592 10.8135 8.13757 10.7826 8.18503C10.7391 8.25189 10.7195 8.29103 10.7024 8.34503C10.6753 8.43074 10.6722 8.45459 10.6724 8.57543C10.6726 8.67551 10.6747 8.70175 10.6862 8.74503C10.7065 8.82134 10.7236 8.86276 10.7585 8.92087C10.8634 9.09536 11.0225 9.21388 11.2114 9.25819C11.25 9.26726 11.2857 9.26972 11.373 9.26931C11.4731 9.26884 11.4918 9.26697 11.549 9.2517C11.6244 9.23159 11.7003 9.19653 11.7686 9.15036C11.8071 9.1243 12.202 8.73324 13.5928 7.34387C14.5691 6.36859 15.4076 5.52826 15.4561 5.47646C15.5582 5.36753 15.6081 5.30529 15.6755 5.20263C15.7995 5.01407 15.8908 4.79223 15.9356 4.57094C15.964 4.43041 15.9712 4.35669 15.9712 4.20423C15.9712 4.05178 15.964 3.97806 15.9356 3.83752C15.8775 3.55055 15.7472 3.27749 15.5576 3.04533C15.5253 3.00583 15.297 2.76874 15.0501 2.51847C14.8032 2.2682 14.2652 1.72215 13.8545 1.30503C13.4438 0.887912 13.0739 0.515445 13.0324 0.477326C12.752 0.219714 12.4091 0.058472 12.0358 0.00875679C11.9457 -0.00324321 11.6334 -0.00280801 11.5458 0.00943519ZM10.1666 5.05617C10.0995 5.06259 10.0112 5.08627 9.9525 5.11356C9.83439 5.16848 9.96887 5.03729 7.50346 7.50271C5.03792 9.96824 5.16913 9.83374 5.11435 9.95175C5.0386 10.1149 5.03341 10.3373 5.10139 10.5071C5.16957 10.6773 5.32228 10.83 5.49256 10.8982C5.66232 10.9662 5.88471 10.961 6.04787 10.8853C6.16587 10.8305 6.03137 10.9617 8.49691 8.49615C10.9625 6.03062 10.8312 6.16512 10.886 6.04712C10.9615 5.88443 10.9668 5.66108 10.899 5.49181C10.8436 5.35347 10.7321 5.22559 10.5951 5.14333C10.4791 5.07367 10.3206 5.04143 10.1666 5.05617ZM4.53778 6.72951C4.40655 6.75196 4.3215 6.78586 4.22418 6.85451C4.19187 6.8773 3.97225 7.09049 3.55218 7.50683C3.20898 7.84699 2.38242 8.66565 1.71538 9.32609C1.04834 9.98653 0.47557 10.558 0.442552 10.596C0.206674 10.8674 0.056824 11.199 0.0095088 11.5542C-0.0031696 11.6494 -0.0031696 11.9399 0.0095088 12.035C0.0577264 12.3971 0.210846 12.7307 0.456715 13.0095C0.553266 13.1189 2.98765 15.5456 3.05298 15.5975C3.32635 15.8146 3.63046 15.9456 3.96457 15.9901C4.05975 16.0028 4.35021 16.0028 4.44539 15.9901C4.81694 15.9406 5.16205 15.7791 5.43894 15.525C5.47873 15.4885 6.03868 14.9258 6.68327 14.2746C7.32785 13.6234 8.13913 12.8041 8.48611 12.4538C8.94747 11.9881 9.12604 11.8038 9.15068 11.7678C9.19689 11.7004 9.23215 11.6243 9.25245 11.5482C9.26772 11.491 9.26959 11.4723 9.27006 11.3722C9.27047 11.285 9.26801 11.2493 9.25894 11.2106C9.21463 11.0217 9.09611 10.8626 8.92162 10.7577C8.86359 10.7229 8.82226 10.7059 8.74578 10.6854C8.70209 10.6737 8.67676 10.6717 8.57298 10.6716C8.45953 10.6715 8.4471 10.6727 8.38738 10.6893C8.30606 10.7119 8.22246 10.7529 8.15631 10.8027C8.1213 10.829 7.51458 11.4371 6.29181 12.6716C5.29488 13.678 4.46534 14.5116 4.44838 14.5241C4.37889 14.5751 4.30222 14.5986 4.20498 14.5986C4.12642 14.5986 4.08101 14.5883 4.01298 14.5551C3.96611 14.5323 3.93566 14.5024 2.71644 13.2832C1.49722 12.064 1.46735 12.0335 1.4445 11.9866C1.41133 11.9186 1.40106 11.8732 1.40106 11.7946C1.40106 11.6958 1.42539 11.6179 1.47791 11.5484C1.49129 11.5307 2.32482 10.7014 3.33019 9.70558C4.58253 8.46508 5.1703 7.87864 5.19681 7.84318C5.24704 7.776 5.28825 7.69217 5.31037 7.61223C5.32688 7.55259 5.32807 7.53995 5.32798 7.42663C5.3279 7.32286 5.32587 7.29752 5.3142 7.25383C5.29376 7.17736 5.27676 7.13603 5.24188 7.07799C5.1382 6.90548 4.98114 6.78753 4.79378 6.74148C4.75379 6.73165 4.57433 6.72326 4.53778 6.72951Z",
                    fill: "#3D4551"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_403_8651",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 24903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var QnaReport = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFF3BF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3394_52609)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.8571 8H10.8571C10.4025 8 9.96641 8.18061 9.64493 8.5021C9.32344 8.82359 9.14282 9.25963 9.14282 9.71429V22.2857C9.14282 22.7403 9.32344 23.1765 9.64493 23.4979C9.96641 23.8194 10.4024 24 10.8571 24H21.1428C21.5975 24 22.0336 23.8194 22.3551 23.4979C22.6765 23.1765 22.8571 22.7403 22.8571 22.2857V15H16.5714C16.1769 15 15.8571 14.6802 15.8571 14.2857V8ZM22.3795 13.5714L17.2857 8.47759V13.5714H22.3795Z",
                    fill: "#FA5252"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3394_52609",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(8 8)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QnaReport);


/***/ }),

/***/ 76815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var UserBlock = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFE3E3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3394_52640)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.7088 8.00372C15.376 8.01971 15.1664 8.03793 14.8992 8.07409C13.8055 8.22214 12.7239 8.61346 11.7728 9.20518C11.3938 9.44098 11.0166 9.72359 10.6785 10.0251C10.5578 10.1327 10.3648 10.3136 10.32 10.3611C10.1715 10.5186 10.0756 10.6218 10.0279 10.6752C9.30249 11.489 8.75734 12.4284 8.41055 13.4624C8.20895 14.0635 8.08392 14.6676 8.02912 15.3056C8.00719 15.5608 8.00331 15.6652 8.00331 16C8.00331 16.3805 8.01283 16.5695 8.04829 16.8928C8.17702 18.0664 8.5756 19.2152 9.20523 20.2272C9.74266 21.091 10.4639 21.8659 11.296 22.4736C11.9416 22.9451 12.6925 23.3318 13.4624 23.5894C14.0684 23.7921 14.6672 23.916 15.3056 23.9709C15.5609 23.9928 15.6653 23.9967 16 23.9967C16.3805 23.9967 16.5695 23.9872 16.8928 23.9517C18.0664 23.823 19.2153 23.4243 20.2272 22.7948C20.6054 22.5594 20.9901 22.2711 21.3248 21.9719C21.447 21.8627 21.6363 21.6851 21.68 21.6388C21.9638 21.3379 22.0699 21.2188 22.2276 21.024C22.8225 20.289 23.2875 19.4401 23.5894 18.5376C23.7877 17.9448 23.911 17.3564 23.9682 16.7301C23.9798 16.6026 23.9936 16.3766 23.9936 16.3123C23.9936 16.2779 23.9965 16.2486 24 16.2464C24.0041 16.2438 24.0064 16.1523 24.0064 15.9928C24.0064 15.828 24.0042 15.7446 24 15.7472C23.9959 15.7497 23.9936 15.7286 23.9936 15.6883C23.9936 15.5831 23.9738 15.3093 23.9517 15.1072C23.8235 13.9351 23.4243 12.7846 22.7948 11.7728C22.2575 10.9091 21.536 10.1339 20.704 9.52635C20.0583 9.05476 19.3112 8.66994 18.5376 8.4105C17.8807 8.19017 17.2503 8.06679 16.5188 8.0154C16.3911 8.00643 15.823 7.99824 15.7088 8.00372ZM15.872 9.40606C14.5074 9.42632 13.1548 9.88989 12.0529 10.7149C11.9923 10.7603 11.9241 10.8126 11.9014 10.8312L11.8602 10.865L16.4981 15.5023L21.136 20.1396L21.1655 20.1034C21.1817 20.0835 21.2309 20.0194 21.2748 19.9611C21.9607 19.0498 22.4017 17.963 22.5433 16.8352C22.6005 16.3798 22.6094 15.8861 22.5691 15.408C22.4623 14.1408 21.9541 12.8758 21.1526 11.8816C20.8891 11.5548 20.5859 11.2429 20.2656 10.9692C19.243 10.0953 17.9391 9.54878 16.5952 9.43079C16.3897 9.41274 16.0967 9.40272 15.872 9.40606ZM10.8346 11.8965C10.8184 11.9165 10.7692 11.9805 10.7252 12.0389C10.2938 12.612 9.96081 13.2503 9.73211 13.9424C9.55222 14.4868 9.44978 15.0331 9.41414 15.6384C9.39894 15.8965 9.40607 16.3067 9.43071 16.592C9.51975 17.6229 9.86215 18.6339 10.4245 19.5264C10.7688 20.0728 11.2205 20.5916 11.7344 21.0307C12.6955 21.852 13.9096 22.387 15.168 22.5436C15.4574 22.5796 15.6825 22.5929 16 22.5929C16.3176 22.5929 16.5427 22.5796 16.832 22.5436C17.8744 22.4139 18.8975 22.0212 19.7627 21.4189C19.8632 21.3489 20.0457 21.2128 20.1034 21.1648L20.1396 21.1347L15.5018 16.4975L10.864 11.8603L10.8346 11.8965ZM8.00293 16C8.00293 16.139 8.00377 16.1959 8.00481 16.1264C8.00584 16.0568 8.00584 15.9431 8.00481 15.8736C8.00377 15.804 8.00293 15.8609 8.00293 16Z",
                    fill: "#FA5252"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3394_52640",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(8 8)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserBlock);


/***/ }),

/***/ 68764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var UserReport = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFF3BF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3394_52614)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.9999 12C19.9999 14.2091 18.2091 16 15.9999 16C13.7908 16 11.9999 14.2091 11.9999 12C11.9999 9.79086 13.7908 8 15.9999 8C18.2091 8 19.9999 9.79086 19.9999 12ZM8.36621 23.3143C9.38565 20.0686 12.4179 17.7143 16 17.7143C19.582 17.7143 22.6142 20.0686 23.6337 23.3143C23.743 23.6622 23.4709 24 23.1062 24H8.89371C8.52901 24 8.25693 23.6622 8.36621 23.3143Z",
                    fill: "#FA5252"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3394_52614",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(8 8)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserReport);


/***/ }),

/***/ 66875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var UserUnBlock = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#EBFBEE"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3394_52716)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.712 8.00366C15.402 8.01746 15.1664 8.03786 14.8992 8.07402C13.8055 8.22207 12.7239 8.6134 11.7728 9.20511C10.6874 9.88042 9.75158 10.839 9.10383 11.9391C8.96975 12.1668 8.7881 12.5205 8.68502 12.7545C8.31987 13.5836 8.10537 14.4179 8.02912 15.3055C8.00736 15.5587 8.0034 15.6656 8.00334 15.9999C8.00327 16.3802 8.01277 16.5688 8.04829 16.8927C8.17702 18.0664 8.5756 19.2151 9.20523 20.2271C9.70539 21.031 10.3631 21.7564 11.1264 22.3461C11.8172 22.8798 12.6187 23.3064 13.4624 23.5894C14.0635 23.791 14.6677 23.916 15.3056 23.9708C15.5609 23.9927 15.6653 23.9966 16 23.9966C16.3805 23.9966 16.5695 23.9871 16.8928 23.9516C18.0664 23.8229 19.2153 23.4243 20.2272 22.7947C20.6163 22.5526 20.9778 22.2806 21.3504 21.9494C21.4621 21.8501 21.8502 21.4619 21.9495 21.3503C22.4615 20.7742 22.8403 20.216 23.168 19.5551C23.6134 18.6564 23.8774 17.7242 23.9682 16.7301C23.9798 16.6025 23.9936 16.3765 23.9936 16.3123C23.9936 16.2779 23.9965 16.2485 24 16.2463C24.0041 16.2438 24.0064 16.1534 24.0064 15.9963C24.0064 15.8366 24.0042 15.7503 24 15.7503C23.9962 15.7503 23.9936 15.7252 23.9936 15.6879C23.9936 15.583 23.9738 15.309 23.9517 15.1071C23.8235 13.935 23.4243 12.7845 22.7948 11.7727C22.5051 11.3071 22.1701 10.8765 21.7865 10.4767C21.1181 9.78016 20.3994 9.25039 19.5552 8.83196C18.59 8.35354 17.6183 8.09223 16.5188 8.01538C16.3909 8.00645 15.8319 7.99832 15.712 8.00366ZM15.872 9.40599C14.5128 9.42618 13.1622 9.88736 12.064 10.7063C11.5581 11.0836 11.0845 11.5572 10.7064 12.0639C10.2857 12.6276 9.95734 13.2607 9.73211 13.9423C9.55222 14.4867 9.44978 15.0331 9.41414 15.6383C9.40493 15.7949 9.40493 16.2049 9.41414 16.3615C9.45087 16.9851 9.55821 17.5445 9.7494 18.1087C10.1365 19.2508 10.8074 20.2385 11.7344 21.0307C12.7576 21.9051 14.0669 22.4534 15.408 22.5692C15.7864 22.6019 16.2136 22.6019 16.592 22.5692C17.9333 22.4534 19.2413 21.9056 20.2656 21.0307C20.5331 20.8022 20.8023 20.533 21.0308 20.2655C21.8517 19.3044 22.3852 18.0943 22.5433 16.8351C22.6005 16.3798 22.6094 15.886 22.5691 15.4079C22.4623 14.141 21.9559 12.8799 21.1539 11.8833C20.8907 11.5563 20.587 11.2437 20.2656 10.9691C19.3046 10.1479 18.0901 9.61279 16.832 9.45631C16.5279 9.41848 16.1974 9.40116 15.872 9.40599ZM15.9104 11.9334C15.8185 11.9508 15.7851 11.9596 15.7347 11.98C15.5801 12.0422 15.4425 12.1724 15.3663 12.3286C15.3302 12.4025 15.3127 12.4646 15.3028 12.5526C15.2982 12.594 15.296 13.0482 15.296 13.9548V15.2959H13.955C13.0483 15.2959 12.5941 15.2981 12.5527 15.3027C12.4647 15.3125 12.4026 15.3301 12.3287 15.3662C12.1341 15.4611 11.9894 15.6423 11.9447 15.847C11.9284 15.9216 11.9284 16.0782 11.9447 16.1528C11.9894 16.3572 12.1344 16.5388 12.3287 16.6336C12.4042 16.6704 12.4675 16.688 12.5577 16.6973C12.5999 16.7016 13.0839 16.7039 13.9591 16.7039H15.296V18.0449C15.296 18.9516 15.2982 19.4058 15.3028 19.4472C15.3127 19.5352 15.3302 19.5973 15.3663 19.6712C15.4609 19.8651 15.6431 20.0106 15.847 20.0552C15.9234 20.0719 16.0789 20.0717 16.1536 20.0548C16.3603 20.0081 16.539 19.8653 16.6337 19.6712C16.6705 19.5958 16.6881 19.5324 16.6974 19.4423C16.7017 19.4 16.704 18.916 16.704 18.0408V16.7039H18.0409C18.9161 16.7039 19.4001 16.7016 19.4424 16.6973C19.5325 16.688 19.5959 16.6704 19.6713 16.6336C19.8655 16.5389 20.0083 16.3602 20.0549 16.1535C20.0722 16.0772 20.0722 15.9226 20.0549 15.8463C20.0083 15.6396 19.8655 15.4609 19.6713 15.3662C19.5974 15.3301 19.5353 15.3125 19.4473 15.3027C19.4059 15.2981 18.9517 15.2959 18.0451 15.2959H16.704V13.959C16.704 13.0838 16.7017 12.5998 16.6974 12.5575C16.6881 12.4674 16.6705 12.404 16.6337 12.3286C16.5398 12.136 16.3586 11.9904 16.1568 11.9453C16.1132 11.9355 15.9427 11.9273 15.9104 11.9334ZM8.00293 16.0031C8.00293 16.1404 8.00377 16.1956 8.00481 16.1259C8.00585 16.0561 8.00584 15.9438 8.0048 15.8763C8.00377 15.8087 8.00292 15.8658 8.00293 16.0031Z",
                    fill: "#37B24D"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3394_52716",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(8 8)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserUnBlock);


/***/ }),

/***/ 23889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LinkTag = function(param) {
    var href = param.href, _target = param.target, target = _target === void 0 ? "_self" : _target, children = param.children, style = param.style, onClickNavigateToScreen = param.onClickNavigateToScreen, wrapperStyle = param.wrapperStyle, className = param.className;
    return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        className: className,
        role: "button",
        onClick: onClickNavigateToScreen,
        style: wrapperStyle,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
            target: target,
            style: style,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LinkTag);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1aad4008-0"
})(_templateObject());


/***/ }),

/***/ 28879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73451);


var ReportSelectModal = function(param) {
    var isVisible = param.isVisible, selectList = param.selectList, onClose = param.onClose, _title = param.title, title = _title === void 0 ? "신고하기" : _title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            modalTitle: title,
            selectList: selectList,
            onClose: onClose
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReportSelectModal);


/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ KAKAO_SHARE_TYPE; },
  "C": function() { return /* binding */ SelectModal_ShareSelectModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(72282);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/atom/icon/Kakao.tsx

var KakaoIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "16",
                fill: "#FFE337"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.6719 10C14.7552 10 13.8906 10.1406 13.0781 10.4219C12.2656 10.7031 11.5573 11.0833 10.9531 11.5625C10.349 12.0417 9.86979 12.6042 9.51562 13.25C9.17188 13.8958 9 14.5833 9 15.3125C9 15.7812 9.07292 16.2344 9.21875 16.6719C9.36458 17.099 9.56771 17.5052 9.82812 17.8906C10.099 18.2656 10.4219 18.6146 10.7969 18.9375C11.1719 19.25 11.5833 19.526 12.0312 19.7656L11.5312 22.375L14.4219 20.5312C14.6198 20.5625 14.8229 20.5885 15.0312 20.6094C15.2396 20.6198 15.4531 20.625 15.6719 20.625C16.5885 20.625 17.4531 20.4896 18.2656 20.2188C19.0781 19.9375 19.7865 19.5573 20.3906 19.0781C20.9948 18.5885 21.4688 18.026 21.8125 17.3906C22.1667 16.7448 22.3438 16.0521 22.3438 15.3125C22.3438 14.5833 22.1667 13.8958 21.8125 13.25C21.4688 12.6042 20.9948 12.0417 20.3906 11.5625C19.7865 11.0833 19.0781 10.7031 18.2656 10.4219C17.4531 10.1406 16.5885 10 15.6719 10Z",
                fill: "black"
            })
        ]
    });
};
/* harmony default export */ var Kakao = (KakaoIcon);

// EXTERNAL MODULE: ./src/components/atom/icon/Link.tsx
var Link = __webpack_require__(2721);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/index.tsx
var SelectModal = __webpack_require__(73451);
;// CONCATENATED MODULE: ./src/components/molecules/Modal/SelectModal/ShareSelectModal/index.tsx










var KAKAO_SHARE_TYPE = {
    QNA: "QNA",
    MAGAZINE: "MAGAZINE",
    BOARD_POST: "BOARD_POST",
    NON_BENEFIT_MAP: "NON_BENEFIT_MAP"
};
/**
 * @param isVisible boolean
 * @param onClose () => void
 * @param type KAKAO_SHARE_TYPE
 * @param pageName string
 * @param kakaoShare [optional] KakaoShareProps
 * @param copyLink? CopyLinkProps
 */ var ShareSelectModal = function(param) {
    var isVisible = param.isVisible, onClose = param.onClose, type = param.type, pageName = param.pageName, kakaoShare = param.kakaoShare, copyLink = param.copyLink;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var ref = (0,react.useState)(false), _isVisible = ref[0], _setIsVisible = ref[1];
    var ref1 = (0,react.useState)(), shareItems = ref1[0], setShareItems = ref1[1];
    var eventNamePath = type.toLocaleLowerCase();
    // 공유하기 [카카오]
    var onShareKakao = (0,react.useCallback)(function() {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init("b921b0231b604bf1aea6460c3d26cb57");
        }
        if (kakaoShare) {
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_share_kakao_click"),
                    pageName: pageName,
                    payload: {
                        id: kakaoShare.id
                    }
                }
            });
            var Kakao = window.Kakao;
            if (type === KAKAO_SHARE_TYPE.QNA) {
                Kakao.Share.sendCustom({
                    templateId: 90853,
                    templateArgs: {
                        questionPid: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.MAGAZINE) {
                Kakao.Share.sendCustom({
                    templateId: 90880,
                    templateArgs: {
                        magazinePid: kakaoShare.id,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        titleImageUrl: kakaoShare.imageUrl
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.BOARD_POST) {
                Kakao.Share.sendCustom({
                    templateId: 94245,
                    templateArgs: {
                        id: kakaoShare.id,
                        title: kakaoShare.title,
                        content: kakaoShare.content
                    }
                });
            }
            if (type === KAKAO_SHARE_TYPE.NON_BENEFIT_MAP) {
                Kakao.Share.sendCustom({
                    templateId: 114723,
                    templateArgs: {
                        diagnosisTypeId: kakaoShare.id,
                        treatmentMedicineId: kakaoShare.subId,
                        title: kakaoShare.title,
                        description: kakaoShare.content,
                        thumbnailUrl: kakaoShare.imageUrl
                    }
                });
            }
        }
        onClose();
    }, [
        type,
        kakaoShare,
        eventNamePath,
        pageName,
        onClose
    ]);
    // 공유하기 [링크복사]
    var onCopyLink = (0,react.useCallback)(function() {
        if (copyLink) {
            var ref;
            (0,logger/* mobileLogger */.Pp)({
                logger: {
                    eventName: "".concat(eventNamePath, "_copy_link_click"),
                    pageName: pageName,
                    payload: {
                        id: copyLink === null || copyLink === void 0 ? void 0 : copyLink.id
                    }
                }
            });
            (ref = document.getElementById(copyLink === null || copyLink === void 0 ? void 0 : copyLink.copyElementId)) === null || ref === void 0 ? void 0 : ref.click();
        }
        onClose();
    }, [
        copyLink,
        eventNamePath,
        pageName,
        onClose
    ]);
    var onCompleteCopy = function() {
        toast({
            text: "클립보드로 복사되었습니다.",
            direction: "bottom"
        });
    };
    var generateSelectList = (0,react.useCallback)(function() {
        var selectItems = [];
        if (copyLink) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            hasWrapper: true
                        });
                    },
                    text: "링크 복사",
                    onClick: onCopyLink
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        if (kakaoShare) {
            selectItems = [
                {
                    Icon: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Kakao, {});
                    },
                    text: "카카오톡으로 공유",
                    onClick: onShareKakao
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(selectItems));
        }
        setShareItems(selectItems);
    }, [
        copyLink,
        onShareKakao,
        onCopyLink,
        kakaoShare,
        setShareItems
    ]);
    (0,react.useEffect)(function() {
        generateSelectList();
    }, [
        generateSelectList
    ]);
    (0,react.useEffect)(function() {
        _setIsVisible(isVisible);
    }, [
        isVisible
    ]);
    // https://sharer.kakao.com/picker/link?app_key=b921b0231b604bf1aea6460c3d26cb57&short_key=7007dc80-2f45-494f-a8fc-3ad2b18dd522
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    defer: true,
                    src: "https://developers.kakao.com/sdk/js/kakao.min.js"
                })
            }),
            _isVisible && !!shareItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectModal/* default */.Z, {
                modalTitle: "공유하기",
                selectList: shareItems,
                onClose: onClose
            }),
            !!copyLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                text: copyLink.copyLinkUrl,
                onCopy: onCompleteCopy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    id: copyLink.copyElementId
                })
            })
        ]
    });
};
/* harmony default export */ var SelectModal_ShareSelectModal = (ShareSelectModal);


/***/ }),

/***/ 73451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_buttons_DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);
/* harmony import */ var _Overlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78952);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  bottom: 32px;\n  padding: 24px 0 16px;\n  position: absolute;\n  width: calc(100% - 32px);\n  max-width: 736px;\n  border-radius: 20px;\n  animation: ",
        " 0.3s;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  padding: 0 24px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  justify-content: flex-start;\n  padding: 12px 24px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




/**
 *
 * @param modalTitle string
 * @param selectList Array<SelectModalListItem>
 * @param onClose () => void
 */ var SelectModal = function(param) {
    var modalTitle = param.modalTitle, selectList = param.selectList, onClose = param.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Overlay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        index: 10,
        onClickOverlay: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                    children: modalTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectedItemWrapper, {
                    children: selectList.map(function(param, key) {
                        var Icon = param.Icon, text = param.text, onClick = param.onClick;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SelectItem, {
                            onClick: onClick,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Icon, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SelectItemText, {
                                    children: text
                                })
                            ]
                        }, "selectModal_".concat(key));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectModal);
var BottomUp = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .keyframes */ .F4)(_templateObject());
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd7f6fd7-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n  background: ".concat(theme.color.white, ";\n");
}, BottomUp);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd7f6fd7-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n  ".concat(theme.typography.UI20SB, ";\n");
});
var SelectedItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-dd7f6fd7-2"
})(_templateObject3());
var SelectItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_atom_buttons_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-dd7f6fd7-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    &:active {\n      opacity: 1;\n      background-color: ".concat(theme.color.gray50, ";\n    }\n  ");
});
var SelectItemText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-dd7f6fd7-4"
})(_templateObject5());


/***/ }),

/***/ 53214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60288);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  border-radius: 50%;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 50%;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  z-index: 1;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  background-color: white;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var NurseProfile = function(param) {
    var url = param.url, size = param.size;
    var resizingImgUrl = (0,_utils_image__WEBPACK_IMPORTED_MODULE_2__/* .resizingImg */ .Kp)({
        originUrl: url,
        width: size * 3,
        height: size * 3,
        quality: 100
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        size: size,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NurseImage, {
                url: resizingImgUrl,
                size: size
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundImage, {
                size: size
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NurseProfile);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4426003f-0"
})(_templateObject(), function(param) {
    var theme = param.theme, size = param.size;
    return "\n    border: 1px solid ".concat(theme.color.gray200, ";\n    width: ").concat(size, "px;\n    height: ").concat(size, "px;\n  ");
});
var NurseImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4426003f-1"
})(_templateObject1(), function(param) {
    var url = param.url, size = param.size;
    return "\n    background-image: url(".concat(url, ");\n    width: ").concat(size - 1, "px;\n    height: ").concat(size - 1, "px;\n");
});
var BackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-4426003f-2"
})(_templateObject2(), function(param) {
    var size = param.size;
    return "\n    width: ".concat(size - 1, "px;\n    height: ").concat(size - 1, "px;\n  ");
});


/***/ }),

/***/ 9107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ BreadCrumbsWrapper; },
  "Z": function() { return /* binding */ Faq_FaqTagListTemplate; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 3 modules
var StickyAppHeader = __webpack_require__(73487);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Magazine/MagazineMobileTemplate/MagazineSkeleton/index.tsx
var MagazineSkeleton = __webpack_require__(96871);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/hooks/magazine/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(44355);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/hooks/faq/useGetFaqTagListPage.ts





var parseMagazineTagList = function(data) {
    var parseMagazineListItem = function(magazine) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine), {
            magazinePid: magazine.magazinePid,
            date: "".concat(dayjs_min_default()(magazine.createdAt).format("YYYY.MM.DD"))
        });
    };
    if (data) {
        return data.tagMagazineCursorPage.elements.map(function(magazine) {
            return parseMagazineListItem(magazine);
        });
    }
    return [];
};
var useGetFaqTagListPage = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20, tagName = arguments.length > 1 ? arguments[1] : void 0;
    var ref = (0,magazine_gql_impl/* useGetMagazineTagListPageQuery */.wJ)({
        request: {
            size: size,
            tagName: tagName,
            contentType: magazine/* MagazineType.FAQ */.rL.FAQ
        }
    }, {
        select: function(data) {
            return parseMagazineTagList(data);
        }
    }), faqs = ref.data, faqsLoading = ref.isLoading;
    return {
        faqs: faqs !== null && faqs !== void 0 ? faqs : [],
        faqsLoading: faqsLoading
    };
};
/* harmony default export */ var faq_useGetFaqTagListPage = (useGetFaqTagListPage);

// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/hooks/faq/useFaqTagViewModel.ts



var useFaqTagViewModel = function(tag) {
    var ref = faq_useGetFaqTagListPage(20, tag), faqs = ref.faqs, faqsLoading = ref.faqsLoading;
    var moveToPage = (0,useCustomRouter/* default */.Z)().moveToPage;
    var onClickMove = function(faqPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faqPid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: faqPid
            }
        });
    };
    return {
        faqs: faqs,
        faqsLoading: faqsLoading,
        onClickMove: onClickMove
    };
};
/* harmony default export */ var faq_useFaqTagViewModel = (useFaqTagViewModel);

// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(64952);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
;// CONCATENATED MODULE: ./src/components/templates/communication/Faq/FaqTagListTemplate/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-bottom: 16px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  max-width: 1152px;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 8px 24px;\n  color: ",
        ";\n  ",
        ";\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var FaqTagListTemplate = function(param) {
    var tag = param.tag, client = param.client;
    var viewModel = faq_useFaqTagViewModel(tag);
    if (viewModel.faqsLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSkeleton/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                    title: "1분 FAQ"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            path: "".concat(common/* ROUTES.FAQ.TAG.path */.Z6.FAQ.TAG.path),
                            type: "magazine"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTile, {
                                children: "#".concat(tag)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: viewModel.faqs.map(function(faq) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                        href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faq.magazinePid),
                                        onClickNavigateToScreen: function() {
                                            return viewModel.onClickMove(faq.magazinePid);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                            magazine: {
                                                title: faq.title,
                                                mobileTitle: faq.mobileTitle,
                                                image: "",
                                                date: faq.date,
                                                magazinePid: faq.magazinePid,
                                                description: faq.description,
                                                mobileDescription: faq.mobileDescription,
                                                siteName: ""
                                            }
                                        })
                                    }, faq.magazinePid);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Faq_FaqTagListTemplate = (FaqTagListTemplate);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5c61070-0"
})(_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var BreadCrumbsWrapper = (0,styled_components_browser_esm/* default */.ZP)(BreadCrumbs/* default.Wrapper */.Z.Wrapper).withConfig({
    componentId: "sc-a5c61070-1"
})(_templateObject1(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
});
var Content = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-a5c61070-2"
})(_templateObject2());
var PageTile = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-a5c61070-3"
})(_templateObject3(), theme/* default.color.gray700 */.Z.color.gray700, theme/* default.typography.UI28SB */.Z.typography.UI28SB, layout/* Tablet */.YD, theme/* default.typography.UI22SB */.Z.typography.UI22SB);


/***/ }),

/***/ 96871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13971);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 96px);\n  margin-right: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MagazineItemSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Left, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 60,
                                    height: 18,
                                    marginRight: 8
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                style: {
                                    width: 66,
                                    height: 18
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 48,
                            marginTop: 8,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            height: 18,
                            marginBottom: 2
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: "70%",
                            height: 18
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Right, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 72,
                            marginBottom: 4
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        style: {
                            width: 96,
                            height: 28
                        }
                    })
                ]
            })
        ]
    });
};
var MagazineSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: Array.from({
            length: 8
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MagazineItemSkeleton, {}, "skeleton_".concat(i));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MagazineSkeleton);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-0"
})(_templateObject());
var Left = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-1"
})(_templateObject1());
var Row = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-2"
})(_templateObject2());
var Right = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fdc826d3-3"
})(_templateObject3());


/***/ }),

/***/ 22260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89961);
/* harmony import */ var _assets_lottie_loading_dot_ongoing_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65196);
/* harmony import */ var _assets_lottie_loading_dot_wait_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28989);
/* harmony import */ var _components_atom_CustomLottieIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84655);
/* harmony import */ var _components_molecules_NurseProfile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53214);
/* harmony import */ var _components_molecules_QuestionList_QuestionItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38427);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44376);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72271);
/* harmony import */ var _types_search__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50728);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    & > div {\n      border-bottom: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  ",
        ";\n\n  &:div {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  div {\n    border: 2px solid white;\n    border-radius: 50%;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var RelatedQuestionItem = function(param) {
    var _titleAsH2 = param.titleAsH2, titleAsH2 = _titleAsH2 === void 0 ? true : _titleAsH2, questionCard = param.questionCard, onClickRelatedQna = param.onClickRelatedQna, isLast = param.isLast;
    var questionPid = questionCard.question.questionPid;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        isLast: isLast,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_QuestionList_QuestionItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            titleAsH2: titleAsH2,
            isPaidQuestion: false,
            questionCard: questionCard,
            onClickQuestion: function() {
                return onClickRelatedQna(questionPid);
            },
            isLast: isLast,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_QuestionList_QuestionItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"].BottomLeft */ .Z.BottomLeft, {
                children: questionCard.answeredStatus === _types_search__WEBPACK_IMPORTED_MODULE_10__/* .EQuestionAnsweredStatus.Answered */ .qv.Answered ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(QuestionBottomAnswerStatus, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionDoctorImageWrapper, {
                            children: questionCard.answererProfileImageUrls.slice(0, 5).map(function(image, key) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionDoctorImage, {
                                    imageKey: key,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_NurseProfile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        url: image,
                                        size: 28
                                    })
                                }, "answered-doctor-".concat(key));
                            })
                        }),
                        questionCard.answererCount,
                        "개의 답변"
                    ]
                }) : questionCard.question.status !== _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_9__/* .QuestionStatus.AwaitingBasicAnswer */ .xVd.AwaitingBasicAnswer ? // 답변 중 / 답변 확인 중
                // 목록
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(QuestionBottomAnswerStatus, {
                    fontColor: questionCard.answeredStatus === _types_search__WEBPACK_IMPORTED_MODULE_10__/* .EQuestionAnsweredStatus.Answering */ .qv.Answering ? _styles_theme__WEBPACK_IMPORTED_MODULE_8__/* ["default"].color.primary500 */ .Z.color.primary500 : _styles_theme__WEBPACK_IMPORTED_MODULE_8__/* ["default"].color.blue500 */ .Z.color.blue500,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_CustomLottieIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            width: 24,
                            height: 24,
                            animationData: questionCard.answeredStatus === _types_search__WEBPACK_IMPORTED_MODULE_10__/* .EQuestionAnsweredStatus.Answering */ .qv.Answering ? _assets_lottie_loading_dot_ongoing_json__WEBPACK_IMPORTED_MODULE_3__ : _assets_lottie_loading_dot_wait_json__WEBPACK_IMPORTED_MODULE_4__,
                            style: {
                                marginRight: 8
                            }
                        }),
                        questionCard.answeredStatusText
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})
            })
        }, questionPid)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RelatedQuestionItem);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-29b71480-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n  &: hover {\n    background: ".concat(theme.color.gray30, ";\n  };\n  &: active {\n    background: ").concat(theme.color.gray50, ";\n  };\n  ");
}, function(param) {
    var theme = param.theme, isLast = param.isLast;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv)(_templateObject(), isLast ? "none" : "1px solid ".concat(theme.color.gray40));
});
var QuestionBottomAnswerStatus = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29b71480-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, fontColor = param.fontColor;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(fontColor !== null && fontColor !== void 0 ? fontColor : theme.color.gray700, ";\n  ");
});
var QuestionDoctorImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29b71480-2"
})(_templateObject3());
var QuestionDoctorImage = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-29b71480-3"
})(_templateObject4(), function(param) {
    var imageKey = param.imageKey;
    return "\n    margin-left: -".concat(imageKey ? 8 : 0, "px;\n    z-index: ").concat(5 - imageKey, ";\n  ");
});


/***/ }),

/***/ 13805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ DOCTOR_NOW_COMPANY_LATITUDE; },
/* harmony export */   "y": function() { return /* binding */ DOCTOR_NOW_COMPANY_LONGITUDE; }
/* harmony export */ });
var DOCTOR_NOW_COMPANY_LATITUDE = 37.4995535963247;
var DOCTOR_NOW_COMPANY_LONGITUDE = 127.025752388871;


/***/ }),

/***/ 53199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ui_MedicineInfoBottomSheet; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/molecules/Overlay/index.tsx + 1 modules
var Overlay = __webpack_require__(78952);
;// CONCATENATED MODULE: ./src/constants/pharmacy/index.ts
var finasterides = [
    "프로스카정",
    "프로페시아정",
    "피나스타정",
    "알파스카정",
    "프로피나정",
    "프로스몰정",
    "피나이스정",
    "한올피나스테리드정",
    "스카렉스정",
    "피나로신정",
    "피나드론정",
    "스카테론정",
    "유로리드정",
    "프로엠정",
    "대웅바이오피나스테리드정",
    "핀카정",
    "유로피나정",
    "피나베린정",
    "피로이드정",
    "푸로스타정",
    "프로리드정",
    "피나스텔정",
    "피나스티드정",
    "파나스카정",
    "리드페시아정",
    "트로피나정",
    "파나드정",
    "보령피나스테리드정",
    "일양피나스테리드정",
    "유로스칸정",
    "피스테리정",
    "푸로케어정",
    "피나테드정",
    "파세드정",
    "한림피나스테리드정",
    "알로시아정",
    "피나스틴정",
    "모나스타정",
    "알로페시드정",
    "헤어페시아정",
    "헤어피나정",
    "피나모린정",
    "레나시딘정",
    "바로피나정",
    "발트만정",
    "미노페시아정",
    "네오페시아정",
    "마이시아정",
    "다모케어정",
    "메디페시아정",
    "알로게인정",
    "그로모정",
    "모나리드정",
    "모나스틴정",
    "두피나정",
    "피나페시아정",
    "케이시아정",
    "피나시딜정",
    "모나드정",
    "헤나모정",
    "페로시아정",
    "헤어게인정",
    "다모페시아정",
    "헤어스모정",
    "알로펙정",
    "알로스칸정",
    "뉴피나정",
    "마이페시아정",
    "하이페시아정",
    "베아리모정",
    "프로시정",
    "마인페시아정",
    "헤어그로정",
    "유나피아정",
    "유나시아정",
    "모나필정",
    "피나젠정",
    "프리스타정",
    "피나트라정",
    "핀스타정",
    "피나라이드정",
    "화이자피나스테리드정",
    "피나세틴정",
    "필라스트정",
    "나우스카정",
    "프리피나정",
    "파나리드정",
    "프로스테리드정",
    "피나시아정",
    "피나그렌정",
    "피나린정",
    "프로스타트정",
    "마이피나정",
    "메리나정",
    "피나프로스정",
    "피나텐정",
    "피나스토정",
    "에피나시정",
    "씨엠피나정",
    "씨엠프로정",
    "피나스칸정",
    "피나드정",
    "피나정",
    "모나정",
    "모더페시아정",
    "비피케어정",
    "피나스로정",
    "티나제정",
    "프로스틸정",
    "모페시아정",
    "베르모나정",
    "엔피스카정",
    "피나스테아정",
    "피나진정",
    "피테스정",
    "피나롤정",
    "프로나드정",
    "하이피나정",
    "유레이드정",
    "피나에이블정",
    "비보존피나스테리드정",
    "피나즈정",
    "알로피나정",
    "피나론정",
    "모나페시아정",
    "스텐카정",
    "이노엔피나스테리드정",
    "삼성피나스테리드정",
    "피나스트리온정",
    "모나시아정",
    "큐로이드정",
    "프로화정",
    "모리턴정",
    "신신피나스테리드정",
    "피나스정",
    "피나윈정",
    "리모날정",
    "엔피나정",
    "다림피나스테리드정",
    "모어에이블정",
    "피나스톤정",
    "피나테크정",
    "피나스테린정",
    "피나세타정",
    "유니테리드정",
    "모그로정",
    "프로모아정",
    "피노테정",
    "알파엠정",
    "포뮬레시아정",
    "제이페시아정",
    "제이피나정",
    "모모페시아정",
    "피나리정",
    "피나디드정",
    "에이페시아정",
    "피나프로정",
    "뉴리드정",
    "위피나정",
    "멕스페시아정",
    "피나온정",
    "피나세트정",
    "테라피나스정",
    "명문피나스테리드정",
    "뉴페시아정",
    "피나에스정",
    "피나모아정",
    "프로핀카정",
    "한국팜비오피나스테리드정",
    "피나스트정",
    "아스테리정",
    "헤오나정",
    "피나앤정",
    "휴피나정",
    "피나신정",
    "텔콘알에프피나스테리드정",
    "스테리정",
    "프로아모정",
    "다모테리드정",
    "비피스타정",
    "메가페시아정",
    "엔티테리드정",
    "피나스텐정",
    "소피나정",
    "피나시드정",
    "안국피나스테리드정",
    "뉴모나스테리드정",
    "모벤시아정",
    "모모드정",
    "피나엠정",
    "다나페시아정",
    "모시아모정",
    "알로테드정",
    "와이투피나정",
    "그로페시아정",
    "피나모정",
    "제노페시아정",
    "오뉴페시아정",
    "원페시아정", 
];
var liraglutides = [
    "빅토자펜주",
    "삭센다펜주",
    "줄토피플렉스터치주"
];
var isotretinoins = [
    "아키놀연질캡슐",
    "니메겐연질캡슐",
    "핀플연질캡슐",
    "이소틴연질캡슐",
    "뉴티논연질캡슐",
    "이소티나연질캡슐",
    "이소트렌연질캡슐",
    "아크날연질캡슐",
    "트레틴연질캡슐",
    "아큐네탄연질캡슐",
    "이소티논연질캡슐",
    "이소트레틴겔",
    "레씨범연질캡슐",
    "트레인연질캡슐",
    "제로큐탄연질캡슐",
    "로아큐탄캡슐",
    "트레논연질캡슐",
    "로이탄연질캡슐",
    "오피큐탄연질캡슐",
    "아크논연질캡슐",
    "이소탐연질캡슐",
    "우리큐탄연질캡슐",
    "클레어연질캡슐",
    "삼성이소트레티노인연질캡슐",
    "이소팩트연질캡슐",
    "로아크연질캡슐",
    "화이트이소트레티노인연질캡슐",
    "로큐탄연질캡슐",
    "레아큐연질캡슐",
    "안국이소트레티노인연질캡슐",
    "모아큐탄연질캡슐", 
];
var clindamycins = [
    "듀케이겔",
    "에피외용액",
    "아클리신액",
    "아크닌액",
    "다크린외용액",
    "크리신외용액",
    "듀오크린액",
    "아크프리외용액",
    "크레오신티외용액1％",
    "퓨어킨외용액",
    "아크네신액",
    "클린티외용액",
    "에이치피앤씨클린다마이신포스페이트외용액1%",
    "클린다-케이외용액",
    "클린디올액",
    "끌로이외용액",
    "클린다미액",
    "피에이큐라덤외용액",
    "동인에피겔",
    "진다클린겔",
    "큐티안겔",
    "클린디올겔",
    "크레오신질크림2%",
    "듀악겔",
    "듀악겔5%",
    "듀악겔3%",
    "클리스코주",
    "크레오신주",
    "클리마이신주",
    "훌그램주사", 
];
var dutasterides = [
    "아보다트연질캡슐",
    "유힐릭스연질캡슐",
    "두타반연질캡슐",
    "두타론연질캡슐",
    "두테스몰연질캡슐",
    "아보스타연질캡슐",
    "아보테리드연질캡슐",
    "아나딘연질캡슐",
    "네오다트연질캡슐",
    "두테드연질캡슐",
    "씨엠두타연질캡슐",
    "두타리드연질캡슐",
    "아보피나연질캡슐",
    "두타텍트연질캡슐",
    "두아보연질캡슐",
    "아보스티드연질캡슐",
    "두타라이드연질캡슐",
    "두타스카연질캡슐",
    "아두타연질캡슐",
    "아보테드연질캡슐",
    "두타렉스연질캡슐",
    "원투스테리드연질캡슐",
    "두로칸연질캡슐",
    "두타젠연질캡슐",
    "아보두타연질캡슐",
    "다모다트연질캡슐",
    "아보타스연질캡슐",
    "아보탄연질캡슐",
    "두타드연질캡슐",
    "휴메리나연질캡슐",
    "두타겟연질캡슐",
    "두테론연질캡슐",
    "대웅바이오두타스테리드연질캡슐",
    "삼천당두타스테리드연질캡슐",
    "자이가드연질캡슐",
    "프로다트연질캡슐",
    "두타락연질캡슐",
    "안국두타스테리드연질캡슐",
    "유로다트연질캡슐",
    "타테린연질캡슐",
    "아다모연질캡슐",
    "두타케어정",
    "제이다트정",
    "두타반플러스정",
    "네오다트정",
    "엔피다트정",
    "두로케어정",
    "두아모정",
    "아보그로정",
    "두테스정",
    "대웅바이오두타스테리드정",
    "원투스테리드정",
    "두타론정",
    "다모다트정",
    "두타리드정",
    "두타브정",
    "아보타스정",
    "아보투윈연질캡슐",
    "에이두타정",
    "듀타그렌정",
    "두타스테린정",
    "아이두타연질캡슐",
    "두타온연질캡슐",
    "중헌두타스테리드연질캡슐",
    "두타그로연질캡슐",
    "아보다칸정",
    "두테론정",
    "모모타정",
    "두타윈연질캡슐",
    "두타스텐정",
    "두타모아정",
    "두타스타정",
    "보령두타스테리드연질캡슐",
    "팜젠두타스테리드연질캡슐",
    "아리드정",
    "두타엘정",
    "아다모정",
    "아보테드정",
    "두타린정",
    "삼성두타스테리드정",
    "아보리드정",
    "두리드정",
    "두타베린정",
    "두다트정",
    "케이두타다트정",
    "일성두타스테리드정",
    "두타겟정",
    "메가두타연질캡슐",
    "두타프렌정",
    "두보트정",
    "두타엠연질캡슐",
    "삼천당두타스테리드정",
    "두타시드정",
    "두타엠정",
    "두로칸정",
    "머카나정",
    "휴메리나정",
    "안국두타연질캡슐",
    "두모보연질캡슐",
    "아보텍트정",
    "두타모정",
    "모모다트정",
    "휴다트연질캡슐",
    "두리스연질캡슐",
    "동구두타리드연질캡슐",
    "아보엠연질캡슐",
    "모벤두타정",
    "에이두타연질캡슐", 
];
var semaglutides = [
    "위고비프리필드펜",
    "오젬픽프리필드펜",
    "리벨서스정"
];
var trifarotenes = [
    "아크리프"
];
var tirzepatides = [
    "마운자로프리필드펜"
];
//should change to use medicine code like app
var PHARMACY_MEDICINE_NAMES_MAP = {
    "1": {
        medicineList: finasterides,
        name: "피나스테리드"
    },
    "2": {
        medicineList: liraglutides,
        name: "리라글루티드"
    },
    "3": {
        medicineList: isotretinoins,
        name: "이소트레티노인"
    },
    "4": {
        medicineList: clindamycins,
        name: "클린다마이신"
    },
    "17": {
        medicineList: dutasterides,
        name: "두타스테리드"
    },
    "18": {
        medicineList: semaglutides,
        name: "세마글루티드"
    },
    "63": {
        medicineList: trifarotenes,
        name: "트리파로텐"
    },
    "64": {
        medicineList: tirzepatides,
        name: "터제파타이드"
    }
};

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-find/ui/MedicineInfoBottomSheet.tsx







var MedicineInfoBottomSheet = function(param) {
    var treatmentMedicineIds = param.treatmentMedicineIds, onClickClose = param.onClickClose;
    var ref = (0,react.useState)({}), hasOverflow = ref[0], setHasOverflow = ref[1];
    var ref1 = (0,react.useState)({}), expandedItems = ref1[0], setExpandedItems = ref1[1];
    var textRefs = (0,react.useRef)([]);
    // 선택된 약 그룹 정보 (없으면 빈 배열)
    var selectedMedicineGroup = treatmentMedicineIds.length > 1 && PHARMACY_MEDICINE_NAMES_MAP ? treatmentMedicineIds.map(function(id) {
        return PHARMACY_MEDICINE_NAMES_MAP[id];
    }).filter(Boolean) : [];
    // 더보기 핸들러
    var expandItem = function(index) {
        setExpandedItems(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, index, true));
        });
    };
    // 텍스트 오버플로우 감지
    (0,react.useEffect)(function() {
        if (selectedMedicineGroup.length === 0) return;
        // 요소가 렌더링된 후에 실행
        var checkOverflow = function() {
            var newHasOverflow = {};
            textRefs.current.forEach(function(ref, index) {
                if (ref) {
                    // scrollHeight > clientHeight 또는 scrollWidth > clientWidth일 경우 오버플로우 발생
                    var isOverflowing = ref.scrollHeight > ref.clientHeight || ref.scrollWidth > ref.clientWidth;
                    newHasOverflow[index] = isOverflowing;
                }
            });
            setHasOverflow(newHasOverflow);
        };
        checkOverflow();
        // 윈도우 리사이즈 시 오버플로우 상태 재확인
        window.addEventListener("resize", checkOverflow);
        return function() {
            window.removeEventListener("resize", checkOverflow);
        };
    }, [
        selectedMedicineGroup
    ]);
    var getDisplayedMedicineList = function(list) {
        if (!list || !list.length) return "";
        return list.join(", ");
    };
    // 약품 목록이 비어있는지 확인
    var isMedicineGroupEmpty = selectedMedicineGroup.length === 0;
    // 내용물 렌더링
    var renderContent = function() {
        // 목록이 비어있는 경우
        if (isMedicineGroupEmpty) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col space-y-8 pb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-2 px-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-start gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-[7px] h-1 w-1 rounded-full bg-gray-400"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "typography-ui-13m text-gray-500",
                                children: "선택된 약품이 없습니다."
                            })
                        ]
                    })
                })
            });
        }
        // 기본 약품 목록 표시
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col px-[4px] pb-6",
            children: [
                selectedMedicineGroup.map(function(medicine, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "typography-ui-15sb text-gray-900",
                                        children: medicine.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                ref: function(el) {
                                                    textRefs.current[index] = el;
                                                },
                                                className: "typography-ui-13r ".concat(!expandedItems[index] ? "line-clamp-1" : "", " flex-1 text-gray-600"),
                                                children: getDisplayedMedicineList(medicine.medicineList)
                                            }),
                                            hasOverflow[index] && !expandedItems[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    return expandItem(index);
                                                },
                                                className: "typography-ui-13r !underline cursor-pointer whitespace-nowrap border-0 bg-transparent text-gray-600 underline-offset-2",
                                                children: "더보기"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            index < selectedMedicineGroup.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-4 h-[1px] w-full bg-gray-40"
                            })
                        ]
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4 mb-8 flex flex-col gap-2 px-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-[7px] h-[4px] min-w-[4px] rounded-full bg-gray-200"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "typography-ui-13m text-gray-400",
                                    children: "성분 선택은 진료 및 상담 과정에서 의사소통을 원활하게 하기 위한 목적으로 활용됩니다."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row items-start gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-[7px] h-[4px] min-w-[4px] rounded-full bg-gray-200"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "typography-ui-13m text-gray-400",
                                    children: "약품명은 각 성분에 대한 이해를 돕기 위한 표기이며, 약품은 의사의 전문적 판단에 따라 처방됩니다."
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    // 오버레이 클릭 핸들러
    var handleOverlayClick = function() {
        onClickClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
        onClickOverlay: handleOverlayClick,
        className: "!items-end",
        index: 500,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative max-h-[80vh] w-full max-w-full animate-slideUp overflow-y-scroll rounded-t-[24px] bg-white px-[20px] pt-[24px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-4 flex flex-row items-center justify-between px-[4px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "typography-ui-20sb text-gray-800",
                        children: "성분 안내"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-h-[480px] overflow-y-scroll",
                    children: renderContent()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onClickClose,
                    className: "typography-ui-17sb mb-4 flex w-full items-center justify-center rounded-xl bg-primary-500 py-[15px] text-white hover:bg-primary-600",
                    children: "확인"
                })
            ]
        })
    });
};
/* harmony default export */ var ui_MedicineInfoBottomSheet = (MedicineInfoBottomSheet);


/***/ }),

/***/ 23490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PharmacyMapHeaderTabs_PharmacyMapHeaderTabs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSlideTab/index.tsx
var DNSlideTab = __webpack_require__(67788);
// EXTERNAL MODULE: ./src/designComponents/organisms/DNSlideTab/DNSlideTabItem/index.tsx
var DNSlideTabItem = __webpack_require__(57823);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/Skeleton/index.tsx + 1 modules
var Skeleton = __webpack_require__(13971);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-find/ui/EmptyTabsSkeleton.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 46px;\n  padding: 12px 0;\n  padding-left: 24px;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var EmptyTabsSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    width: 50,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    width: 50,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    width: 80,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    width: 70,
                    height: 22
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                style: {
                    width: 80,
                    height: 22
                }
            })
        ]
    });
};
/* harmony default export */ var ui_EmptyTabsSkeleton = (EmptyTabsSkeleton);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a130b21-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.color.gray100, ";\n  ");
});

;// CONCATENATED MODULE: ./src/features/pharmacies/shared/ui/PharmacyMapHeaderTabs/PharmacyMapHeaderTabs.tsx




var PharmacyMapHeaderTabs = function(param) {
    var tabs = param.tabs, selectedTab = param.selectedTab, onClickTab = param.onClickTab;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: tabs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DNSlideTab/* default */.Z, {
            value: selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.name,
            className: "z-[2] bg-white",
            children: tabs.map(function(tab) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(DNSlideTabItem/* default */.Z, {
                    label: tab.name,
                    isActive: (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.id) === tab.id,
                    onClick: function() {
                        onClickTab(tab);
                    }
                }, tab.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_EmptyTabsSkeleton, {})
    });
};
/* harmony default export */ var PharmacyMapHeaderTabs_PharmacyMapHeaderTabs = (PharmacyMapHeaderTabs);


/***/ }),

/***/ 38245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ useSearchKoreaAddressV2Query; },
/* harmony export */   "Yx": function() { return /* binding */ useDoctorReviewMetricQuery; },
/* harmony export */   "dr": function() { return /* binding */ useGetHospitalByIdQuery; },
/* harmony export */   "hh": function() { return /* binding */ useGetAddressByLocationQuery; },
/* harmony export */   "nR": function() { return /* binding */ useGetTotalReviewCountWithAverageRatingByPublicIdQuery; },
/* harmony export */   "xK": function() { return /* binding */ useGetUserAddressesQuery; }
/* harmony export */ });
/* unused harmony exports GetHospitalByIdDocument, DoctorReviewMetricDocument, GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery, GetTotalReviewCountWithAverageRatingByPublicIdDocument, GetAddressByLocationDocument, GetUserAddressesDocument, SearchKoreaAddressV2Document, HospitalExternalPostDocument, useHospitalExternalPostQuery */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var GetHospitalByIdDocument = "\n    query GetHospitalById($publicId: String!) {\n  getHospitalByPublicId(publicId: $publicId) {\n    id\n    name\n    isBookable\n    isTodayBookable\n    partnershipTemplate\n    profileImages {\n      url\n      isRepresentative\n    }\n    badges\n    naverPlaceDetail {\n      hashtags\n      treatmentMenus {\n        treatmentName\n        price\n      }\n    }\n    temporaryHolidaysNotice\n    temporaryHolidays\n    todayDuty {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n      operatingStatus\n    }\n    duties {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n    }\n    departmentsV2 {\n      departmentId\n      departmentName\n    }\n    departmentGroups {\n      averageRating\n      departmentGroupId\n      departmentGroupName\n      departmentGroupIconUrl\n      tags\n    }\n    nonBenefitDiagnosisPrices {\n      middleCategoryName\n      minPrice\n      maxPrice\n    }\n    longitude\n    latitude\n    jibunAddress\n    roadAddress\n    detailAddress\n    directionGuidance\n    parkingInformation\n    isFreeParking\n    tel\n    viewCount\n    introduction\n    regionByDepth {\n      siDoName\n      siGunGuName\n      eupMyeonDongName\n    }\n    treatments {\n      id\n      name\n    }\n    hospitalAdBanners {\n      displayDiscount\n      displayPrice\n      id\n      thumbnailImageUrl\n      title\n      url\n      hospitalId\n    }\n    hospitalSurgeries {\n      surgeryCount\n      surgeryName\n      badges\n      id\n    }\n    doctors {\n      id\n      publicId\n      hospitalId\n      isAbsent\n      name\n      displayName\n      medicineType\n      gender\n      profileImagePath\n      contractType\n      departmentGroups {\n        departmentGroupId\n        departmentGroupName\n        departmentGroupIconUrl\n        averageRating\n      }\n      professionalDepartmentsV2 {\n        departmentId\n        departmentName\n        departmentCode\n      }\n      careers {\n        careerType\n        content\n        id\n      }\n      reviewMetric {\n        averageRating\n        totalCount\n        groupByDiagnosisType {\n          count\n          diagnosisType\n          diagnosisTypeId\n          name\n        }\n        groupByRating {\n          count\n          rating\n        }\n      }\n      partnershipStatus\n    }\n    topRatedDoctorReviews(size: 3) {\n      content\n      createdAt\n      id\n      isPrivate\n      likeCount\n      maskedHolderName\n      rating\n      targetCategoryName\n      title\n      isBlocked\n      isLiked\n      comments {\n        content\n        createdAt\n        id\n        isBlocked\n        reviewCommentHolder {\n          id\n          name\n          profileImageUrl\n        }\n      }\n      reviewContext {\n        reviewReceiver {\n          id\n          name\n        }\n      }\n      tags {\n        id\n        reviewId\n        tag {\n          tagId\n          text\n        }\n        tagId\n      }\n    }\n  }\n}\n    ";
var useGetHospitalByIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetHospitalById",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables), options);
};
useGetHospitalByIdQuery.getKey = function(variables) {
    return [
        "GetHospitalById",
        variables
    ];
};
useGetHospitalByIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables, options);
};
var DoctorReviewMetricDocument = "\n    query DoctorReviewMetric($doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input!) {\n  doctorReviewMetric(doctorReviewSearchRequest: $doctorReviewSearchRequest) {\n    totalCount\n    averageRating\n    groupByRating {\n      count\n      rating\n    }\n    groupByDiagnosisType {\n      diagnosisType\n      diagnosisTypeId\n      name\n      count\n    }\n  }\n}\n    ";
var useDoctorReviewMetricQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "DoctorReviewMetric",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables), options);
};
useDoctorReviewMetricQuery.getKey = function(variables) {
    return [
        "DoctorReviewMetric",
        variables
    ];
};
useDoctorReviewMetricQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables, options);
};
var GetFaceToFaceDiagnosisBookingFormByPublicIdDocument = "\n    query GetFaceToFaceDiagnosisBookingFormByPublicId($publicId: String!) {\n  getFaceToFaceDiagnosisBookingFormByPublicId(publicId: $publicId) {\n    hospital {\n      name\n    }\n    doctor {\n      name\n      medicineType\n    }\n    booking {\n      status\n    }\n    diagnosis {\n      status\n    }\n    bookingId\n    targetDate\n    targetDateDisplayText\n    detailSymptom\n    name\n    registrationNumber\n    address\n    detailAddress\n  }\n}\n    ";
var useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables), options);
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.getKey = function(variables) {
    return [
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ];
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables, options);
};
var GetTotalReviewCountWithAverageRatingByPublicIdDocument = "\n    query GetTotalReviewCountWithAverageRatingByPublicId($publicId: String!) {\n  getTotalReviewCountWithAverageRatingByPublicId(publicId: $publicId) {\n    averageRating\n    totalCount\n  }\n}\n    ";
var useGetTotalReviewCountWithAverageRatingByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables), options);
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey = function(variables) {
    return [
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ];
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables, options);
};
var GetAddressByLocationDocument = "\n    query GetAddressByLocation($longitude: Float!, $latitude: Float!) {\n  getAddressByLocation(longitude: $longitude, latitude: $latitude) {\n    detailAddress\n    jibunAddress\n    roadAddress\n    sido\n    zipCode\n    sigungu\n    dongLi\n  }\n}\n    ";
var useGetAddressByLocationQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetAddressByLocation",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables), options);
};
useGetAddressByLocationQuery.getKey = function(variables) {
    return [
        "GetAddressByLocation",
        variables
    ];
};
useGetAddressByLocationQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables, options);
};
var GetUserAddressesDocument = "\n    query GetUserAddresses {\n  getUserAddresses {\n    userAddressId\n    userId\n    alias\n    roadAddress\n    oldAddress\n    detailAddress\n    addressType\n    location {\n      latitude\n      longitude\n    }\n    zipCode\n    deliveryComment\n    frontDoorPassword\n    isDefault\n  }\n}\n    ";
var useGetUserAddressesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables), options);
};
useGetUserAddressesQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ];
};
useGetUserAddressesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables, options);
};
var SearchKoreaAddressV2Document = "\n    query SearchKoreaAddressV2($request: KoreaAddressSearchRequestV2Input!) {\n  searchKoreaAddressV2(request: $request) {\n    centroidLatitude\n    centroidLongitude\n    displayName\n    regionCode\n    regionName\n  }\n}\n    ";
var useSearchKoreaAddressV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchKoreaAddressV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables), options);
};
useSearchKoreaAddressV2Query.getKey = function(variables) {
    return [
        "SearchKoreaAddressV2",
        variables
    ];
};
useSearchKoreaAddressV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables, options);
};
var HospitalExternalPostDocument = "\n    query HospitalExternalPost($hospitalPublicId: ID!, $size: Int!, $pivotId: Int) {\n  hospitalExternalPost(\n    hospitalPublicId: $hospitalPublicId\n    size: $size\n    pivotId: $pivotId\n  ) {\n    totalCount\n    items {\n      id\n      title\n      content\n      postedAt\n      url\n    }\n  }\n}\n    ";
var useHospitalExternalPostQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "HospitalExternalPost",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables), options);
};
useHospitalExternalPostQuery.getKey = function(variables) {
    return [
        "HospitalExternalPost",
        variables
    ];
};
useHospitalExternalPostQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables, options);
};


/***/ }),

/***/ 44355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YL": function() { return /* binding */ useGetMagazineAuthorQuery; },
/* harmony export */   "cR": function() { return /* binding */ useGetPrevNextMagazinePidQuery; },
/* harmony export */   "oh": function() { return /* binding */ useInsertMagazineLikeMutation; },
/* harmony export */   "t_": function() { return /* binding */ useGetMagazineRelatedQuestionCardsQuery; },
/* harmony export */   "uW": function() { return /* binding */ useGetMagazineByAuthorPublicIdQuery; },
/* harmony export */   "v": function() { return /* binding */ useDeleteMagazineLikeMutation; },
/* harmony export */   "wJ": function() { return /* binding */ useGetMagazineTagListPageQuery; },
/* harmony export */   "yH": function() { return /* binding */ useGetMagazineRelatedMagazinesQuery; }
/* harmony export */ });
/* unused harmony exports InsertMagazineLikeDocument, DeleteMagazineLikeDocument, GetQuestionRelatedMagazinesDocument, useGetQuestionRelatedMagazinesQuery, GetMagazineTagListPageDocument, GetMagazineRelatedMagazinesDocument, GetPrevNextMagazinePidDocument, GetMagazineRelatedQuestionCardsDocument, GetMagazineRelatedBoardPostsDocument, useGetMagazineRelatedBoardPostsQuery, GetMagazineAuthorDocument, GetMagazineByAuthorPublicIdDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48228);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var InsertMagazineLikeDocument = "\n    mutation InsertMagazineLike($magazinePid: ID!) {\n  insertMagazineLike(magazinePid: $magazinePid)\n}\n    ";
var useInsertMagazineLikeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D)([
        "InsertMagazineLike"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(InsertMagazineLikeDocument, "InsertMagazineLike", variables)();
    }, options);
};
useInsertMagazineLikeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(InsertMagazineLikeDocument, "InsertMagazineLike", variables, options);
};
var DeleteMagazineLikeDocument = "\n    mutation DeleteMagazineLike($magazinePid: ID!) {\n  deleteMagazineLike(magazinePid: $magazinePid)\n}\n    ";
var useDeleteMagazineLikeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D)([
        "DeleteMagazineLike"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DeleteMagazineLikeDocument, "DeleteMagazineLike", variables)();
    }, options);
};
useDeleteMagazineLikeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DeleteMagazineLikeDocument, "DeleteMagazineLike", variables, options);
};
var GetQuestionRelatedMagazinesDocument = "\n    query GetQuestionRelatedMagazines($request: QuestionRelatedMagazinesRequestInput!) {\n  questionRelatedMagazines(request: $request) {\n    description\n    title\n    magazinePid\n    createdAt\n    titleImageUrl\n  }\n}\n    ";
var useGetQuestionRelatedMagazinesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetQuestionRelatedMagazines",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetQuestionRelatedMagazinesDocument, "GetQuestionRelatedMagazines", variables), options);
};
useGetQuestionRelatedMagazinesQuery.getKey = function(variables) {
    return [
        "GetQuestionRelatedMagazines",
        variables
    ];
};
useGetQuestionRelatedMagazinesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetQuestionRelatedMagazinesDocument, "GetQuestionRelatedMagazines", variables, options);
};
var GetMagazineTagListPageDocument = "\n    query GetMagazineTagListPage($request: TagMagazineCursorPageRequestInput!) {\n  tagMagazineCursorPage(request: $request) {\n    pivot\n    elements {\n      createdAt\n      description\n      magazinePid\n      mobileContent\n      mobileDescription\n      mobileTitle\n      title\n      titleImageUrl\n      content\n    }\n  }\n}\n    ";
var useGetMagazineTagListPageQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetMagazineTagListPage",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineTagListPageDocument, "GetMagazineTagListPage", variables), options);
};
useGetMagazineTagListPageQuery.getKey = function(variables) {
    return [
        "GetMagazineTagListPage",
        variables
    ];
};
useGetMagazineTagListPageQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineTagListPageDocument, "GetMagazineTagListPage", variables, options);
};
var GetMagazineRelatedMagazinesDocument = "\n    query GetMagazineRelatedMagazines($request: MagazineRelatedMagazinesRequestInput!) {\n  magazineRelatedMagazines(request: $request) {\n    title\n    mobileTitle\n    description\n    mobileDescription\n    content\n    mobileContent\n    createdAt\n    titleImageUrl\n    magazinePid\n    contentType\n  }\n}\n    ";
var useGetMagazineRelatedMagazinesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetMagazineRelatedMagazines",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineRelatedMagazinesDocument, "GetMagazineRelatedMagazines", variables), options);
};
useGetMagazineRelatedMagazinesQuery.getKey = function(variables) {
    return [
        "GetMagazineRelatedMagazines",
        variables
    ];
};
useGetMagazineRelatedMagazinesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineRelatedMagazinesDocument, "GetMagazineRelatedMagazines", variables, options);
};
var GetPrevNextMagazinePidDocument = "\n    query GetPrevNextMagazinePid($magazinePid: ID!, $contentType: String) {\n  prevMagazinePid(magazinePid: $magazinePid, contentType: $contentType)\n  nextMagazinePid(magazinePid: $magazinePid, contentType: $contentType)\n}\n    ";
var useGetPrevNextMagazinePidQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetPrevNextMagazinePid",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetPrevNextMagazinePidDocument, "GetPrevNextMagazinePid", variables), options);
};
useGetPrevNextMagazinePidQuery.getKey = function(variables) {
    return [
        "GetPrevNextMagazinePid",
        variables
    ];
};
useGetPrevNextMagazinePidQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetPrevNextMagazinePidDocument, "GetPrevNextMagazinePid", variables, options);
};
var GetMagazineRelatedQuestionCardsDocument = "\n    query GetMagazineRelatedQuestionCards($request: MagazineRelatedQuestionCardsRequestInput!) {\n  magazineRelatedQuestionCards(request: $request) {\n    answeredStatus\n    answererCount\n    answererProfileImageUrls\n    question {\n      status\n      title\n      attachments {\n        blindType\n        questionAttachmentId\n      }\n      questionPid\n      content\n      category {\n        name\n        iconImageUrl\n        questionCategoryId\n      }\n      tags {\n        name\n        questionTagId\n      }\n      createdAt\n      isBlockedByMe\n    }\n  }\n}\n    ";
var useGetMagazineRelatedQuestionCardsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetMagazineRelatedQuestionCards",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineRelatedQuestionCardsDocument, "GetMagazineRelatedQuestionCards", variables), options);
};
useGetMagazineRelatedQuestionCardsQuery.getKey = function(variables) {
    return [
        "GetMagazineRelatedQuestionCards",
        variables
    ];
};
useGetMagazineRelatedQuestionCardsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineRelatedQuestionCardsDocument, "GetMagazineRelatedQuestionCards", variables, options);
};
var GetMagazineRelatedBoardPostsDocument = "\n    query GetMagazineRelatedBoardPosts($request: MagazineRelatedBoardPostsRequestInput!) {\n  magazineRelatedBoardPosts(request: $request) {\n    title\n    content\n    blinded\n    boardPostPid\n    boardPostAttachments {\n      blindType\n      boardPostAttachmentId\n    }\n  }\n}\n    ";
var useGetMagazineRelatedBoardPostsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetMagazineRelatedBoardPosts",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineRelatedBoardPostsDocument, "GetMagazineRelatedBoardPosts", variables), options);
};
useGetMagazineRelatedBoardPostsQuery.getKey = function(variables) {
    return [
        "GetMagazineRelatedBoardPosts",
        variables
    ];
};
useGetMagazineRelatedBoardPostsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineRelatedBoardPostsDocument, "GetMagazineRelatedBoardPosts", variables, options);
};
var GetMagazineAuthorDocument = "\n    query GetMagazineAuthor($authorPublicId: ID!) {\n  magazineAuthor(authorPublicId: $authorPublicId) {\n    affiliation {\n      affiliationType\n      affiliationPid\n      name\n    }\n    career {\n      careerType\n      content\n      id\n      isRepresentative\n    }\n    name\n    profileDescription\n    profileImage\n    publicId\n  }\n}\n    ";
var useGetMagazineAuthorQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetMagazineAuthor",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineAuthorDocument, "GetMagazineAuthor", variables), options);
};
useGetMagazineAuthorQuery.getKey = function(variables) {
    return [
        "GetMagazineAuthor",
        variables
    ];
};
useGetMagazineAuthorQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineAuthorDocument, "GetMagazineAuthor", variables, options);
};
var GetMagazineByAuthorPublicIdDocument = "\n    query GetMagazineByAuthorPublicId($authorPublicId: ID!, $pagingRequest: PagingRequestInput!) {\n  magazineByAuthorPublicId(\n    authorPublicId: $authorPublicId\n    pagingRequest: $pagingRequest\n  ) {\n    totalCount\n    totalPageCount\n    magazines {\n      createdAt\n      description\n      titleImageUrl\n      magazinePid\n      mobileDescription\n      title\n      mobileTitle\n    }\n  }\n}\n    ";
var useGetMagazineByAuthorPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "GetMagazineByAuthorPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineByAuthorPublicIdDocument, "GetMagazineByAuthorPublicId", variables), options);
};
useGetMagazineByAuthorPublicIdQuery.getKey = function(variables) {
    return [
        "GetMagazineByAuthorPublicId",
        variables
    ];
};
useGetMagazineByAuthorPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetMagazineByAuthorPublicIdDocument, "GetMagazineByAuthorPublicId", variables, options);
};


/***/ }),

/***/ 39466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F8": function() { return /* binding */ useGetNearbyPharmacyDetailV3ByUserQuery; },
/* harmony export */   "GE": function() { return /* binding */ usePharmacyReviewTagsByRatingQuery; },
/* harmony export */   "Jl": function() { return /* binding */ useParseReceiptMutation; },
/* harmony export */   "Jn": function() { return /* binding */ useFindPickupListOfNearbyPharmacyV3ByUserQuery; },
/* harmony export */   "ME": function() { return /* binding */ useRequestDispensationToPharmacyMutation; },
/* harmony export */   "Mb": function() { return /* binding */ useGetPharmacyDispensableMedicinesQuery; },
/* harmony export */   "Np": function() { return /* binding */ usePickupNearbyPharmacySearchTabQuery; },
/* harmony export */   "UD": function() { return /* binding */ usePreSignedUrlForReceiptUploadQuery; },
/* harmony export */   "Vt": function() { return /* binding */ useRemoveFavoritePharmacyMutation; },
/* harmony export */   "aH": function() { return /* binding */ usePharmacyReviewsQuery; },
/* harmony export */   "eY": function() { return /* binding */ useCreatePharmacyReviewV2Mutation; },
/* harmony export */   "g8": function() { return /* binding */ useCheckUserFavoritePharmacyQuery; },
/* harmony export */   "lv": function() { return /* binding */ useIsBadgeDowngradeTargetQuery; },
/* harmony export */   "oo": function() { return /* binding */ useAddFavoritePharmacyMutation; },
/* harmony export */   "vk": function() { return /* binding */ useGeneralNearbyPharmacySearchTabsQuery; },
/* harmony export */   "xB": function() { return /* binding */ useFavoritePharmaciesQuery; },
/* harmony export */   "xT": function() { return /* binding */ useFindGeneralListOfNearbyPharmacyV3ByUserQuery; },
/* harmony export */   "xk": function() { return /* binding */ useGetPharmacyAttributesQuery; }
/* harmony export */ });
/* unused harmony exports PreSignedUrlForReceiptUploadDocument, ParseReceiptDocument, PharmacyReviewTagsByRatingDocument, CreatePharmacyReviewV2Document, RequestPartnershipPickupDispensationV2Document, useRequestPartnershipPickupDispensationV2Mutation, PharmacyReviewsDocument, PickupNearbyPharmacySearchTabDocument, GeneralNearbyPharmacySearchTabsDocument, TreatmentMedicinesByTreatmentIdDocument, useTreatmentMedicinesByTreatmentIdQuery, GetPharmacyDispensableMedicinesDocument, FindGeneralListOfNearbyPharmacyV3ByUserDocument, FindPickupListOfNearbyPharmacyV3ByUserDocument, GetNearbyPharmacyDetailV3ByUserDocument, AddFavoritePharmacyDocument, RemoveFavoritePharmacyDocument, CheckUserFavoritePharmacyDocument, GetPharmacyAttributesDocument, RequestDispensationToPharmacyDocument, FavoritePharmaciesDocument, IsBadgeDowngradeTargetDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48228);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var PreSignedUrlForReceiptUploadDocument = "\n    query PreSignedUrlForReceiptUpload($request: ReceiptUploadPreSignedUrlRequestInput!) {\n  preSignedUrlForReceiptUpload(request: $request) {\n    preSignedUrl\n    filePath\n  }\n}\n    ";
var usePreSignedUrlForReceiptUploadQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "PreSignedUrlForReceiptUpload",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PreSignedUrlForReceiptUploadDocument, "PreSignedUrlForReceiptUpload", variables), options);
};
usePreSignedUrlForReceiptUploadQuery.getKey = function(variables) {
    return [
        "PreSignedUrlForReceiptUpload",
        variables
    ];
};
usePreSignedUrlForReceiptUploadQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PreSignedUrlForReceiptUploadDocument, "PreSignedUrlForReceiptUpload", variables, options);
};
var ParseReceiptDocument = "\n    mutation ParseReceipt($request: ReceiptParsingRequestInput!) {\n  parseReceipt(request: $request) {\n    success\n    storeInformation {\n      name\n      address\n      businessNumber\n    }\n    paymentInformation {\n      price\n      paidDate\n      cardCompany\n      cardNumber\n    }\n  }\n}\n    ";
var useParseReceiptMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "ParseReceipt"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(ParseReceiptDocument, "ParseReceipt", variables)();
    }, options);
};
useParseReceiptMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(ParseReceiptDocument, "ParseReceipt", variables, options);
};
var PharmacyReviewTagsByRatingDocument = "\n    query PharmacyReviewTagsByRating($rating: Int!) {\n  pharmacyReviewTagsByRating(rating: $rating) {\n    id\n    text\n  }\n}\n    ";
var usePharmacyReviewTagsByRatingQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "PharmacyReviewTagsByRating",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PharmacyReviewTagsByRatingDocument, "PharmacyReviewTagsByRating", variables), options);
};
usePharmacyReviewTagsByRatingQuery.getKey = function(variables) {
    return [
        "PharmacyReviewTagsByRating",
        variables
    ];
};
usePharmacyReviewTagsByRatingQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PharmacyReviewTagsByRatingDocument, "PharmacyReviewTagsByRating", variables, options);
};
var CreatePharmacyReviewV2Document = "\n    mutation CreatePharmacyReviewV2($request: PharmacyReviewCreateMutationRequestInput!) {\n  createPharmacyReviewV2(request: $request)\n}\n    ";
var useCreatePharmacyReviewV2Mutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "CreatePharmacyReviewV2"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CreatePharmacyReviewV2Document, "CreatePharmacyReviewV2", variables)();
    }, options);
};
useCreatePharmacyReviewV2Mutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CreatePharmacyReviewV2Document, "CreatePharmacyReviewV2", variables, options);
};
var RequestPartnershipPickupDispensationV2Document = "\n    mutation requestPartnershipPickupDispensationV2($request: PartnershipPickupDispensationMutationRequestV2Input!) {\n  requestPartnershipPickupDispensationV2(request: $request)\n}\n    ";
var useRequestPartnershipPickupDispensationV2Mutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "requestPartnershipPickupDispensationV2"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RequestPartnershipPickupDispensationV2Document, "requestPartnershipPickupDispensationV2", variables)();
    }, options);
};
useRequestPartnershipPickupDispensationV2Mutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RequestPartnershipPickupDispensationV2Document, "requestPartnershipPickupDispensationV2", variables, options);
};
var PharmacyReviewsDocument = "\n    query PharmacyReviews($request: PharmacyReviewRequestInput!) {\n  pharmacyReviews(request: $request) {\n    content\n    createdAt\n    id\n    isPrivate\n    maskedHolderName\n    rating\n    targetCategoryName\n    targetPrice\n    title\n    reviewContext {\n      reviewHolderId\n    }\n    reviewTags {\n      reviewId\n      tag {\n        tagId\n        text\n      }\n    }\n  }\n}\n    ";
var usePharmacyReviewsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "PharmacyReviews",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PharmacyReviewsDocument, "PharmacyReviews", variables), options);
};
usePharmacyReviewsQuery.getKey = function(variables) {
    return [
        "PharmacyReviews",
        variables
    ];
};
usePharmacyReviewsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PharmacyReviewsDocument, "PharmacyReviews", variables, options);
};
var PickupNearbyPharmacySearchTabDocument = "\n    query PickupNearbyPharmacySearchTab($diagnosisId: ID!) {\n  pickupNearbyPharmacySearchTab(diagnosisId: $diagnosisId) {\n    sortTypes {\n      type\n      title\n    }\n    filters {\n      type\n      title\n      description\n      mode\n      activeIconUrl\n      inactiveIconUrl\n      subFilters {\n        type\n        title\n        description\n        mode\n        inactiveIconUrl\n        activeIconUrl\n      }\n    }\n  }\n}\n    ";
var usePickupNearbyPharmacySearchTabQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "PickupNearbyPharmacySearchTab",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PickupNearbyPharmacySearchTabDocument, "PickupNearbyPharmacySearchTab", variables), options);
};
usePickupNearbyPharmacySearchTabQuery.getKey = function(variables) {
    return [
        "PickupNearbyPharmacySearchTab",
        variables
    ];
};
usePickupNearbyPharmacySearchTabQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(PickupNearbyPharmacySearchTabDocument, "PickupNearbyPharmacySearchTab", variables, options);
};
var GeneralNearbyPharmacySearchTabsDocument = "\n    query GeneralNearbyPharmacySearchTabs {\n  generalNearbyPharmacySearchTabs {\n    id\n    name\n    diagnosisType\n    diagnosisTypeId\n    sortTypes {\n      type\n      title\n    }\n    filters {\n      type\n      title\n      description\n      mode\n      activeIconUrl\n      inactiveIconUrl\n      subFilters {\n        type\n        title\n        description\n        mode\n        inactiveIconUrl\n        activeIconUrl\n      }\n    }\n    treatmentMedicines {\n      id\n      treatmentId\n      name\n      description\n      dispensationUnits {\n        isDefault\n        dispensationUnit\n        dispensationUnitDisplayName\n        treatmentMedicineId\n        treatmentMedicineUnitId\n      }\n      treatmentMedicineStrengths {\n        treatmentMedicineStrengthId\n        unit\n        treatmentMedicineId\n        isDefault\n      }\n    }\n  }\n}\n    ";
var useGeneralNearbyPharmacySearchTabsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "GeneralNearbyPharmacySearchTabs"
    ] : [
        "GeneralNearbyPharmacySearchTabs",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GeneralNearbyPharmacySearchTabsDocument, "GeneralNearbyPharmacySearchTabs", variables), options);
};
useGeneralNearbyPharmacySearchTabsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GeneralNearbyPharmacySearchTabs"
    ] : [
        "GeneralNearbyPharmacySearchTabs",
        variables
    ];
};
useGeneralNearbyPharmacySearchTabsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GeneralNearbyPharmacySearchTabsDocument, "GeneralNearbyPharmacySearchTabs", variables, options);
};
var TreatmentMedicinesByTreatmentIdDocument = "\n    query TreatmentMedicinesByTreatmentId($treatmentId: ID!) {\n  treatmentMedicinesByTreatmentId(treatmentId: $treatmentId) {\n    id\n    treatmentId\n    name\n    description\n    dispensationUnits {\n      isDefault\n      dispensationUnit\n      dispensationUnitDisplayName\n      treatmentMedicineId\n      treatmentMedicineUnitId\n    }\n  }\n}\n    ";
var useTreatmentMedicinesByTreatmentIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "TreatmentMedicinesByTreatmentId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(TreatmentMedicinesByTreatmentIdDocument, "TreatmentMedicinesByTreatmentId", variables), options);
};
useTreatmentMedicinesByTreatmentIdQuery.getKey = function(variables) {
    return [
        "TreatmentMedicinesByTreatmentId",
        variables
    ];
};
useTreatmentMedicinesByTreatmentIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(TreatmentMedicinesByTreatmentIdDocument, "TreatmentMedicinesByTreatmentId", variables, options);
};
var GetPharmacyDispensableMedicinesDocument = "\n    query GetPharmacyDispensableMedicines($request: PharmacyDispensableMedicinesRequestInput!) {\n  pharmacyDispensableMedicines(request: $request) {\n    totalAmount\n    dispensableMedicines {\n      prescribedMedicineId\n      pharmacyMedicine {\n        medicineId\n        price\n        isAlternativeMedicine\n        unitType\n        unit\n        displayName\n        medicine {\n          medicineName\n        }\n        treatmentMedicine {\n          name\n        }\n      }\n    }\n  }\n}\n    ";
var useGetPharmacyDispensableMedicinesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetPharmacyDispensableMedicines",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetPharmacyDispensableMedicinesDocument, "GetPharmacyDispensableMedicines", variables), options);
};
useGetPharmacyDispensableMedicinesQuery.getKey = function(variables) {
    return [
        "GetPharmacyDispensableMedicines",
        variables
    ];
};
useGetPharmacyDispensableMedicinesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetPharmacyDispensableMedicinesDocument, "GetPharmacyDispensableMedicines", variables, options);
};
var FindGeneralListOfNearbyPharmacyV3ByUserDocument = "\n    query FindGeneralListOfNearbyPharmacyV3ByUser($request: NearbyPharmacySearchRequestV3Input!, $treatmentId: ID = null, $treatmentMedicineId: ID = null, $treatmentMedicineStrengthId: ID = null, $dispensationUnit: Int = null, $shouldIncludeDispensableMedicine: Boolean! = false, $shouldIncludeDiagnosisPrice: Boolean! = false) {\n  nearbyPharmacyV3ByUser(request: $request) {\n    contact {\n      tel\n      safetyNumber\n    }\n    location {\n      distanceInMeters\n      latitude\n      longitude\n      pharmacyName\n      roadAddress\n      jibunAddress\n      detailAddress\n    }\n    name\n    partnership\n    pharmacyId\n    publicId\n    pickupCompletedCount\n    reviewMeta {\n      averageRating\n      totalCount\n    }\n    attributesV3(\n      diagnosisId: null\n      treatmentMedicineId: $treatmentMedicineId\n      treatmentMedicineStrengthId: $treatmentMedicineStrengthId\n      isAlternativeExcluded: null\n      dispensationUnit: $dispensationUnit\n    ) {\n      mainTags {\n        title\n        type\n        imageUrl\n      }\n      badges {\n        title\n        type\n        imageUrl\n      }\n      tags {\n        title\n        type\n        imageUrl\n      }\n      priceTags {\n        title\n        type\n        imageUrl\n      }\n    }\n    dispensableMedicines(\n      diagnosisId: null\n      treatmentMedicineId: $treatmentMedicineId\n      treatmentMedicineStrengthId: $treatmentMedicineStrengthId\n      dispensationUnit: $dispensationUnit\n      isAlternativeExcluded: false\n    ) @include(if: $shouldIncludeDispensableMedicine) {\n      totalAmount\n      dispensableMedicines {\n        pharmacyMedicine {\n          medicineId\n          price\n          isAlternativeMedicine\n          unitType\n          unit\n          displayName\n          medicine {\n            medicineName\n          }\n          treatmentMedicine {\n            name\n          }\n        }\n      }\n    }\n    diagnosisPrice(\n      treatmentId: $treatmentId\n      treatmentMedicineId: $treatmentMedicineId\n    ) @include(if: $shouldIncludeDiagnosisPrice)\n    operation {\n      status\n      display\n    }\n    pharmacyNextOperationHour {\n      earliestAvailableReservationHour\n      earliestAvailableReservationHourString\n    }\n    isFavoritePharmacy\n  }\n}\n    ";
var useFindGeneralListOfNearbyPharmacyV3ByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "FindGeneralListOfNearbyPharmacyV3ByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FindGeneralListOfNearbyPharmacyV3ByUserDocument, "FindGeneralListOfNearbyPharmacyV3ByUser", variables), options);
};
useFindGeneralListOfNearbyPharmacyV3ByUserQuery.getKey = function(variables) {
    return [
        "FindGeneralListOfNearbyPharmacyV3ByUser",
        variables
    ];
};
useFindGeneralListOfNearbyPharmacyV3ByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FindGeneralListOfNearbyPharmacyV3ByUserDocument, "FindGeneralListOfNearbyPharmacyV3ByUser", variables, options);
};
var FindPickupListOfNearbyPharmacyV3ByUserDocument = "\n    query FindPickupListOfNearbyPharmacyV3ByUser($request: NearbyPharmacySearchRequestV3Input!, $userLocation: NearbyPharmacyGeoPointInput!, $diagnosisId: ID = null, $shouldIncludeDispensableMedicine: Boolean = false, $isAlternativeExcluded: Boolean!) {\n  nearbyPharmacyV3ByUser(request: $request) {\n    contact {\n      faxNumber\n      safetyNumber\n      tel\n    }\n    location {\n      distanceInMeters\n      latitude\n      longitude\n      pharmacyName\n      roadAddress\n      jibunAddress\n      detailAddress\n    }\n    name\n    partnership\n    pharmacyId\n    publicId\n    pickupCompletedCount\n    reviewMeta {\n      averageRating\n      totalCount\n    }\n    attributesV3(\n      diagnosisId: $diagnosisId\n      isAlternativeExcluded: $isAlternativeExcluded\n    ) {\n      mainTags {\n        title\n        type\n        imageUrl\n      }\n      badges {\n        title\n        type\n        imageUrl\n      }\n      tags {\n        title\n        type\n        imageUrl\n      }\n      priceTags {\n        title\n        type\n        imageUrl\n      }\n      recommendationScore(diagnosisId: $diagnosisId, userLocation: $userLocation) {\n        pharmacyId\n        score\n      }\n    }\n    dispensableMedicines(\n      diagnosisId: $diagnosisId\n      treatmentMedicineId: null\n      dispensationUnit: null\n      isAlternativeExcluded: $isAlternativeExcluded\n    ) @include(if: $shouldIncludeDispensableMedicine) {\n      totalAmount\n      dispensableMedicines {\n        pharmacyMedicine {\n          medicineId\n          price\n          isAlternativeMedicine\n          unitType\n          unit\n          displayName\n          medicine {\n            medicineName\n          }\n          treatmentMedicine {\n            name\n          }\n        }\n        medicine {\n          medicineName\n        }\n      }\n    }\n    operation {\n      status\n      display\n    }\n    pharmacyNextOperationHour {\n      earliestAvailableReservationHour\n      earliestAvailableReservationHourString\n    }\n    isFavoritePharmacy\n  }\n}\n    ";
var useFindPickupListOfNearbyPharmacyV3ByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "FindPickupListOfNearbyPharmacyV3ByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FindPickupListOfNearbyPharmacyV3ByUserDocument, "FindPickupListOfNearbyPharmacyV3ByUser", variables), options);
};
useFindPickupListOfNearbyPharmacyV3ByUserQuery.getKey = function(variables) {
    return [
        "FindPickupListOfNearbyPharmacyV3ByUser",
        variables
    ];
};
useFindPickupListOfNearbyPharmacyV3ByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FindPickupListOfNearbyPharmacyV3ByUserDocument, "FindPickupListOfNearbyPharmacyV3ByUser", variables, options);
};
var GetNearbyPharmacyDetailV3ByUserDocument = "\n    query GetNearbyPharmacyDetailV3ByUser($request: NearbyPharmacyDetailSearchByPublicIdRequestInput!, $diagnosisId: ID, $isAlternativeExcluded: Boolean!) {\n  nearbyPharmacyDetailByPublicId(request: $request) {\n    contact {\n      faxNumber\n      tel\n      safetyNumber\n    }\n    location {\n      detailAddress\n      distanceInMeters\n      jibunAddress\n      latitude\n      longitude\n      pharmacyName\n      roadAddress\n      zipCode\n    }\n    partnership\n    pharmacyId\n    publicId\n    pickupCompletedCount\n    reviewMeta {\n      totalCount\n      averageRating\n    }\n    pharmacyNextOperationHour {\n      earliestAvailableReservationHour\n      earliestAvailableReservationHourString\n    }\n    operation {\n      display\n      todayDuty {\n        weekDay\n        openTime\n        closeTime\n        isClosed\n        hasBreakTime\n        breakStartTime\n        breakEndTime\n      }\n      duties {\n        weekDay\n        openTime\n        closeTime\n        isClosed\n        hasBreakTime\n        breakStartTime\n        breakEndTime\n      }\n      status\n    }\n    numberOfReviewsByRating {\n      rating\n      count\n    }\n    attributesV3(\n      diagnosisId: $diagnosisId\n      isAlternativeExcluded: $isAlternativeExcluded\n    ) {\n      mainTags {\n        imageUrl\n        type\n      }\n      badges {\n        imageUrl\n        type\n      }\n      tags {\n        imageUrl\n        type\n      }\n      priceTags {\n        title\n        type\n        imageUrl\n      }\n    }\n    prescribedMedicineInfoWithDoseDays(diagnosisId: $diagnosisId) {\n      medicineSummary {\n        medicineId\n        medicineName\n        medicineImageUrl\n        hasDetailInfo\n        pharmaceuticalEffectLiteracy\n        publicId\n        medicineDispensability(isAlternativeExcluded: $isAlternativeExcluded) {\n          medicineId\n          dispensabilityStatus\n          iconImageUrl\n        }\n      }\n    }\n    isFavoritePharmacy\n  }\n}\n    ";
var useGetNearbyPharmacyDetailV3ByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetNearbyPharmacyDetailV3ByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetNearbyPharmacyDetailV3ByUserDocument, "GetNearbyPharmacyDetailV3ByUser", variables), options);
};
useGetNearbyPharmacyDetailV3ByUserQuery.getKey = function(variables) {
    return [
        "GetNearbyPharmacyDetailV3ByUser",
        variables
    ];
};
useGetNearbyPharmacyDetailV3ByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetNearbyPharmacyDetailV3ByUserDocument, "GetNearbyPharmacyDetailV3ByUser", variables, options);
};
var AddFavoritePharmacyDocument = "\n    mutation AddFavoritePharmacy($pharmacyId: ID!) {\n  addFavoritePharmacy(pharmacyId: $pharmacyId)\n}\n    ";
var useAddFavoritePharmacyMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "AddFavoritePharmacy"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(AddFavoritePharmacyDocument, "AddFavoritePharmacy", variables)();
    }, options);
};
useAddFavoritePharmacyMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(AddFavoritePharmacyDocument, "AddFavoritePharmacy", variables, options);
};
var RemoveFavoritePharmacyDocument = "\n    mutation RemoveFavoritePharmacy($pharmacyId: ID!) {\n  removeFavoritePharmacy(pharmacyId: $pharmacyId)\n}\n    ";
var useRemoveFavoritePharmacyMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "RemoveFavoritePharmacy"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RemoveFavoritePharmacyDocument, "RemoveFavoritePharmacy", variables)();
    }, options);
};
useRemoveFavoritePharmacyMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RemoveFavoritePharmacyDocument, "RemoveFavoritePharmacy", variables, options);
};
var CheckUserFavoritePharmacyDocument = "\n    query CheckUserFavoritePharmacy($pharmacyId: ID!) {\n  checkUserFavoritePharmacy(pharmacyId: $pharmacyId)\n}\n    ";
var useCheckUserFavoritePharmacyQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "CheckUserFavoritePharmacy",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CheckUserFavoritePharmacyDocument, "CheckUserFavoritePharmacy", variables), options);
};
useCheckUserFavoritePharmacyQuery.getKey = function(variables) {
    return [
        "CheckUserFavoritePharmacy",
        variables
    ];
};
useCheckUserFavoritePharmacyQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CheckUserFavoritePharmacyDocument, "CheckUserFavoritePharmacy", variables, options);
};
var GetPharmacyAttributesDocument = "\n    query GetPharmacyAttributes($request: NearbyPharmacyDetailSearchRequestV3Input!, $diagnosisId: ID!, $isAlternativeExcluded: Boolean!) {\n  nearbyPharmacyDetailV3ByUser(request: $request) {\n    attributesV3(\n      diagnosisId: $diagnosisId\n      isAlternativeExcluded: $isAlternativeExcluded\n    ) {\n      mainTags {\n        title\n        type\n        imageUrl\n      }\n      badges {\n        title\n        type\n        imageUrl\n      }\n      tags {\n        title\n        type\n        imageUrl\n      }\n      priceTags {\n        title\n        type\n        imageUrl\n      }\n    }\n  }\n}\n    ";
var useGetPharmacyAttributesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetPharmacyAttributes",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetPharmacyAttributesDocument, "GetPharmacyAttributes", variables), options);
};
useGetPharmacyAttributesQuery.getKey = function(variables) {
    return [
        "GetPharmacyAttributes",
        variables
    ];
};
useGetPharmacyAttributesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetPharmacyAttributesDocument, "GetPharmacyAttributes", variables, options);
};
var RequestDispensationToPharmacyDocument = "\n    mutation RequestDispensationToPharmacy($request: DispensationPharmacyFaxRequestInput!) {\n  requestDispensationToPharmacy(request: $request)\n}\n    ";
var useRequestDispensationToPharmacyMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "RequestDispensationToPharmacy"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RequestDispensationToPharmacyDocument, "RequestDispensationToPharmacy", variables)();
    }, options);
};
useRequestDispensationToPharmacyMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(RequestDispensationToPharmacyDocument, "RequestDispensationToPharmacy", variables, options);
};
var FavoritePharmaciesDocument = "\n    query FavoritePharmacies($request: FavoritePharmaciesRequestInput!) {\n  favoritePharmacies(request: $request) {\n    name\n    partnership\n    pharmacyId\n    publicId\n    pickupCompletedCount\n    isFavoritePharmacy\n    contact {\n      faxNumber\n      safetyNumber\n      tel\n    }\n    location {\n      detailAddress\n      distanceInMeters\n      jibunAddress\n      latitude\n      longitude\n      pharmacyName\n      roadAddress\n      zipCode\n    }\n    reviewMeta {\n      averageRating\n      totalCount\n    }\n    attributesV3 {\n      badges {\n        imageUrl\n        title\n        type\n      }\n      mainTags {\n        imageUrl\n        title\n        type\n      }\n      priceTags {\n        imageUrl\n        title\n        type\n      }\n      tags {\n        imageUrl\n        title\n        type\n      }\n    }\n    numberOfReviewsByRating {\n      count\n      rating\n    }\n    operation {\n      display\n      status\n      duties {\n        closeTime\n        id\n        isClosed\n        openTime\n        pharmacyId\n        weekDay\n      }\n    }\n    pharmacyNextOperationHour {\n      earliestAvailableReservationHour\n      earliestAvailableReservationHourString\n      pharmacyId\n    }\n  }\n}\n    ";
var useFavoritePharmaciesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "FavoritePharmacies",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FavoritePharmaciesDocument, "FavoritePharmacies", variables), options);
};
useFavoritePharmaciesQuery.getKey = function(variables) {
    return [
        "FavoritePharmacies",
        variables
    ];
};
useFavoritePharmaciesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(FavoritePharmaciesDocument, "FavoritePharmacies", variables, options);
};
var IsBadgeDowngradeTargetDocument = "\n    query IsBadgeDowngradeTarget($diagnosisId: ID!) {\n  isBadgeDowngradeTarget(diagnosisId: $diagnosisId)\n}\n    ";
var useIsBadgeDowngradeTargetQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "IsBadgeDowngradeTarget",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(IsBadgeDowngradeTargetDocument, "IsBadgeDowngradeTarget", variables), options);
};
useIsBadgeDowngradeTargetQuery.getKey = function(variables) {
    return [
        "IsBadgeDowngradeTarget",
        variables
    ];
};
useIsBadgeDowngradeTargetQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(IsBadgeDowngradeTargetDocument, "IsBadgeDowngradeTarget", variables, options);
};


/***/ }),

/***/ 79832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSearchCriteria */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26297);
/* harmony import */ var _parsers_f2f_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89325);
/* harmony import */ var _parsers_pharmacy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50635);
/* harmony import */ var _services_pharmacy_PharmacyPickupService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39826);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72271);
/* harmony import */ var _shared_hooks_useDebounceWithLoading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78974);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var _pharmacy_gql_impl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39466);









var getSearchCriteria = function(diagnosisType, diagnosisTypeId, treatmentMedicineId, dispensationUnit, treatmentMedicineStrengthId) {
    if (!diagnosisType) {
        return {};
    }
    if (!diagnosisTypeId) {
        return {};
    }
    if (diagnosisType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Treatment */ .LE2.Treatment) {
        return {
            medicineSearchCriteria: {
                treatmentId: diagnosisTypeId,
                treatmentMedicineId: treatmentMedicineId,
                dispensationUnit: dispensationUnit,
                treatmentMedicineStrengthId: treatmentMedicineStrengthId
            }
        };
    }
    if (diagnosisType === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisType.Department */ .LE2.Department) {
        return {
            departmentSearchCriteria: {
                departmentId: diagnosisTypeId
            }
        };
    }
    return {};
};
var useFindGeneralListOfNearbyPharmacyV3ByUser = function(queryRequest) {
    var ref = (0,_shared_hooks_useDebounceWithLoading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(queryRequest, 500, {
        leading: false,
        trailing: true
    }), queryRequestDebounced = ref.debouncedValue, isQueryRequestDebouncedLoading = ref.isLoading;
    var latitude = queryRequestDebounced.latitude, longitude = queryRequestDebounced.longitude, diagnosisType = queryRequestDebounced.diagnosisType, diagnosisTypeId = queryRequestDebounced.diagnosisTypeId, treatmentMedicineId = queryRequestDebounced.treatmentMedicineId, dispensationUnit = queryRequestDebounced.dispensationUnit, treatmentMedicineStrengthId = queryRequestDebounced.treatmentMedicineStrengthId, shouldIncludeDiagnosisPrice = queryRequestDebounced.shouldIncludeDiagnosisPrice, restQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(queryRequestDebounced, [
        "latitude",
        "longitude",
        "diagnosisType",
        "diagnosisTypeId",
        "treatmentMedicineId",
        "dispensationUnit",
        "treatmentMedicineStrengthId",
        "shouldIncludeDiagnosisPrice"
    ]);
    var isEnabled = function() {
        if (shouldIncludeDiagnosisPrice && !treatmentMedicineId && !dispensationUnit) {
            return false;
        }
        return !!restQuery.northEastLatitude && !!restQuery.northEastLongitude && !!restQuery.southWestLatitude && !!restQuery.southWestLongitude;
    };
    var mapCoordinate = _services_pharmacy_PharmacyPickupService__WEBPACK_IMPORTED_MODULE_2__/* .PharmacyPickupService.getMapCoordinate */ .B.getMapCoordinate(restQuery);
    var userCoordinate = (0,_parsers_f2f_common__WEBPACK_IMPORTED_MODULE_0__/* .getCoordinate */ .FY)(latitude, longitude);
    var ref1 = (0,_pharmacy_gql_impl__WEBPACK_IMPORTED_MODULE_6__/* .useFindGeneralListOfNearbyPharmacyV3ByUserQuery */ .xT)({
        request: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, {
            userLocation: {
                latitude: userCoordinate.latitude,
                longitude: userCoordinate.longitude
            },
            geoBound: {
                northEastLatitude: mapCoordinate.northEastLatitude,
                northEastLongitude: mapCoordinate.northEastLongitude,
                southWestLatitude: mapCoordinate.southWestLatitude,
                southWestLongitude: mapCoordinate.southWestLongitude
            },
            page: 1
        }, getSearchCriteria(diagnosisType, diagnosisTypeId, treatmentMedicineId, dispensationUnit, treatmentMedicineStrengthId)),
        treatmentId: diagnosisTypeId,
        treatmentMedicineId: treatmentMedicineId,
        dispensationUnit: dispensationUnit,
        treatmentMedicineStrengthId: treatmentMedicineStrengthId,
        shouldIncludeDispensableMedicine: !!treatmentMedicineId && !!dispensationUnit,
        shouldIncludeDiagnosisPrice: shouldIncludeDiagnosisPrice
    }, {
        select: _parsers_pharmacy__WEBPACK_IMPORTED_MODULE_1__/* .parseGeneralListOfNearbyPharmacy */ .af,
        enabled: isEnabled(),
        keepPreviousData: true
    }), _data = ref1.data, data = _data === void 0 ? [] : _data, isFetching = ref1.isFetching, isLoading = ref1.isLoading;
    var isVisibleMedicinePrice = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return data.some(function(pharmacy) {
            return pharmacy.hasMedicinePrice();
        });
    }, [
        data
    ]);
    return {
        isLoading: isFetching || isLoading || isQueryRequestDebouncedLoading,
        data: data,
        isVisibleMedicinePrice: isVisibleMedicinePrice
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFindGeneralListOfNearbyPharmacyV3ByUser);


/***/ }),

/***/ 68512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24903);
/* harmony import */ var _components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76815);
/* harmony import */ var _components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68764);
/* harmony import */ var _components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66875);
/* harmony import */ var _useModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98266);
/* harmony import */ var _useToast__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17722);








var REPORT_TYPE = {
    QUESTION: "question",
    ANSWER: "answer",
    BOARD_POST: "board_post",
    BOARD_POST_COMMENT: "board_post_comment"
};
var useReviewReportModal = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showReportModal = ref[0], setShowReportModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), reportData = ref1[0], setReportData = ref1[1];
    var reportItems = [
        {
            Icon: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserReport__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
            },
            text: "사용자 신고",
            onClick: function() {
                showToast({
                    message: "선택한 사용자를 신고했어요."
                });
                closeModal();
                onCloseReportModal();
            }
        },
        {
            Icon: function() {
                return isBlocked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserUnBlock__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_UserBlock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
            },
            text: "사용자 차단",
            onClick: function() {
                showToast({
                    message: "선택한 사용자를 차단했어요."
                });
                closeModal();
                onCloseReportModal();
            }
        },
        {
            Icon: function() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atom_icon_Report_QnaReport__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
            },
            text: "리뷰 신고",
            onClick: function() {
                showToast({
                    message: "선택한 리뷰를 신고했어요"
                });
                closeModal();
                onCloseReportModal();
            }
        }, 
    ];
    var closeModal = (0,_useModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().closeModal;
    var showToast = (0,_useToast__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().showToast;
    var isBlocked = reportData === null || reportData === void 0 ? void 0 : reportData.isBlocked;
    var onCloseReportModal = function() {
        setShowReportModal(false);
        setReportData(undefined);
    };
    var onShowReportModal = function(data) {
        setReportData(data);
    };
    var openReportModal = function() {
        setShowReportModal(true);
    };
    return {
        showReportModal: showReportModal,
        onShowReportModal: onShowReportModal,
        onCloseReportModal: onCloseReportModal,
        openReportModal: openReportModal,
        reportData: reportData,
        reportItems: reportItems
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useReviewReportModal);


/***/ }),

/***/ 13041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useIntersectionObserver = function(param) {
    var target = param.target, _freeze = param.freeze, freeze = _freeze === void 0 ? false : _freeze, _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, _root = param.root, root = _root === void 0 ? null : _root, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0%" : _rootMargin;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), entry = ref[0], setEntry = ref[1];
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var updateEntry = function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), currentEntry = _param[0];
        setEntry(currentEntry);
    };
    var cleanObserver = function() {
        if (observer.current) {
            observer.current.disconnect();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var hasIOSupport = "IntersectionObserver" in window;
        if (!freeze && target && hasIOSupport) {
            var observerParams = {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            };
            var observer = new IntersectionObserver(updateEntry, observerParams);
            observer.observe(target);
        }
        return function() {
            cleanObserver();
        };
    }, [
        target,
        root,
        rootMargin,
        threshold,
        freeze
    ]);
    return entry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersectionObserver);


/***/ }),

/***/ 17722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53476);
/* harmony import */ var _recoil_atoms_common_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15094);



var useToast = function() {
    var setToasts = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_toast__WEBPACK_IMPORTED_MODULE_2__/* .toastState */ .J);
    var removeToast = function(id) {
        setToasts(function(oldToasts) {
            return oldToasts.filter(function(toast) {
                return toast.id !== id;
            });
        });
    };
    var _showToast = function(props) {
        var id = new Date().getTime();
        setToasts([
            {
                props: props,
                id: id
            }
        ]);
        return setTimeout(function() {
            return removeToast(id);
        }, (props.visibleTime || 2000) + 800);
    };
    var showToast = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(_showToast, 300);
    return {
        showToast: showToast
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useToast);


/***/ }),

/***/ 84958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ Review; },
/* harmony export */   "Fj": function() { return /* binding */ EReviewType; },
/* harmony export */   "IE": function() { return /* binding */ ReviewComment; },
/* harmony export */   "R": function() { return /* binding */ ReviewDiagnosisDoctor; },
/* harmony export */   "Vj": function() { return /* binding */ ReviewTag; },
/* harmony export */   "XV": function() { return /* binding */ ReviewTagExposure; },
/* harmony export */   "fr": function() { return /* binding */ ReviewTargetType; }
/* harmony export */ });
/* unused harmony exports MedicineType, ReviewDiagnosis */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27805);


var ReviewTargetType;
(function(ReviewTargetType) {
    ReviewTargetType["DOCTOR"] = "DOCTOR";
    ReviewTargetType["PHARMACY"] = "PHARMACY";
})(ReviewTargetType || (ReviewTargetType = {}));
var EReviewType;
(function(EReviewType) {
    EReviewType["NORMAL"] = "NORMAL";
    EReviewType["BEST"] = "BEST";
})(EReviewType || (EReviewType = {}));
var MedicineType;
(function(MedicineType) {
    MedicineType["Counselor"] = "COUNSELOR";
    MedicineType["Dentist"] = "DENTIST";
    MedicineType["Doctor"] = "DOCTOR";
    MedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
})(MedicineType || (MedicineType = {}));
var Review = /*#__PURE__*/ function() {
    "use strict";
    function Review(review) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Review);
        this.review = review;
    }
    var _proto = Review.prototype;
    _proto.shouldNotDisplayed = function shouldNotDisplayed(currentUserId) {
        if (!this.isPrivate) {
            return false;
        }
        return Number(currentUserId) !== Number(this.userId);
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Review, [
        {
            key: "id",
            get: function get() {
                return this.review.id;
            }
        },
        {
            key: "isPrivate",
            get: function get() {
                return this.review.isPrivate;
            }
        },
        {
            key: "userId",
            get: function get() {
                return this.review.userId;
            }
        },
        {
            key: "isLiked",
            get: function get() {
                return this.review.isLiked;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.review.title;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.review.content;
            }
        },
        {
            key: "writer",
            get: function get() {
                return this.review.writer;
            }
        },
        {
            key: "rating",
            get: function get() {
                return this.review.rating;
            }
        },
        {
            key: "comment",
            get: function get() {
                return this.review.comment;
            }
        },
        {
            key: "likeCount",
            get: function get() {
                return this.review.likeCount;
            }
        },
        {
            key: "tags",
            get: function get() {
                return this.review.tags;
            }
        },
        {
            key: "price",
            get: function get() {
                return this.review.price;
            }
        },
        {
            key: "createdAt",
            get: function get() {
                return this.review.createdAt;
            }
        },
        {
            key: "diagnosisCategoryName",
            get: function get() {
                return this.review.diagnosisCategoryName;
            }
        },
        {
            key: "doctor",
            get: function get() {
                return this.review.doctor;
            }
        }
    ]);
    return Review;
}();
var ReviewTag = /*#__PURE__*/ function() {
    "use strict";
    function ReviewTag(tag) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewTag);
        this.tag = tag;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewTag, [
        {
            key: "reviewId",
            get: function get() {
                return this.tag.reviewId;
            }
        },
        {
            key: "tagId",
            get: function get() {
                return this.tag.tagId;
            }
        },
        {
            key: "text",
            get: function get() {
                return this.tag.text;
            }
        }
    ]);
    return ReviewTag;
}();
var ReviewComment = /*#__PURE__*/ function() {
    "use strict";
    function ReviewComment(reviewComment) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewComment);
        this.reviewComment = reviewComment;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewComment, [
        {
            key: "createdAt",
            get: function get() {
                return this.reviewComment.createdAt;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.reviewComment.content;
            }
        }
    ]);
    return ReviewComment;
}();
var ReviewDiagnosis = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ReviewDiagnosis(reviewDiagnosis) {
        _class_call_check(this, ReviewDiagnosis);
        this.reviewDiagnosis = reviewDiagnosis;
    }
    _create_class(ReviewDiagnosis, [
        {
            key: "doctor",
            get: function get() {
                return this.reviewDiagnosis.doctor;
            }
        }
    ]);
    return ReviewDiagnosis;
}()));
var ReviewDiagnosisDoctor = /*#__PURE__*/ function() {
    "use strict";
    function ReviewDiagnosisDoctor(reviewDiagnosisDoctor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewDiagnosisDoctor);
        this.reviewDiagnosisDoctor = reviewDiagnosisDoctor;
    }
    var _proto = ReviewDiagnosisDoctor.prototype;
    _proto.getDoctorDisplayName = function getDoctorDisplayName() {
        if (this.medicineType === MedicineType.OrientalDoctor) {
            return "".concat(this.name, " 한의사");
        }
        return "".concat(this.name, " 의사");
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewDiagnosisDoctor, [
        {
            key: "id",
            get: function get() {
                return this.reviewDiagnosisDoctor.id;
            }
        },
        {
            key: "medicineType",
            get: function get() {
                return this.reviewDiagnosisDoctor.medicineType;
            }
        },
        {
            key: "name",
            get: function get() {
                return this.reviewDiagnosisDoctor.name;
            }
        },
        {
            key: "profile",
            get: function get() {
                return this.reviewDiagnosisDoctor.profile;
            }
        }
    ]);
    return ReviewDiagnosisDoctor;
}();
var ReviewTagExposure;
(function(ReviewTagExposure) {
    ReviewTagExposure["ALWAYS"] = "ALWAYS";
    ReviewTagExposure["POSITIVE"] = "POSITIVE";
    ReviewTagExposure["NEGATIVE"] = "NEGATIVE";
    ReviewTagExposure["NONE"] = "NONE";
})(ReviewTagExposure || (ReviewTagExposure = {}));


/***/ }),

/***/ 70296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ non_benefit_map; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/ui/NonBenefitPharmacyHeader.tsx



var NonBenefitPharmacyHeader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "z-[2] bg-white",
        children: props.isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: "flex items-center justify-between px-6 pb-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "typography-ui-22sb",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: props.handleOpenShareModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                        name: "share",
                        color: theme/* default.color.gray600 */.Z.color.gray600,
                        size: 24
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            className: "flex h-12 items-center justify-between px-5 py-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "typography-ui-22sb",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: props.handleOpenShareModal,
                    className: "typography-ui-16sb flex flex h-12 items-center items-center gap-2 rounded-lg border border-gray-100 border-solid px-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "share",
                            color: theme/* default.color.gray600 */.Z.color.gray600,
                            size: 20
                        }),
                        "공유하기"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ui_NonBenefitPharmacyHeader = (NonBenefitPharmacyHeader);

// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/Filter/Filter.tsx
var Filter = __webpack_require__(57266);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyScrollFilters/PharmacyScrollFilters.tsx
var PharmacyScrollFilters = __webpack_require__(98264);
// EXTERNAL MODULE: ./src/components/common/ClickLogger.tsx
var ClickLogger = __webpack_require__(53157);
// EXTERNAL MODULE: ./src/constants/ddActions/pharmacy/index.ts
var pharmacy = __webpack_require__(77292);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/Modals/AddressesModal.tsx
var AddressesModal = __webpack_require__(15517);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ./src/features/pharmacies/pharmacies-find/ui/MedicineInfoBottomSheet.tsx + 1 modules
var MedicineInfoBottomSheet = __webpack_require__(53199);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/hooks/usePharmacyFilterViewModel.ts
var usePharmacyFilterViewModel = __webpack_require__(65669);
// EXTERNAL MODULE: ./src/hooks/pharmacy/usePharmacyLocation.ts
var usePharmacyLocation = __webpack_require__(46088);
// EXTERNAL MODULE: ./src/models/pharmacy/index.ts
var models_pharmacy = __webpack_require__(75203);
;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/viewModels/useNonBenefitPharmacyFilterViewModel.ts






function useNonBenefitPharmacyFilterViewModel(param) {
    var selectedTab = param.selectedTab, defaultSort = param.defaultSort, onApplyFilter = param.onApplyFilter, onClickCurrentLocation = param.onClickCurrentLocation;
    // 공통 필터 뷰모델 초기화
    var commonFilterViewModel = (0,usePharmacyFilterViewModel/* default */.Z)({
        selectedTab: selectedTab,
        defaultSort: defaultSort,
        nearbyPharmacySortsAndFilters: selectedTab ? {
            sorts: selectedTab.sortTypes,
            filters: selectedTab.filters
        } : undefined,
        onApplyFilter: onApplyFilter
    });
    // 약국 위치 관련 훅 초기화
    var locationHook = (0,usePharmacyLocation/* default */.Z)();
    // 약 정보 관련 상태
    var ref = (0,react.useState)(false), isMedicineInfoOpen = ref[0], setIsMedicineInfoOpen = ref[1];
    var ref1 = (0,react.useState)(false), isSortBottomSheetOpen = ref1[0], setIsSortBottomSheetOpen = ref1[1];
    // 주소 관련 액션
    var addressActions = {
        openAddressSelectModal: function() {
            return {
                addresses: locationHook.addresses,
                onOpenAddressListScreen: locationHook.goToAppMyPageAddressScreen,
                onRequestCurrentPosition: onClickCurrentLocation
            };
        }
    };
    // 바텀시트 핸들러
    var openSortBottomSheet = function() {
        return setIsSortBottomSheetOpen(true);
    };
    var closeSortBottomSheet = function() {
        return setIsSortBottomSheetOpen(false);
    };
    var handleMedicineInfoClick = function() {
        return setIsMedicineInfoOpen(true);
    };
    var handleCloseMedicineInfo = function() {
        return setIsMedicineInfoOpen(false);
    };
    // 필터 선택 핸들러
    var handleFilterClick = function(filter) {
        commonFilterViewModel.toggleFilter(filter);
    };
    // 정렬 선택 핸들러
    var handleSortSelected = (0,react.useCallback)(function(sort) {
        var newCriteria = {
            selectedMedicine: commonFilterViewModel.localFilterCriteria.selectedMedicine,
            selectedCommonFilters: commonFilterViewModel.localFilterCriteria.selectedCommonFilters,
            includeDiagnosisPriceFilter: commonFilterViewModel.localFilterCriteria.includeDiagnosisPriceFilter,
            selectedSortMethod: sort
        };
        onApplyFilter(newCriteria);
        closeSortBottomSheet();
    }, [
        commonFilterViewModel.localFilterCriteria,
        onApplyFilter
    ]);
    // 약 관련 핸들러
    var handleMedicineClick = (0,react.useCallback)(function(medicine) {
        var ref;
        if (!medicine.dispensationUnits.length) {
            return;
        }
        // 기본 단위 찾기 (isDefault가 true인 단위 또는 첫 번째 단위)
        var defaultUnit = medicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || medicine.dispensationUnits[0];
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(medicine, defaultUnit, medicine.treatmentMedicineId, (ref = medicine.treatmentMedicineStrengths[0]) === null || ref === void 0 ? void 0 : ref.treatmentMedicineStrengthId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    var handleDispensationUnitClick = (0,react.useCallback)(function(unit) {
        var ref, ref1;
        if (!((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine)) {
            return;
        }
        var _treatmentMedicineStrengthId;
        var selectedStrength = (_treatmentMedicineStrengthId = commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicineStrengthId) !== null && _treatmentMedicineStrengthId !== void 0 ? _treatmentMedicineStrengthId : (ref1 = commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine.treatmentMedicineStrengths[0]) === null || ref1 === void 0 ? void 0 : ref1.treatmentMedicineStrengthId;
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine, unit, commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicineId, selectedStrength);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter,
            includeDiagnosisPriceFilter: commonFilterViewModel.localFilterCriteria.includeDiagnosisPriceFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    var handleDispensationStrengthClick = (0,react.useCallback)(function(strength) {
        var ref;
        if (!((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine)) {
            return;
        }
        var _dispensationUnit;
        var selectedUnit = (_dispensationUnit = commonFilterViewModel.localFilterCriteria.selectedMedicine.dispensationUnit) !== null && _dispensationUnit !== void 0 ? _dispensationUnit : commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine.dispensationUnits[0];
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicine, selectedUnit, commonFilterViewModel.localFilterCriteria.selectedMedicine.treatmentMedicineId, strength.treatmentMedicineStrengthId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        commonFilterViewModel,
        onApplyFilter
    ]);
    // 조건부 UI 표시 관련 함수
    var shouldShowTreatmentMedicineFilter = (0,react.useCallback)(function() {
        var ref;
        return !!(selectedTab === null || selectedTab === void 0 ? void 0 : (ref = selectedTab.treatmentMedicines) === null || ref === void 0 ? void 0 : ref.length);
    }, [
        selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.treatmentMedicines
    ]);
    var shouldShowDiagnosisPriceFilter = (0,react.useCallback)(function() {
        return !!commonFilterViewModel.localFilterCriteria.selectedMedicine;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    // 약/단위 선택 관련 헬퍼 함수
    var isMedicineSelected = (0,react.useCallback)(function(medicine) {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineId) === medicine.treatmentMedicineId;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var getSelectedMedicineUnits = (0,react.useCallback)(function() {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.dispensationUnits) || [];
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var getSelectedMedicineStrengths = (0,react.useCallback)(function() {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineStrengths) || [];
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var isDispensationUnitSelected = (0,react.useCallback)(function(unit) {
        var ref, ref1;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : (ref1 = ref.dispensationUnit) === null || ref1 === void 0 ? void 0 : ref1.dispensationUnit) === unit.dispensationUnit;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    var isDispensationStrengthSelected = (0,react.useCallback)(function(strength) {
        var ref;
        return ((ref = commonFilterViewModel.localFilterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicineStrengthId) === strength.treatmentMedicineStrengthId;
    }, [
        commonFilterViewModel.localFilterCriteria.selectedMedicine
    ]);
    // 초기 약 선택 설정
    (0,react.useEffect)(function() {
        var ref;
        // 약이 있고 아직 선택되지 않았을 때만 처리
        if (!(selectedTab === null || selectedTab === void 0 ? void 0 : (ref = selectedTab.treatmentMedicines) === null || ref === void 0 ? void 0 : ref.length) || commonFilterViewModel.localFilterCriteria.selectedMedicine) {
            return;
        }
        var firstMedicine = selectedTab.treatmentMedicines[0];
        var defaultUnit = firstMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || firstMedicine.dispensationUnits[0];
        var defaultStrength = firstMedicine.treatmentMedicineStrengths.length > 0 ? firstMedicine.treatmentMedicineStrengths.find(function(medicine) {
            return medicine.isDefault;
        }) || firstMedicine.treatmentMedicineStrengths[0] : null;
        var newMedicineFilter = new models_pharmacy/* MedicineFilterModel */.QP(firstMedicine, defaultUnit, firstMedicine.treatmentMedicineId, defaultStrength === null || defaultStrength === void 0 ? void 0 : defaultStrength.treatmentMedicineStrengthId);
        var newCriteria = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel.localFilterCriteria), {
            selectedMedicine: newMedicineFilter
        });
        commonFilterViewModel.setLocalFilterCriteria(newCriteria);
        onApplyFilter(newCriteria);
    }, [
        selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.treatmentMedicines,
        commonFilterViewModel,
        onApplyFilter
    ]);
    var ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonFilterViewModel), {
        locationHook: locationHook,
        addressActions: addressActions,
        // 정렬 관련 상태 및 메서드
        isSortBottomSheetOpen: isSortBottomSheetOpen,
        openSortBottomSheet: openSortBottomSheet,
        closeSortBottomSheet: closeSortBottomSheet,
        // 필터 및 정렬 핸들러
        handleFilterClick: handleFilterClick,
        handleSortSelected: handleSortSelected,
        // 약 관련 상태 및 메서드
        isMedicineInfoOpen: isMedicineInfoOpen,
        handleMedicineInfoClick: handleMedicineInfoClick,
        handleCloseMedicineInfo: handleCloseMedicineInfo,
        treatmentMedicines: (ref2 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.treatmentMedicines) !== null && ref2 !== void 0 ? ref2 : [],
        handleMedicineClick: handleMedicineClick,
        handleDispensationUnitClick: handleDispensationUnitClick,
        handleDispensationStrengthClick: handleDispensationStrengthClick,
        shouldShowTreatmentMedicineFilter: shouldShowTreatmentMedicineFilter,
        isMedicineSelected: isMedicineSelected,
        getSelectedMedicineUnits: getSelectedMedicineUnits,
        getSelectedMedicineStrengths: getSelectedMedicineStrengths,
        isDispensationUnitSelected: isDispensationUnitSelected,
        isDispensationStrengthSelected: isDispensationStrengthSelected,
        shouldShowDiagnosisPriceFilter: shouldShowDiagnosisPriceFilter
    });
}

;// CONCATENATED MODULE: ./src/features/pharmacies/pharmacies-nonbenefit/ui/NonBenefitPharmacyHeaderFilter.tsx














var NonBenefitPharmacyHeaderFilter = function(props) {
    var ref, ref1;
    var ref2 = (0,useModal/* default */.Z)(), showModal = ref2.showModal, closeModal = ref2.closeModal;
    var viewModel = useNonBenefitPharmacyFilterViewModel({
        client: props.client,
        selectedTab: props.selectedTab,
        defaultSort: props.defaultSort,
        onApplyFilter: props.onApplyFilter,
        onClickCurrentLocation: props.onClickCurrentLocation
    });
    var openAddressSelectModal = function() {
        var addressOptions = viewModel.addressActions.openAddressSelectModal();
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressesModal/* default */.Z, {
                    client: props.client,
                    addresses: addressOptions.addresses,
                    onOpenAddressListScreen: addressOptions.onOpenAddressListScreen,
                    onRequestCurrentPosition: function() {
                        var ref;
                        (ref = addressOptions.onRequestCurrentPosition) === null || ref === void 0 ? void 0 : ref.call(addressOptions);
                        closeModal();
                    }
                }),
                onClickOverlay: closeModal
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PharmacyScrollFilters/* default */.Z, {
                    pharmacyFilters: viewModel.searchFiltersHook.pharmacyFilterListWithoutIncludeDiagnosisPriceFilter,
                    onClickSearchCommonFilter: viewModel.handleFilterClick,
                    onClickListFilter: viewModel.handleFilterClick,
                    selectedFilters: viewModel.localFilterCriteria.selectedCommonFilters,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: pharmacy/* PharmacyDdAction.ClickLocation */.Fe.ClickLocation,
                                payload: {
                                    location: props.currentDongLi
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter/* default.LargeFilter */.Z.LargeFilter, {
                                onClick: openAddressSelectModal,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "my_location",
                                        size: 16,
                                        color: theme/* default.color.gray700 */.Z.color.gray700,
                                        filled: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.currentDongLi
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-[4px] h-full min-w-[1px] bg-gray-30"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                            params: {
                                eventName: pharmacy/* PharmacyDdAction.ClickSort */.Fe.ClickSort
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter/* default.LargeFilter */.Z.LargeFilter, {
                                onClick: viewModel.openSortBottomSheet,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "swap_vert",
                                        size: 16,
                                        color: theme/* default.color.gray700 */.Z.color.gray700,
                                        filled: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: viewModel.localFilterCriteria.selectedSortMethod.title
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            viewModel.shouldShowTreatmentMedicineFilter() && viewModel.localFilterCriteria.selectedMedicine && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col divide-y divide-solid divide-gray-30 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-20 items-center gap-[2px] pl-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "typography-ui-13sb text-gray-800",
                                        children: "처방약"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "flex cursor-pointer items-center justify-center border-0 bg-none",
                                        onClick: viewModel.handleMedicineInfoClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/pharmacy/info_gray.svg",
                                            alt: "정보",
                                            width: "14",
                                            height: "14"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: (ref = viewModel.treatmentMedicines) === null || ref === void 0 ? void 0 : ref.map(function(medicine) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isMedicineSelected(medicine) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleMedicineClick(medicine);
                                        },
                                        children: medicine.name
                                    }, medicine.treatmentMedicineId);
                                })
                            })
                        ]
                    }),
                    viewModel.getSelectedMedicineStrengths().length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-20 items-center pl-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "typography-ui-13sb text-gray-800",
                                    children: "처방용량"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: viewModel.getSelectedMedicineStrengths().map(function(strength) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isDispensationStrengthSelected(strength) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleDispensationStrengthClick(strength);
                                        },
                                        children: strength.unit
                                    }, "non-benefit-medicine-strength-".concat(strength.treatmentMedicineStrengthId));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-10 w-full flex-row items-center gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-20 items-center pl-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "typography-ui-13sb text-gray-800",
                                    children: "처방단위"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scrollbar-hide flex flex-1 items-center gap-2 overflow-x-auto whitespace-nowrap pr-12",
                                children: viewModel.getSelectedMedicineUnits().map(function(unit) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,style.cn)("typography-ui-13sb flex h-10 items-center px-1", viewModel.isDispensationUnitSelected(unit) ? "text-primary-700" : "typography-ui-13m text-gray-600"),
                                        onClick: function() {
                                            return viewModel.handleDispensationUnitClick(unit);
                                        },
                                        children: unit.dispensationUnitDisplayName
                                    }, unit.dispensationUnit);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ActionSheet */.Vb, {
                open: viewModel.isSortBottomSheetOpen,
                onOpenChange: function(open) {
                    return !open && viewModel.closeSortBottomSheet();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ActionSheetContent */.MG, {
                    title: "어떤 순서로 정렬할까요?",
                    closeOnOverlayClick: true,
                    children: viewModel.searchFiltersHook.pharmacySorts.map(function(sort, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* ActionSheetItem */.QI, {
                            label: sort.title,
                            selected: sort.type === viewModel.localFilterCriteria.selectedSortMethod.type,
                            onPress: function() {
                                return viewModel.handleSortSelected(sort);
                            }
                        }, "sort-".concat(index));
                    })
                })
            }),
            viewModel.isMedicineInfoOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineInfoBottomSheet/* default */.Z, {
                treatmentMedicineIds: ((ref1 = props.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.treatmentMedicines.map(function(medicine) {
                    return medicine.treatmentMedicineId;
                })) || [],
                onClickClose: viewModel.handleCloseMedicineInfo
            })
        ]
    });
};
/* harmony default export */ var ui_NonBenefitPharmacyHeaderFilter = (NonBenefitPharmacyHeaderFilter);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/LoginModal/index.tsx + 6 modules
var LoginModal = __webpack_require__(81822);
// EXTERNAL MODULE: ./src/components/molecules/Modal/SelectModal/ShareSelectModal/index.tsx + 1 modules
var ShareSelectModal = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/components/molecules/Overlay/index.tsx + 1 modules
var Overlay = __webpack_require__(78952);
// EXTERNAL MODULE: ./src/components/templates/communication/Faq/FaqTagListTemplate/index.tsx + 2 modules
var FaqTagListTemplate = __webpack_require__(9107);
// EXTERNAL MODULE: ./src/constants/logs/pharmacy/index.tsx
var logs_pharmacy = __webpack_require__(15255);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/EmptyPharmacyToast/EmptyPharmacyToast.tsx
var EmptyPharmacyToast = __webpack_require__(48929);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyCardBottomSheet/PharmacyCardBottomSheet.tsx + 3 modules
var PharmacyCardBottomSheet = __webpack_require__(74541);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyListBottomSheet/PharmacyListBottomSheet.tsx + 7 modules
var PharmacyListBottomSheet = __webpack_require__(28494);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyMapContainer/PharmacyMapContainer.tsx + 10 modules
var PharmacyMapContainer = __webpack_require__(33153);
// EXTERNAL MODULE: ./src/features/pharmacies/shared/ui/PharmacyMapHeaderTabs/PharmacyMapHeaderTabs.tsx + 1 modules
var PharmacyMapHeaderTabs = __webpack_require__(23490);
// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/pharmacy.ts
var types_pharmacy = __webpack_require__(6271);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/components/atom/icon/layout/HealthMedicalMedicines.tsx
var HealthMedicalMedicines = __webpack_require__(71305);
// EXTERNAL MODULE: ./src/components/templates/pharmacy/detail/components/PharmacyInfoHeader/index.tsx
var PharmacyInfoHeader = __webpack_require__(89584);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/map/NonBenefitMapTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n    flex-direction: column;\n    width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  height: 48px;\n  padding: 0 20px;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 8px;\n  color: white;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n    padding-top: 8px;\n  gap: 8px;;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



























var GLOBAL_HEADER_HEIGHT = 60;
var NonBenefitMapTemplate = function(param) {
    var viewModel = param.viewModel, client = param.client, title = param.title;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    var ref10 = (0,react.useState)(false), isShowShareModal = ref10[0], setShowShareModal = ref10[1];
    var diagnosisTypeId = (ref = viewModel.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisTypeId;
    var treatmentProductMedicineName = (ref1 = viewModel.selectedMedicine) === null || ref1 === void 0 ? void 0 : ref1.treatmentProductMedicineName;
    var treatmentProductShareImageUrl = (ref2 = viewModel.selectedMedicine) === null || ref2 === void 0 ? void 0 : ref2.treatmentProductShareImageUrl;
    var treatmentMedicineId = (ref3 = viewModel.selectedTreatmentMedicine) === null || ref3 === void 0 ? void 0 : ref3.treatmentMedicineId;
    var treatmentMedicineUnitId = (ref4 = viewModel.selectedTreatmentMedicineUnit) === null || ref4 === void 0 ? void 0 : ref4.treatmentMedicineUnitId;
    var handleOpenShareModal = function() {
        setShowShareModal(true);
    };
    var handleCloseShareModal = function() {
        setShowShareModal(false);
    };
    var _selectedPharmacy, ref11, ref12, ref13, _isIncludeDiagnosisPriceFilterSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqTagListTemplate/* BreadCrumbsWrapper */.X, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    visible: true,
                    breadCrumbs: viewModel.breadCrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_NonBenefitPharmacyHeader, {
                                isMobile: client.isMobile,
                                title: title,
                                handleOpenShareModal: handleOpenShareModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyMapHeaderTabs/* default */.Z, {
                                tabs: viewModel.tabs,
                                selectedTab: viewModel.selectedTab,
                                onClickTab: viewModel.onClickTab
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyMapContainer/* default */.Z, {
                                selectedPharmacy: viewModel.selectedPharmacy,
                                updatePharmacyMapInitiateError: viewModel.updatePharmacyMapInitiateError,
                                level: 6,
                                isPharmaciesLoading: viewModel.isNearbyPharmaciesLoading,
                                centerCoordinate: viewModel.currentLocation,
                                pharmacies: viewModel.pharmacies,
                                updateDongLiName: viewModel.updateDongLiName,
                                updateMapCoordinate: viewModel.updateCurrentMapCoordinate,
                                isVisibleMedicinePrice: viewModel.isVisibleMedicinePrice,
                                shouldShowDiagnosisPrice: viewModel.isIncludeDiagnosisPriceFilterSelected,
                                resetSelectedPharmacy: viewModel.resetSelectedPharmacy,
                                updateSelectedPharmacy: viewModel.updateSelectedPharmacy,
                                mapRef: viewModel.mapRef,
                                headerHeight: (client.isMobile ? 156 : 152) - GLOBAL_HEADER_HEIGHT
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyListBottomSheet/* default */.Z, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_NonBenefitPharmacyHeaderFilter, {
                            client: client,
                            selectedTab: viewModel.selectedTab,
                            defaultSort: types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice,
                            currentDongLi: viewModel.dongLiName,
                            onApplyFilter: function(filterCriteria) {
                                return viewModel.applyFilter(filterCriteria);
                            },
                            onClickCurrentLocation: viewModel.onClickCurrentLocation
                        }),
                        client: client,
                        ref: viewModel.pharmacyListBottomSheetRef,
                        scrollListRef: viewModel.scrollListRef,
                        isNearbyPharmaciesLoading: viewModel.isNearbyPharmaciesLoading,
                        pharmacies: viewModel.pharmacies,
                        onClickPharmacyItem: viewModel.onClickPharmacyItem,
                        isIncludeDiagnosisPriceFilterSelected: viewModel.isIncludeDiagnosisPriceFilterSelected,
                        isVisibleMedicinePrice: viewModel.isVisibleMedicinePrice,
                        onClickCurrentLocation: viewModel.requestGeolocationPermissionInWeb,
                        headerHeight: client.isMobile ? 150 : 146,
                        shouldTransparent: viewModel.shouldShowPharmacyCard
                    }),
                    viewModel.shouldShowPharmacyCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyCardBottomSheet/* default */.Z, {
                        pharmacy: viewModel.selectedPharmacy,
                        isVisibleMedicinePrice: viewModel.isVisibleMedicinePrice,
                        shouldShowDiagnosisPrice: viewModel.isIncludeDiagnosisPriceFilterSelected,
                        clickViewListModeButton: viewModel.onClickViewListModeButtonWithResetSelectedPharmacy,
                        shouldShowPharmacyDetail: true,
                        onClickCurrentLocation: viewModel.requestGeolocationPermissionInWeb,
                        pharmacyMainInfoComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyInfoHeader/* default */.Z, {
                            pharmacy: (_selectedPharmacy = viewModel.selectedPharmacy) !== null && _selectedPharmacy !== void 0 ? _selectedPharmacy : viewModel.pharmacies[0],
                            onClickFavoritePharmacy: function(e) {
                                var _selectedPharmacy;
                                viewModel.onClickFavoritePharmacy(e, (_selectedPharmacy = viewModel.selectedPharmacy) !== null && _selectedPharmacy !== void 0 ? _selectedPharmacy : viewModel.pharmacies[0]);
                            }
                        }),
                        client: client,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyCardBottomSheet/* default.ButtonArea */.Z.ButtonArea, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickLogger/* default */.Z, {
                                    params: {
                                        eventName: logs_pharmacy/* FindPharmacyLog.click_pharmacy_diagnosis_button */.Vq.click_pharmacy_diagnosis_button,
                                        payload: {
                                            pharmacyId: (ref11 = (ref5 = viewModel.selectedPharmacy) === null || ref5 === void 0 ? void 0 : ref5.pharmacyId) !== null && ref11 !== void 0 ? ref11 : 0,
                                            price: ((ref12 = (ref6 = viewModel.selectedPharmacy) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.pharmacyDispensableMedicines) === null || ref7 === void 0 ? void 0 : ref7.totalAmount) !== null && ref12 !== void 0 ? ref12 : 0) + ((ref13 = (ref8 = viewModel.selectedPharmacy) === null || ref8 === void 0 ? void 0 : ref8.diagnosisPrice) !== null && ref13 !== void 0 ? ref13 : 0)
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PharmacyDiagnosisActionButtonWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButton, {
                                                type: "button",
                                                onClick: viewModel.onOpenAppInstallBottomSheet,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PharmacyDiagnosisActionButtonText, {
                                                    children: (ref9 = viewModel.selectedPharmacy) === null || ref9 === void 0 ? void 0 : ref9.getFindPharmacyDiagnosisActionButtonText((_isIncludeDiagnosisPriceFilterSelected = viewModel.isIncludeDiagnosisPriceFilterSelected) !== null && _isIncludeDiagnosisPriceFilterSelected !== void 0 ? _isIncludeDiagnosisPriceFilterSelected : false, viewModel.selectedTabName, viewModel.isSelectedAllTab())
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextArea, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthMedicalMedicines/* default */.Z, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTextWrapper, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                                children: "오늘 "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedEventText, {
                                                                children: "1,379명"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventText, {
                                                                children: "이 ".concat(treatmentProductMedicineName, " 처방받았어요")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSelectModal/* default */.C, {
                isVisible: isShowShareModal,
                onClose: handleCloseShareModal,
                type: ShareSelectModal/* KAKAO_SHARE_TYPE.NON_BENEFIT_MAP */.Z.NON_BENEFIT_MAP,
                pageName: (0,logger/* getPageName */.j0)(router),
                kakaoShare: {
                    id: diagnosisTypeId !== null && diagnosisTypeId !== void 0 ? diagnosisTypeId : "",
                    subId: treatmentMedicineId !== null && treatmentMedicineId !== void 0 ? treatmentMedicineId : "",
                    title: "".concat(treatmentProductMedicineName, " 최저가 약국 찾기"),
                    content: "내 근처에서 가장 저렴한 ".concat(treatmentProductMedicineName, " 가격을 확인하고 비교할 수 있어요."),
                    imageUrl: treatmentProductShareImageUrl
                },
                copyLink: {
                    id: diagnosisTypeId !== null && diagnosisTypeId !== void 0 ? diagnosisTypeId : "",
                    copyElementId: "copyNonBenefitMap",
                    copyLinkUrl: "".concat((0,format/* formatShareUrl */.zm)(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path), "?diagnosisTypeId=").concat(diagnosisTypeId, "&treatmentMedicineId=").concat(treatmentMedicineId, "&treatmentMedicineUnitId=").concat(treatmentMedicineUnitId, "&latitude=").concat(viewModel.currentMapLocation.latitude, "&longitude=").concat(viewModel.currentMapLocation.longitude)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyPharmacyToast/* default */.Z, {
                shouldShowToast: viewModel.shouldShowEmptyPharmacyMessage()
            }),
            viewModel.showLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
                onClickOverlay: viewModel.closeLoginModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
                    isWritePage: false,
                    onClick: viewModel.closeLoginModal,
                    redirectUrl: "",
                    trackInfo: {
                        campaign: "doctor_detail",
                        content: "doctor_detail_family_doctor_add_remove",
                        buttonText: "단골 의사 추가/삭제"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var map_NonBenefitMapTemplate = (NonBenefitMapTemplate);
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ed9ce6e9-0"
})(_templateObject());
var PharmacyDiagnosisActionButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ed9ce6e9-1"
})(_templateObject1());
var PharmacyDiagnosisActionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-ed9ce6e9-2"
})(_templateObject2(), theme/* default.color.primary600 */.Z.color.primary600);
var PharmacyDiagnosisActionButtonText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ed9ce6e9-3"
})(_templateObject3(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI16SB, "\n  ");
});
var BottomWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ed9ce6e9-4"
})(_templateObject4());
var EventTextArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ed9ce6e9-5"
})(_templateObject5());
var EventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ed9ce6e9-6"
})(_templateObject6(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15M, ";\n    color: ").concat(_$theme.color.gray500, ";\n  ");
});
var HighlightedEventText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ed9ce6e9-7"
})(_templateObject7(), function(param) {
    var _$theme = param.theme;
    return "\n    ".concat(_$theme.typography.UI15SB, ";\n    color: ").concat(_$theme.color.primary700, ";\n  ");
});
var EventTextWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ed9ce6e9-8"
})(_templateObject8());

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/constants/url.ts
var url = __webpack_require__(26093);
// EXTERNAL MODULE: ./src/entities/non-benefit/index.ts + 16 modules
var non_benefit = __webpack_require__(15673);
// EXTERNAL MODULE: ./src/services/pharmacy/PharmacyPickupService.ts
var PharmacyPickupService = __webpack_require__(39826);
// EXTERNAL MODULE: ./src/utils/url.ts
var utils_url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/features/pharmacies/shared/hooks/usePharmacyViewType.ts




var usePharmacyViewType = function() {
    var router = (0,next_router.useRouter)();
    var viewType = router.query.viewType;
    var pharmacyViewType = PharmacyPickupService/* PharmacyPickupService.getPharmacyViewType */.B.getPharmacyViewType(viewType);
    var shouldShowListView = pharmacyViewType === types_pharmacy/* EPharmacyViewType.List */.DO.List;
    var toggleViewMode = function() {
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.ViewType */.Vc.ViewType,
                value: pharmacyViewType === types_pharmacy/* EPharmacyViewType.Map */.DO.Map ? types_pharmacy/* EPharmacyViewType.List */.DO.List : types_pharmacy/* EPharmacyViewType.Map */.DO.Map
            }, 
        ]);
    };
    return {
        pharmacyViewType: pharmacyViewType,
        shouldShowListView: shouldShowListView,
        toggleViewMode: toggleViewMode
    };
};
/* harmony default export */ var hooks_usePharmacyViewType = (usePharmacyViewType);

// EXTERNAL MODULE: ./src/parsers/f2f/common/index.ts
var f2f_common = __webpack_require__(89325);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
;// CONCATENATED MODULE: ./src/hooks/common/useWebLocation.ts








var useWebLocation = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), dongLiName = ref[0], setDongLiName = ref[1];
    var showToast = (0,useToast/* default */.Z)().showToast;
    var _query = router.query, latitude = _query.latitude, longitude = _query.longitude;
    var currentLocation = (0,f2f_common/* getCoordinate */.FY)(latitude, longitude);
    var updateSearchParamsLocation = function(param) {
        var latitude = param.latitude, longitude = param.longitude;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.Latitude */.Vc.Latitude,
                value: latitude
            },
            {
                key: types_pharmacy/* PharmacySearchParamsQueries.Longitude */.Vc.Longitude,
                value: longitude
            }, 
        ]);
    };
    var requestGeolocationPermissionInWeb = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
            var isToast;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isToast = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                if (!navigator.geolocation) {
                    return [
                        2
                    ];
                }
                navigator.geolocation.getCurrentPosition(function(param) {
                    var coords = param.coords;
                    updateSearchParamsLocation({
                        latitude: coords.latitude,
                        longitude: coords.longitude
                    });
                    callback && callback({
                        latitude: coords.latitude,
                        longitude: coords.longitude
                    });
                }, function() {
                    if (!isToast) return;
                    showToast({
                        message: "위치 권한 허용 후 다시 시도해주세요"
                    });
                }, {
                    enableHighAccuracy: false,
                    timeout: 7000
                });
                return [
                    2
                ];
            });
        });
        return function requestGeolocationPermissionInWeb(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateDongLiName = function(currentDongLiName) {
        setDongLiName(currentDongLiName);
    };
    return {
        dongLiName: dongLiName,
        currentLocation: currentLocation,
        updateDongLiName: updateDongLiName,
        requestGeolocationPermissionInWeb: requestGeolocationPermissionInWeb
    };
};
/* harmony default export */ var common_useWebLocation = (useWebLocation);

// EXTERNAL MODULE: ./src/hooks/pharmacy/useFilteredAndSortedPharmacy.ts
var useFilteredAndSortedPharmacy = __webpack_require__(95782);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useFindGeneralListOfNearbyPharmacyV3ByUser.ts
var useFindGeneralListOfNearbyPharmacyV3ByUser = __webpack_require__(79832);
// EXTERNAL MODULE: ./src/hooks/pharmacy/usePharmacySearchFilters.ts
var usePharmacySearchFilters = __webpack_require__(41841);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/views/non-benefit/index.ts + 2 modules
var views_non_benefit = __webpack_require__(13650);
// EXTERNAL MODULE: ./src/constants/map/index.ts
var map = __webpack_require__(13805);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/entities/non-benefit/hooks/useGetNonBenefitDiagnosisPriceSupportInvitationCode.ts
var useGetNonBenefitDiagnosisPriceSupportInvitationCode = __webpack_require__(80316);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/hooks/login/useLoginViewModel.ts
var useLoginViewModel = __webpack_require__(97110);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useAddFavoritePharmacy.ts
var useAddFavoritePharmacy = __webpack_require__(47272);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useFavoritePharmacies.ts
var useFavoritePharmacies = __webpack_require__(8201);
// EXTERNAL MODULE: ./src/hooks/pharmacy/useRemoveFavoritePharmacy.ts
var useRemoveFavoritePharmacy = __webpack_require__(43928);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/hooks/useToaster.tsx
var useToaster = __webpack_require__(37643);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/nonBenefit.gql.impl.tsx


var NonBenefitMapNearbyPharmacySearchTabsDocument = "\n    query NonBenefitMapNearbyPharmacySearchTabs {\n  nonBenefitMapNearbyPharmacySearchTabs {\n    id\n    name\n    diagnosisType\n    diagnosisTypeId\n    sortTypes {\n      type\n      title\n    }\n    filters {\n      type\n      title\n      description\n      mode\n      activeIconUrl\n      inactiveIconUrl\n      subFilters {\n        type\n        title\n        description\n        mode\n        inactiveIconUrl\n        activeIconUrl\n      }\n    }\n    treatmentMedicines {\n      id\n      treatmentId\n      name\n      description\n      dispensationUnits {\n        isDefault\n        dispensationUnit\n        dispensationUnitDisplayName\n        treatmentMedicineId\n        treatmentMedicineUnitId\n      }\n      treatmentMedicineStrengths {\n        treatmentMedicineStrengthId\n        unit\n        treatmentMedicineId\n        isDefault\n      }\n    }\n  }\n}\n    ";
var useNonBenefitMapNearbyPharmacySearchTabsQuery = function(variables, options) {
    return (0,useQuery/* useQuery */.a)(variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ], (0,fetcher/* gqlFetcher */.l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables), options);
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ];
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher = function(variables, options) {
    return (0,fetcher/* gqlFetcher */.l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables, options);
};

// EXTERNAL MODULE: ./src/services/pharmacy/TreatmentMedicineService.ts
var TreatmentMedicineService = __webpack_require__(81723);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMapNearbyPharmacySearchTabs.ts







// 타입 변환 매퍼 함수
var mapToPharmacyFilterMode = function(mode) {
    // PharmacyFilterMode와 EPharmacyFilterMode는 동일한 값을 가지므로 직접 매핑 가능
    switch(mode){
        case gql_schema/* PharmacyFilterMode.List */.T4Y.List:
            return types_pharmacy/* EPharmacyFilterMode.List */.LR.List;
        case gql_schema/* PharmacyFilterMode.Toggle */.T4Y.Toggle:
            return types_pharmacy/* EPharmacyFilterMode.Toggle */.LR.Toggle;
        case gql_schema/* PharmacyFilterMode.Range */.T4Y.Range:
            return types_pharmacy/* EPharmacyFilterMode.Range */.LR.Range;
        default:
            return types_pharmacy/* EPharmacyFilterMode.Toggle */.LR.Toggle;
    }
};
var mapToPharmacySearchFilterType = function(type) {
    // PharmacyFilterType을 ENearbyPharmacySearchFilterType으로 매핑
    switch(type){
        case gql_schema/* PharmacyFilterType.ConfirmedDispensation */.A1u.ConfirmedDispensation:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.ConfirmedDispensation */.aT.ConfirmedDispensation;
        case gql_schema/* PharmacyFilterType.DispensationProbability */.A1u.DispensationProbability:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.DispensationProbability */.aT.DispensationProbability;
        case gql_schema/* PharmacyFilterType.HandlingMedicine */.A1u.HandlingMedicine:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.HandlingMedicine */.aT.HandlingMedicine;
        case gql_schema/* PharmacyFilterType.HighDispensationProbability */.A1u.HighDispensationProbability:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.HighDispensationProbability */.aT.HighDispensationProbability;
        case gql_schema/* PharmacyFilterType.IncludeDiagnosisPrice */.A1u.IncludeDiagnosisPrice:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */.aT.IncludeDiagnosisPrice;
        case gql_schema/* PharmacyFilterType.IsOpenAtLateNight */.A1u.IsOpenAtLateNight:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IsOpenAtLateNight */.aT.IsOpenAtLateNight;
        case gql_schema/* PharmacyFilterType.IsOpenEveryDay */.A1u.IsOpenEveryDay:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.IsOpenEveryDay */.aT.IsOpenEveryDay;
        case gql_schema/* PharmacyFilterType.Now */.A1u.Now:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.Now */.aT.Now;
        case gql_schema/* PharmacyFilterType.Operating */.A1u.Operating:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.Operating */.aT.Operating;
        case gql_schema/* PharmacyFilterType.PossibleDispensation */.A1u.PossibleDispensation:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.PossibleDispensation */.aT.PossibleDispensation;
        case gql_schema/* PharmacyFilterType.RequestWithApp */.A1u.RequestWithApp:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.RequestWithApp */.aT.RequestWithApp;
        case gql_schema/* PharmacyFilterType.SameMedicine */.A1u.SameMedicine:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.SameMedicine */.aT.SameMedicine;
        // FavoritePharmacy, Partnership, TreatmentMedicine는 없으므로 기본값 반환
        default:
            return types_pharmacy/* ENearbyPharmacySearchFilterType.CheapPrice */.aT.CheapPrice;
    }
};
var mapToPharmacySortsVo = function(sort) {
    // PharmacySortType을 ENearbyPharmacySearchSortType으로 매핑
    var sortType;
    switch(sort.type){
        case gql_schema/* PharmacySortType.Distance */.f$c.Distance:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.Distance */.sZ.Distance;
            break;
        case gql_schema/* PharmacySortType.LowPrice */.f$c.LowPrice:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice;
            break;
        case gql_schema/* PharmacySortType.QuickReceipt */.f$c.QuickReceipt:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.QuickReceipt */.sZ.QuickReceipt;
            break;
        case gql_schema/* PharmacySortType.VisitCount */.f$c.VisitCount:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.VisitCount */.sZ.VisitCount;
            break;
        case gql_schema/* PharmacySortType.MostReviews */.f$c.MostReviews:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.MostReviews */.sZ.MostReviews;
            break;
        case gql_schema/* PharmacySortType.HighRating */.f$c.HighRating:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.HighRating */.sZ.HighRating;
            break;
        // DispensationProbability는 ENearbyPharmacySearchSortType에 없음 -> 기본값 사용
        default:
            sortType = types_pharmacy/* ENearbyPharmacySearchSortType.QuickReceipt */.sZ.QuickReceipt;
    }
    return {
        title: sort.title,
        type: sortType
    };
};
var parseNonBenefitMapNearByPharmacySearchTabsVo = function(data) {
    return data.nonBenefitMapNearbyPharmacySearchTabs.map(function(item) {
        var _diagnosisTypeId;
        return {
            id: item.id,
            name: item.name,
            diagnosisType: item.diagnosisType,
            diagnosisTypeId: (_diagnosisTypeId = item.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : null,
            filters: item.filters.map(function(filter) {
                var _activeIconUrl, _inactiveIconUrl, _title, _description;
                return new models_pharmacy/* NearbyPharmacyFilterModel */.QJ({
                    activeIconUrl: (_activeIconUrl = filter.activeIconUrl) !== null && _activeIconUrl !== void 0 ? _activeIconUrl : undefined,
                    inactiveIconUrl: (_inactiveIconUrl = filter.inactiveIconUrl) !== null && _inactiveIconUrl !== void 0 ? _inactiveIconUrl : undefined,
                    mode: mapToPharmacyFilterMode(filter.mode),
                    title: (_title = filter.title) !== null && _title !== void 0 ? _title : "",
                    description: (_description = filter.description) !== null && _description !== void 0 ? _description : "",
                    type: mapToPharmacySearchFilterType(filter.type),
                    subFilters: filter.subFilters.map(function(subFilter) {
                        var _title, _description;
                        return new models_pharmacy/* NearbyPharmacyFilterModel */.QJ({
                            mode: mapToPharmacyFilterMode(subFilter.mode),
                            title: (_title = subFilter.title) !== null && _title !== void 0 ? _title : "",
                            description: (_description = subFilter.description) !== null && _description !== void 0 ? _description : "",
                            type: mapToPharmacySearchFilterType(subFilter.type),
                            subFilters: []
                        });
                    })
                });
            }),
            sortTypes: item.sortTypes.map(function(type) {
                return mapToPharmacySortsVo(type);
            }),
            treatmentMedicines: item.treatmentMedicines.map(function(medicine) {
                var _description;
                return {
                    treatmentMedicineId: medicine.id,
                    treatmentId: medicine.treatmentId,
                    name: medicine.name,
                    description: (_description = medicine.description) !== null && _description !== void 0 ? _description : undefined,
                    isNew: TreatmentMedicineService/* default.isNewMedicine */.Z.isNewMedicine(medicine.id),
                    treatmentMedicineStrengths: medicine.treatmentMedicineStrengths.map(function(strength) {
                        return {
                            treatmentMedicineStrengthId: strength.treatmentMedicineStrengthId,
                            treatmentMedicineId: strength.treatmentMedicineId,
                            unit: strength.unit,
                            isDefault: strength.isDefault
                        };
                    }),
                    dispensationUnits: medicine.dispensationUnits.map(function(unit) {
                        return {
                            isDefault: unit.isDefault,
                            dispensationUnit: unit.dispensationUnit,
                            dispensationUnitDisplayName: unit.dispensationUnitDisplayName,
                            treatmentMedicineId: Number(unit.treatmentMedicineId),
                            treatmentMedicineUnitId: Number(unit.treatmentMedicineUnitId)
                        };
                    })
                };
            })
        };
    });
};
var useNonBenefitMapNearByPharmacySearchTabs = function() {
    var ref = useNonBenefitMapNearbyPharmacySearchTabsQuery({}, {
        select: parseNonBenefitMapNearByPharmacySearchTabsVo,
        staleTime: 1000 * 60 * 5
    }), _data = ref.data, data = _data === void 0 ? [] : _data;
    return {
        data: data
    };
};
/* harmony default export */ var useNonBenefitMapNearbyPharmacySearchTabs = (useNonBenefitMapNearByPharmacySearchTabs);
var fetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey({}), useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher({}))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        parseNonBenefitMapNearByPharmacySearchTabsVo(response)
                    ];
            }
        });
    });
    return function fetchQuery(queryClient) {
        return _ref.apply(this, arguments);
    };
}();
useNonBenefitMapNearByPharmacySearchTabs.fetchQuery = fetchQuery;

;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMapCategoryTabs.ts








var useNonBenefitMapCategoryTabs = function() {
    var router = (0,next_router.useRouter)();
    var _query = router.query, _diagnosisTypeId = _query.diagnosisTypeId, diagnosisTypeId = _diagnosisTypeId === void 0 ? "" : _diagnosisTypeId, _treatmentMedicineId = _query.treatmentMedicineId, treatmentMedicineId = _treatmentMedicineId === void 0 ? "" : _treatmentMedicineId, _treatmentMedicineUnitId = _query.treatmentMedicineUnitId, treatmentMedicineUnitId = _treatmentMedicineUnitId === void 0 ? "" : _treatmentMedicineUnitId, _treatmentMedicineStrengthId = _query.treatmentMedicineStrengthId, treatmentMedicineStrengthId = _treatmentMedicineStrengthId === void 0 ? "" : _treatmentMedicineStrengthId;
    var ref = useNonBenefitMapNearbyPharmacySearchTabs(), tabs = ref.data;
    var selectedTab = (0,react.useMemo)(function() {
        var ref;
        return (ref = tabs.find(function(tab) {
            return tab.diagnosisTypeId === diagnosisTypeId;
        })) !== null && ref !== void 0 ? ref : tabs[0];
    }, [
        tabs,
        diagnosisTypeId
    ]);
    var selectedTreatmentMedicine = (0,react.useMemo)(function() {
        var ref;
        return (ref = selectedTab.treatmentMedicines.find(function(medicine) {
            return medicine.treatmentMedicineId === treatmentMedicineId;
        })) !== null && ref !== void 0 ? ref : selectedTab.treatmentMedicines[0];
    }, [
        selectedTab,
        treatmentMedicineId
    ]);
    var selectedTreatmentMedicineUnit = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = (ref = selectedTreatmentMedicine.dispensationUnits.findLast(function(unit) {
            return unit.treatmentMedicineUnitId === Number(treatmentMedicineUnitId);
        })) !== null && ref !== void 0 ? ref : selectedTreatmentMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        })) !== null && ref1 !== void 0 ? ref1 : selectedTreatmentMedicine.dispensationUnits[0];
    }, [
        selectedTreatmentMedicine,
        treatmentMedicineUnitId
    ]);
    var selectedTreatmentMedicineStrength = (0,react.useMemo)(function() {
        if (!selectedTreatmentMedicine.treatmentMedicineStrengths.length) return null;
        var ref;
        return (ref = selectedTreatmentMedicine.treatmentMedicineStrengths.find(function(strength) {
            return strength.treatmentMedicineStrengthId === treatmentMedicineStrengthId;
        })) !== null && ref !== void 0 ? ref : selectedTreatmentMedicine.treatmentMedicineStrengths[0];
    }, [
        selectedTreatmentMedicine,
        treatmentMedicineStrengthId
    ]);
    var shouldIncludeDiagnosisPrice = selectedTab.filters.some(function(filter) {
        return filter.type === types_pharmacy/* ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */.aT.IncludeDiagnosisPrice;
    });
    var log = (0,useLogger/* default */.Z)().log;
    var selectTab = function(tab) {
        var defaultTreatmentMedicine = tab.treatmentMedicines[0];
        var defaultDispensationUnit = defaultTreatmentMedicine.dispensationUnits.find(function(unit) {
            return unit.isDefault;
        }) || defaultTreatmentMedicine.dispensationUnits[0];
        var defaultTreatmentMedicineStrength = defaultTreatmentMedicine.treatmentMedicineStrengths.length > 0 ? defaultTreatmentMedicine.treatmentMedicineStrengths.find(function(strength) {
            return strength.isDefault;
        }) || defaultTreatmentMedicine.treatmentMedicineStrengths[0] : null;
        var _diagnosisType, _diagnosisTypeId, _treatmentMedicineId, _treatmentMedicineUnitId, _treatmentMedicineStrengthId;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: "diagnosisType",
                value: (_diagnosisType = tab.diagnosisType) !== null && _diagnosisType !== void 0 ? _diagnosisType : ""
            },
            {
                key: "diagnosisTypeId",
                value: (_diagnosisTypeId = tab.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : ""
            },
            {
                key: "treatmentMedicineId",
                value: (_treatmentMedicineId = defaultTreatmentMedicine.treatmentMedicineId) !== null && _treatmentMedicineId !== void 0 ? _treatmentMedicineId : ""
            },
            {
                key: "treatmentMedicineUnitId",
                value: (_treatmentMedicineUnitId = defaultDispensationUnit.treatmentMedicineUnitId) !== null && _treatmentMedicineUnitId !== void 0 ? _treatmentMedicineUnitId : ""
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(defaultTreatmentMedicineStrength ? [
            {
                key: "treatmentMedicineStrengthId",
                value: (_treatmentMedicineStrengthId = defaultTreatmentMedicineStrength.treatmentMedicineStrengthId) !== null && _treatmentMedicineStrengthId !== void 0 ? _treatmentMedicineStrengthId : ""
            }, 
        ] : [
            {
                key: "treatmentMedicineStrengthId",
                value: ""
            }
        ])));
        log({
            eventName: "".concat(pharmacy/* FindPharmacyDdAction.ClickTab */.vy.ClickTab, "-").concat(tab.id)
        });
    };
    return {
        tabs: tabs,
        selectedTab: selectedTab,
        selectTab: selectTab,
        selectedTreatmentMedicine: selectedTreatmentMedicine,
        selectedTreatmentMedicineUnit: selectedTreatmentMedicineUnit,
        selectedTreatmentMedicineStrength: selectedTreatmentMedicineStrength,
        shouldIncludeDiagnosisPrice: shouldIncludeDiagnosisPrice
    };
};
/* harmony default export */ var nonBenefit_useNonBenefitMapCategoryTabs = (useNonBenefitMapCategoryTabs);

;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMapViewModel.tsx




































var airbrigdeLink = "https://abr.ge/w3tbbv";
var useNonBenefitMapViewModel = function(client) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    var navigate = (0,useNavigate/* default */.Z)();
    var queries = router.query;
    var ref10 = nonBenefit_useNonBenefitMapCategoryTabs(), tabs = ref10.tabs, selectedTab = ref10.selectedTab, selectTab = ref10.selectTab, selectedTreatmentMedicine = ref10.selectedTreatmentMedicine, selectedTreatmentMedicineUnit = ref10.selectedTreatmentMedicineUnit;
    var toast = (0,index_es/* useToast */.pm)().toast;
    var mapRef = (0,react.useRef)(null);
    var pharmacyListBottomSheetRef = (0,react.useRef)(null);
    var ref11 = (0,useModal/* default */.Z)(), showModal = ref11.showModal, closeModal = ref11.closeModal;
    var breadCrumbs = [
        {
            label: "최저가 약국 찾기",
            url: common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path + (0,utils_url/* addQueryString */.sC)(queries),
            logName: "non_benefit_map"
        }, 
    ];
    var scrollListRef = (0,react.useRef)(null);
    var userLocationHook = common_useWebLocation();
    var ref12 = (0,react.useState)(null), selectedPharmacy = ref12[0], setSelectedPharmacy = ref12[1];
    var ref13 = (0,react.useState)(null), pharmacyMapInitiateError = ref13[0], setPharmacyMapInitiateError = ref13[1];
    var ref14 = (0,react.useState)(null), pharmacyFilterCriteria = ref14[0], setPharmacyFilterCriteria = ref14[1];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var addFavoritePharmacyMutation = (0,useAddFavoritePharmacy/* default */.Z)().addFavoritePharmacyMutation;
    var removeFavoritePharmacyMutation = (0,useRemoveFavoritePharmacy/* default */.Z)().removeFavoritePharmacyMutation;
    var invitationCode = (0,useGetNonBenefitDiagnosisPriceSupportInvitationCode/* default */.Z)().invitationCode;
    var showToast = (0,useToaster/* default */.Z)().showToast;
    var log = (0,useLogger/* default */.Z)().log;
    var loginViewModel = (0,useLoginViewModel/* default */.Z)();
    var ref15 = (0,react.useState)(false), showLoginModal = ref15[0], setShowLoginModal = ref15[1];
    var openLoginModal = function() {
        setShowLoginModal(true);
    };
    var closeLoginModal = function() {
        setShowLoginModal(false);
    };
    var shouldShowPharmacyCard = !!selectedPharmacy;
    var updateSelectedPharmacy = function(pharmacy) {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.SelectPharmacy */.$.SelectPharmacy, {
            drug: selectedMedicine.medicineDisplayName
        });
        setSelectedPharmacy(pharmacy);
        if (pharmacyListBottomSheetRef.current) {
            var ref;
            (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.setInitialSnapPoint();
        }
    };
    var resetSelectedPharmacy = function() {
        setSelectedPharmacy(null);
        if (pharmacyListBottomSheetRef.current) {
            var ref;
            (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.setInitialSnapPoint();
        }
    };
    var updatePharmacyMapInitiateError = function(error) {
        setPharmacyMapInitiateError(error);
    };
    var pharmacyViewTypeHook = hooks_usePharmacyViewType();
    var ref16, ref17, _type;
    var searchFiltersHook = (0,usePharmacySearchFilters/* default */.Z)({
        nearbyPharmacySortsAndFilters: {
            filters: (ref16 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.filters) !== null && ref16 !== void 0 ? ref16 : [],
            sorts: (ref17 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.sortTypes) !== null && ref17 !== void 0 ? ref17 : []
        },
        defaultSortType: (_type = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.sortTypes[0].type) !== null && _type !== void 0 ? _type : types_pharmacy/* ENearbyPharmacySearchSortType.LowPrice */.sZ.LowPrice
    });
    var ref18, ref19;
    var ref20 = (0,useFindGeneralListOfNearbyPharmacyV3ByUser/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchFiltersHook.getBoundaryEastWestLongitudeAndLatitude(!!pharmacyMapInitiateError)), {
        latitude: searchFiltersHook.mapCoordinates.latitude,
        longitude: searchFiltersHook.mapCoordinates.longitude,
        diagnosisType: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref = pharmacyFilterCriteria.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisType,
        diagnosisTypeId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref1 = pharmacyFilterCriteria.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.diagnosisTypeId,
        treatmentMedicineId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref2 = pharmacyFilterCriteria.selectedMedicine) === null || ref2 === void 0 ? void 0 : ref2.treatmentMedicineId,
        dispensationUnit: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref3 = pharmacyFilterCriteria.selectedMedicine) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.dispensationUnit) === null || ref4 === void 0 ? void 0 : ref4.dispensationUnit,
        treatmentMedicineStrengthId: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref5 = pharmacyFilterCriteria.selectedMedicine) === null || ref5 === void 0 ? void 0 : ref5.treatmentMedicineStrengthId,
        shouldIncludeDiagnosisPrice: (ref19 = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref6 = pharmacyFilterCriteria.selectedTab) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.filters) === null || ref7 === void 0 ? void 0 : ref7.some(function(filter) {
            return filter.type === types_pharmacy/* ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */.aT.IncludeDiagnosisPrice;
        })) && (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref8 = pharmacyFilterCriteria.includeDiagnosisPriceFilter) === null || ref8 === void 0 ? void 0 : ref8.isSelectedFilter((ref18 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedCommonFilters) !== null && ref18 !== void 0 ? ref18 : []))) !== null && ref19 !== void 0 ? ref19 : false
    })), rawPharmacyList = ref20.data, isNearbyPharmaciesLoading = ref20.isLoading, isVisibleMedicinePrice = ref20.isVisibleMedicinePrice;
    var ref21;
    var ref22 = (0,useFilteredAndSortedPharmacy/* default */.Z)({
        filters: (ref21 = pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedCommonFilters) !== null && ref21 !== void 0 ? ref21 : [],
        sortType: pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : pharmacyFilterCriteria.selectedSortMethod.type,
        pharmacyQueryData: {
            isLoading: isNearbyPharmaciesLoading,
            rawPharmacyData: rawPharmacyList !== null && rawPharmacyList !== void 0 ? rawPharmacyList : []
        },
        shouldFilterByPriceMedicine: !!(pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref9 = pharmacyFilterCriteria.selectedMedicine) === null || ref9 === void 0 ? void 0 : ref9.treatmentMedicine.treatmentMedicineId)
    }), pharmacies = ref22.refinedPharmacy, isDataReady = ref22.isDataReady;
    var shouldShowEmptyPharmacyMessage = function() {
        if (isNearbyPharmaciesLoading || !isDataReady) {
            return false;
        }
        if (pharmacies.length === 0) {
            return true;
        }
        return false;
    };
    var parseSelectNonBenefitMedicine = function() {
        var _medicineCode, _description, _diagnosisTypeId;
        var defaultValue = {
            id: selectedTreatmentMedicine.treatmentMedicineId,
            medicineName: selectedTreatmentMedicine.name,
            medicineCode: (_medicineCode = selectedTreatmentMedicine.medicineCode) !== null && _medicineCode !== void 0 ? _medicineCode : "",
            medicineDescription: (_description = selectedTreatmentMedicine.description) !== null && _description !== void 0 ? _description : "",
            units: [],
            treatment: {
                id: (_diagnosisTypeId = selectedTab.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : "",
                name: selectedTab.name,
                isBenefit: false,
                categoryId: ""
            }
        };
        return new non_benefit/* NonBenefitMedicineModel */.w6(defaultValue);
    };
    var onClickViewListModeButtonWithResetSelectedPharmacy = function() {
        var ref;
        resetSelectedPharmacy();
        (ref = pharmacyListBottomSheetRef.current) === null || ref === void 0 ? void 0 : ref.clickViewListModeButton();
    };
    var selectedMedicine = parseSelectNonBenefitMedicine();
    var onClickPharmacyItem = function(selectPharmacy) {
        if (pharmacyMapInitiateError) {
            return;
        }
        setSelectedPharmacy(selectPharmacy);
    };
    var scrollToTop = function() {
        var ref;
        (ref = scrollListRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            top: 0
        });
    };
    var applyFilter = function(filterCriteria) {
        var ref, ref1, ref2;
        scrollToTop();
        setPharmacyFilterCriteria(filterCriteria);
        var _treatmentMedicineId, _treatmentMedicineUnitId, ref3;
        (0,utils_url/* updateSearchParams */.aM)([
            {
                key: "treatmentMedicineId",
                value: (_treatmentMedicineId = (ref = filterCriteria.selectedMedicine) === null || ref === void 0 ? void 0 : ref.treatmentMedicine.treatmentMedicineId) !== null && _treatmentMedicineId !== void 0 ? _treatmentMedicineId : ""
            },
            {
                key: "treatmentMedicineUnitId",
                value: (_treatmentMedicineUnitId = (ref1 = filterCriteria.selectedMedicine) === null || ref1 === void 0 ? void 0 : ref1.dispensationUnit.treatmentMedicineUnitId) !== null && _treatmentMedicineUnitId !== void 0 ? _treatmentMedicineUnitId : ""
            },
            {
                key: "treatmentMedicineStrengthId",
                value: (ref3 = (ref2 = filterCriteria.selectedMedicine) === null || ref2 === void 0 ? void 0 : ref2.treatmentMedicineStrengthId) !== null && ref3 !== void 0 ? ref3 : ""
            }, 
        ]);
    };
    var ref23 = (0,react.useState)({
        latitude: map/* DOCTOR_NOW_COMPANY_LATITUDE */.q,
        longitude: map/* DOCTOR_NOW_COMPANY_LONGITUDE */.y
    }), currentMapLocation = ref23[0], setCurrentMapLocation = ref23[1];
    var updateCurrentMapCoordinate = function(southWest, northEast) {
        var ref;
        searchFiltersHook.updateMapCoordinate(southWest, northEast);
        var mapCenterLatLng = (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.getCenterLatLng();
        var latitude = mapCenterLatLng === null || mapCenterLatLng === void 0 ? void 0 : mapCenterLatLng.latitude;
        var longitude = mapCenterLatLng === null || mapCenterLatLng === void 0 ? void 0 : mapCenterLatLng.longitude;
        if (!latitude || !longitude) {
            return;
        }
        setCurrentMapLocation({
            latitude: latitude,
            longitude: longitude
        });
    };
    var isSelectedAllTab = function() {
        var ref, ref1, ref2;
        // 전체 탭의 세부 정보 (서버에서 내려옴)
        var ALL_TAB_INFO = {
            name: "전체",
            diagnosisTypeId: null,
            diagnosisType: null
        };
        var isSameDiagnosisTypeWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref = pharmacyFilterCriteria.selectedTab) === null || ref === void 0 ? void 0 : ref.diagnosisType) === ALL_TAB_INFO.diagnosisType;
        var isSameDiagnosisTypeIdWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref1 = pharmacyFilterCriteria.selectedTab) === null || ref1 === void 0 ? void 0 : ref1.diagnosisTypeId) === ALL_TAB_INFO.diagnosisTypeId;
        var isSameNameWithAllTab = (pharmacyFilterCriteria === null || pharmacyFilterCriteria === void 0 ? void 0 : (ref2 = pharmacyFilterCriteria.selectedTab) === null || ref2 === void 0 ? void 0 : ref2.name) === ALL_TAB_INFO.name;
        var ref3;
        return (ref3 = isSameDiagnosisTypeWithAllTab && isSameDiagnosisTypeIdWithAllTab && isSameNameWithAllTab) !== null && ref3 !== void 0 ? ref3 : false;
    };
    var getFavoritePharmacyClickEventName = function(isFavorite) {
        var viewType = pharmacyViewTypeHook.shouldShowListView ? "list" : "map";
        if (isFavorite) {
            return "".concat(pharmacy/* PharmacyDdAction.ClickRemoveFavoritePharmacy */.Fe.ClickRemoveFavoritePharmacy, "_find_").concat(viewType);
        }
        return "".concat(pharmacy/* PharmacyDdAction.ClickAddFavoritePharmacy */.Fe.ClickAddFavoritePharmacy, "_find_").concat(viewType);
    };
    var onClickOpenAppInstallLink = function() {
        airbridge/* default.setDeepLink */.Z.setDeepLink({
            buttonID: "pharmacy-map",
            deeplinkUrl: "".concat(airbrigdeLink).concat(invitationCode ? "?invitationCode=".concat(invitationCode) : ""),
            ctaParams: {
                cta_param_1: "최저가 약국 지도",
                cta_param_2: selectedMedicine.medicineName,
                cta_param_3: selectedMedicine.treatment.name
            }
        });
    };
    var onClickCopyInvitationCode = function() {
        if (navigator.clipboard) {
            toast({
                text: "복사가 완료되었습니다"
            });
            navigator.clipboard.writeText(invitationCode !== null && invitationCode !== void 0 ? invitationCode : "");
        }
    };
    var onOpenAppInstallBottomSheet = function() {
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, {
            drug: selectedMedicine.medicineDisplayName
        });
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_non_benefit/* DiagnosisAppInstallBottomSheet */.Cx, {
                    client: client,
                    buttonId: "pharmacy-map",
                    treatmentProductMedicineName: selectedMedicine.treatmentProductMedicineName,
                    invitationCode: invitationCode,
                    onClose: closeModal,
                    qrCodeUrl: "".concat(airbrigdeLink).concat(invitationCode ? "?invitationCode=".concat(invitationCode) : ""),
                    onClickOpenAppInstallLink: onClickOpenAppInstallLink,
                    onClickCopyInvitationCode: onClickCopyInvitationCode
                })
            }
        });
    };
    var onClickTab = function(tab) {
        selectTab(tab);
        resetSelectedPharmacy();
    };
    var addFavoritePharmacy = function(pharmacy) {
        addFavoritePharmacyMutation({
            pharmacyId: pharmacy.pharmacyId
        }, {
            onSuccess: function() {
                showToast("단골 약국으로 지정했어요.\n더보기 메뉴에서 확인할 수 있어요.");
                pharmacy.updateFavoritePharmacy(true);
                // 단골 약국 캐시 업데이트
                useFavoritePharmacies/* default.updateFavoritePharmacyStatus */.Z.updateFavoritePharmacyStatus(queryClient, pharmacy.pharmacyId, true);
            },
            onError: function(error) {
                showToast(error.message);
            }
        });
    };
    var removeFavoritePharmacy = function(pharmacy) {
        removeFavoritePharmacyMutation({
            pharmacyId: pharmacy.pharmacyId
        }, {
            onSuccess: function() {
                showToast("단골 약국에서 제외했어요.");
                pharmacy.updateFavoritePharmacy(false);
                // 단골 약국 캐시 업데이트
                useFavoritePharmacies/* default.updateFavoritePharmacyStatus */.Z.updateFavoritePharmacyStatus(queryClient, pharmacy.pharmacyId, false);
            }
        });
    };
    var onClickFavoritePharmacy = function(e, pharmacy) {
        e.stopPropagation();
        if (!(client === null || client === void 0 ? void 0 : client.isWebView) && !loginViewModel.isLoggedIn) {
            openLoginModal();
            return;
        }
        if (pharmacy.isFavoritePharmacy) {
            return removeFavoritePharmacy(pharmacy);
        }
        addFavoritePharmacy(pharmacy);
    };
    var openNowPharmacyInfo = function() {
        log({
            eventName: "".concat(pharmacy/* FindPharmacyDdAction.ClickNowInfoInFind */.vy.ClickNowInfoInFind)
        });
        navigate.navigateToPureWebViewAppScreen({
            uri: url/* OutLinks.StockConfirmInfo */.s.StockConfirmInfo
        });
    };
    var onClickCurrentLocation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // useWebLocation을 이용한 구현
                userLocationHook.requestGeolocationPermissionInWeb(function(param) {
                    var latitude = param.latitude, longitude = param.longitude;
                    var ref;
                    if (pharmacyMapInitiateError) {
                        return;
                    }
                    (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setCenter(latitude, longitude);
                }, true);
                return [
                    2
                ];
            });
        });
        return function onClickCurrentLocation() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!selectedMedicine.medicineDisplayName) {
            return;
        }
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, {
            drug: selectedMedicine.medicineDisplayName
        });
    }, [
        selectedMedicine.medicineDisplayName
    ]);
    var ref24;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        breadCrumbs: breadCrumbs
    }, userLocationHook, searchFiltersHook), {
        isNearbyPharmaciesLoading: isNearbyPharmaciesLoading,
        pharmacies: pharmacies,
        scrollListRef: scrollListRef,
        selectedTreatmentMedicine: selectedTreatmentMedicine,
        selectedTreatmentMedicineUnit: selectedTreatmentMedicineUnit,
        queries: queries,
        selectedMedicine: selectedMedicine,
        currentMapLocation: currentMapLocation,
        selectedPharmacy: selectedPharmacy,
        mapRef: mapRef,
        pharmacyListBottomSheetRef: pharmacyListBottomSheetRef,
        tabs: tabs,
        selectedTab: selectedTab,
        selectedTabName: (ref24 = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.name) !== null && ref24 !== void 0 ? ref24 : "탈모약",
        shouldShowPharmacyCard: shouldShowPharmacyCard,
        selectTab: selectTab,
        onClickTab: onClickTab,
        shouldShowEmptyPharmacyMessage: shouldShowEmptyPharmacyMessage,
        updateCurrentMapCoordinate: updateCurrentMapCoordinate,
        applyFilter: applyFilter,
        updateSelectedPharmacy: updateSelectedPharmacy,
        resetSelectedPharmacy: resetSelectedPharmacy,
        updatePharmacyMapInitiateError: updatePharmacyMapInitiateError,
        onClickPharmacyItem: onClickPharmacyItem,
        isSelectedAllTab: isSelectedAllTab,
        onOpenAppInstallBottomSheet: onOpenAppInstallBottomSheet,
        getFavoritePharmacyClickEventName: getFavoritePharmacyClickEventName,
        onClickViewListModeButtonWithResetSelectedPharmacy: onClickViewListModeButtonWithResetSelectedPharmacy,
        openNowPharmacyInfo: openNowPharmacyInfo,
        onClickFavoritePharmacy: onClickFavoritePharmacy,
        openLoginModal: openLoginModal,
        closeLoginModal: closeLoginModal,
        showLoginModal: showLoginModal,
        onClickCurrentLocation: onClickCurrentLocation,
        isVisibleMedicinePrice: isVisibleMedicinePrice
    });
};
/* harmony default export */ var nonBenefit_useNonBenefitMapViewModel = (useNonBenefitMapViewModel);

;// CONCATENATED MODULE: ./src/pages/non-benefit/map/index.tsx
// PageDescription: 비급여 가격 지도 페이지







var NonBenefitMapPages = function(param) {
    var client = param.client;
    var viewModel = nonBenefit_useNonBenefitMapViewModel(client);
    var _queries = viewModel.queries, treatmentMedicineId = _queries.treatmentMedicineId, diagnosisTypeId = _queries.diagnosisTypeId, treatmentMedicineUnitId = _queries.treatmentMedicineUnitId, treatmentMedicineStrengthId = _queries.treatmentMedicineStrengthId;
    var selectedMedicine = viewModel.selectedMedicine;
    var ref;
    var title = "".concat((ref = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentMedicineSeoTitle) !== null && ref !== void 0 ? ref : "");
    var ref1;
    var description = "".concat((ref1 = selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentMedicineSeoDescription) !== null && ref1 !== void 0 ? ref1 : "");
    var canonical = "".concat("https://doctornow.co.kr").concat(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path).concat((0,utils_url/* addQueryString */.sC)({
        diagnosisTypeId: diagnosisTypeId,
        treatmentMedicineId: treatmentMedicineId,
        treatmentMedicineUnitId: treatmentMedicineUnitId,
        treatmentMedicineStrengthId: treatmentMedicineStrengthId
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(map_NonBenefitMapTemplate, {
                client: client,
                viewModel: viewModel,
                title: "".concat(selectedMedicine === null || selectedMedicine === void 0 ? void 0 : selectedMedicine.treatmentProductMedicineName, " 최저가 약국 찾기")
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var non_benefit_map = (NonBenefitMapPages);


/***/ }),

/***/ 89325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FY": function() { return /* binding */ getCoordinate; },
/* harmony export */   "G$": function() { return /* binding */ getHospitalSearchSortFilter; },
/* harmony export */   "Gb": function() { return /* binding */ getAvailableDoctorTimeSlotListMap; },
/* harmony export */   "JP": function() { return /* binding */ HospitalPartnership; },
/* harmony export */   "Ko": function() { return /* binding */ getHospitalSearchMode; },
/* harmony export */   "Mc": function() { return /* binding */ getHospitalCommonFilter; },
/* harmony export */   "Q_": function() { return /* binding */ HospitalSearchCommonFilter; },
/* harmony export */   "TX": function() { return /* binding */ FreeInfluenzaFilter; },
/* harmony export */   "pO": function() { return /* binding */ initializeSelectedInfluenzaFilters; },
/* harmony export */   "sO": function() { return /* binding */ initializeIsInfluenzaFiltersOpen; },
/* harmony export */   "v1": function() { return /* binding */ initializeHospitalSearchCommonFilter; },
/* harmony export */   "vR": function() { return /* binding */ HospitalSortFilter; }
/* harmony export */ });
/* unused harmony export HospitalCommonFilter */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27805);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50930);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7642);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23144);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72271);
/* harmony import */ var _types_hospital__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24396);
/* harmony import */ var _utils_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74735);













var getHospitalSearchSortFilter = function() {
    var sortType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    switch(sortType){
        case "DISTANCE":
            return new HospitalSortFilter(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.DISTANCE */ .k_.DISTANCE);
        case "REVIEW_AVERAGE_RATING":
            return new HospitalSortFilter(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.REVIEW_AVERAGE_RATING */ .k_.REVIEW_AVERAGE_RATING);
        case "REVIEW_COUNT":
            return new HospitalSortFilter(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.REVIEW_COUNT */ .k_.REVIEW_COUNT);
        case "ACCURACY":
        default:
            return new HospitalSortFilter(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.ACCURACY */ .k_.ACCURACY);
    }
};
var getCoordinate = function(queryLatitude, queryLongitude) {
    if (!queryLatitude || !queryLongitude) {
        return _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_4__/* .SearchHospitalService.initializeUserCoordinate */ .h.initializeUserCoordinate();
    }
    var latitude = lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default()(queryLatitude);
    var longitude = lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default()(queryLongitude);
    if (isNaN(latitude) || isNaN(longitude)) {
        return _services_hospital_SearchHospitalService__WEBPACK_IMPORTED_MODULE_4__/* .SearchHospitalService.initializeUserCoordinate */ .h.initializeUserCoordinate();
    }
    return {
        latitude: latitude,
        longitude: longitude
    };
};
var initializeSelectedInfluenzaFilters = function() {
    return Object.values(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalInfluenzaFilter */ .rT).reduce(function(acc, cur) {
        switch(cur){
            case _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalInfluenzaFilter.FreeInfluenza */ .rT.FreeInfluenza:
                {
                    acc[cur] = new FreeInfluenzaFilter(undefined);
                    return acc;
                }
            default:
                return acc;
        }
    }, {});
};
var initializeIsInfluenzaFiltersOpen = function() {
    return Object.values(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalInfluenzaFilter */ .rT).reduce(function(acc, cur) {
        acc["".concat(cur)] = false;
        return acc;
    }, {});
};
var initializeHospitalSearchCommonFilter = function() {
    var initHospitalSearchCommonFilter = Object.values(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType */ .x6).reduce(function(acc, cur) {
        acc["".concat(cur)] = false;
        return acc;
    }, {});
    return new HospitalSearchCommonFilter(initHospitalSearchCommonFilter);
};
var getHospitalCommonFilter = function(commonFilterQueryString) {
    var parsedCommonFilterList = (0,_utils_url__WEBPACK_IMPORTED_MODULE_3__/* .parseQueryStringToArray */ .oO)(commonFilterQueryString);
    var hospitalCommonFilters = Object.values(_types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType */ .x6).reduce(function(acc, type) {
        if (parsedCommonFilterList.includes(type)) {
            acc["".concat(type)] = true;
        } else {
            acc["".concat(type)] = false;
        }
        return acc;
    }, {});
    return new HospitalSearchCommonFilter(hospitalCommonFilters);
};
var getHospitalSearchMode = function() {
    var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    switch(mode){
        case "NEAR":
            return _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchMode.NEAR */ .LC.NEAR;
        default:
            return _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchMode.SEARCH */ .LC.SEARCH;
    }
};
var _obj;
var HOSPITAL_SEARCH_SORT_TYPE_NAME_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.ACCURACY */ .k_.ACCURACY, "관련도 순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.DISTANCE */ .k_.DISTANCE, "가까운 순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.REVIEW_AVERAGE_RATING */ .k_.REVIEW_AVERAGE_RATING, "평점 높은 순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.REVIEW_COUNT */ .k_.REVIEW_COUNT, "리뷰 많은 순"), _obj);
var _obj1;
var HOSPITAL_SEARCH_SORT_TYPE_DTO_MAP = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.ACCURACY */ .k_.ACCURACY, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .HospitalSortType.Accuracy */ .BBh.Accuracy), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.DISTANCE */ .k_.DISTANCE, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .HospitalSortType.Distance */ .BBh.Distance), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.REVIEW_AVERAGE_RATING */ .k_.REVIEW_AVERAGE_RATING, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .HospitalSortType.ReviewAverageRating */ .BBh.ReviewAverageRating), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj1, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalSearchSortType.REVIEW_COUNT */ .k_.REVIEW_COUNT, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .HospitalSortType.ReviewCount */ .BBh.ReviewCount), _obj1);
var HospitalSortFilter = /*#__PURE__*/ function() {
    "use strict";
    function HospitalSortFilter(type) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, HospitalSortFilter);
        this.type = type;
    }
    var _proto = HospitalSortFilter.prototype;
    _proto.getTitle = function getTitle() {
        return HOSPITAL_SEARCH_SORT_TYPE_NAME_MAP[this.type];
    };
    _proto.isSelected = function isSelected(selectedType) {
        return this.type === selectedType;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(HospitalSortFilter, [
        {
            key: "dtoType",
            get: function get() {
                return HOSPITAL_SEARCH_SORT_TYPE_DTO_MAP[this.type];
            }
        }
    ]);
    return HospitalSortFilter;
}();
var _obj2;
var FREE_INFLUENZA_TYPE_NAME_MAP = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj2, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.Child */ .Sy.Child, "어린이 무료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj2, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.Pregnant */ .Sy.Pregnant, "임신부 무료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj2, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.Senior */ .Sy.Senior, "노인 무료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj2, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.SeongnamCitizen */ .Sy.SeongnamCitizen, "성남시민 무료"), _obj2);
var _obj3;
var FREE_INFLUENZA_TYPE_DTO_MAP = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj3, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.Child */ .Sy.Child, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .FreeVaccinationSearchFilterType.Child */ .qTN.Child), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj3, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.Pregnant */ .Sy.Pregnant, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .FreeVaccinationSearchFilterType.Pregnant */ .qTN.Pregnant), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj3, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.Senior */ .Sy.Senior, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .FreeVaccinationSearchFilterType.Senior */ .qTN.Senior), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj3, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalFreeInfluenzaType.SeongnamCitizen */ .Sy.SeongnamCitizen, _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .FreeVaccinationSearchFilterType.SeongnamCitizen */ .qTN.SeongnamCitizen), _obj3);
var FreeInfluenzaFilter = /*#__PURE__*/ function() {
    "use strict";
    function FreeInfluenzaFilter(type) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, FreeInfluenzaFilter);
        this.type = type;
    }
    var _proto = FreeInfluenzaFilter.prototype;
    _proto.getTitle = function getTitle() {
        if (!this.type) {
            return "전체";
        }
        return FREE_INFLUENZA_TYPE_NAME_MAP[this.type];
    };
    _proto.isSelected = function isSelected(selectedType) {
        if (!this.type) {
            return false;
        }
        return this.type === selectedType;
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(FreeInfluenzaFilter, [
        {
            key: "dtoType",
            get: function get() {
                if (!this.type) {
                    return;
                }
                return FREE_INFLUENZA_TYPE_DTO_MAP[this.type];
            }
        }
    ]);
    return FreeInfluenzaFilter;
}();
var PartnershipTemplate;
(function(PartnershipTemplate) {
    PartnershipTemplate["Partner"] = "partner";
    PartnershipTemplate["NonPartner"] = "nonPartner";
})(PartnershipTemplate || (PartnershipTemplate = {}));
var _obj4;
var PARTNERSHIP_TEMPLATE_NAME_MAP = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj4, PartnershipTemplate.Partner, "partner"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj4, PartnershipTemplate.NonPartner, "nonPartner"), _obj4);
var HospitalPartnership = /*#__PURE__*/ function() {
    "use strict";
    function HospitalPartnership(isPartner) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, HospitalPartnership);
        this.isPartner = isPartner;
    }
    var _proto = HospitalPartnership.prototype;
    _proto.getPartnershipAsString = function getPartnershipAsString() {
        return this.isPartner ? PARTNERSHIP_TEMPLATE_NAME_MAP[PartnershipTemplate.Partner] : PARTNERSHIP_TEMPLATE_NAME_MAP[PartnershipTemplate.NonPartner];
    };
    _proto.isPartnership = function isPartnership() {
        return this.isPartner;
    };
    return HospitalPartnership;
}();
var _obj5;
var HOSPITAL_COMMON_FILTER_NAME_MAP = (_obj5 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj5, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType.Specialist */ .x6.Specialist, "전문의"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj5, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType.Operating */ .x6.Operating, "진료중"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj5, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType.Bookable */ .x6.Bookable, "간편예약"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj5, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType.NightOperation */ .x6.NightOperation, "야간진료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj5, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType.NonF2f */ .x6.NonF2f, "비대면 진료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj5, _types_hospital__WEBPACK_IMPORTED_MODULE_2__/* .HospitalCommonFilterType.SundayOperation */ .x6.SundayOperation, "일요일진료"), _obj5);
var HospitalCommonFilter = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function HospitalCommonFilter(type) {
        _class_call_check(this, HospitalCommonFilter);
        this.type = type;
    }
    var _proto = HospitalCommonFilter.prototype;
    _proto.getTitle = function getTitle() {
        return HOSPITAL_COMMON_FILTER_NAME_MAP[this.type];
    };
    _proto.isSelected = function isSelected(selectedType) {
        return this.type === selectedType;
    };
    _create_class(HospitalCommonFilter, [
        {
            key: "dtoType",
            get: function get() {
                return undefined;
            }
        }
    ]);
    return HospitalCommonFilter;
}()));
var HospitalSearchCommonFilter = /*#__PURE__*/ function() {
    "use strict";
    function HospitalSearchCommonFilter(values) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, HospitalSearchCommonFilter);
        this.values = values;
    }
    var _proto = HospitalSearchCommonFilter.prototype;
    _proto.getTitle = function getTitle(key) {
        return HOSPITAL_COMMON_FILTER_NAME_MAP[key];
    };
    _proto.isSelected = function isSelected(key) {
        return this.values[key];
    };
    return HospitalSearchCommonFilter;
}();
var getAvailableDoctorTimeSlotListMap = function(param) {
    var _allDoctorBookableTimes = param.allDoctorBookableTimes, allDoctorBookableTimes = _allDoctorBookableTimes === void 0 ? [] : _allDoctorBookableTimes, _doctorUnavailableTimes = param.doctorUnavailableTimes, doctorUnavailableTimes = _doctorUnavailableTimes === void 0 ? [] : _doctorUnavailableTimes, hospitalDoctorsByDepartment = param.hospitalDoctorsByDepartment, departmentGroupId = param.departmentGroupId;
    var ref;
    var allDoctorListMap = (ref = allDoctorBookableTimes.reduce(function(bookingTimeMap, currentBookingTime) {
        currentBookingTime.bookingTimes.forEach(function(bookingTime) {
            var ref;
            var foundDoctor = (ref = hospitalDoctorsByDepartment["".concat(departmentGroupId)]) === null || ref === void 0 ? void 0 : ref.find(function(doctor) {
                return doctor.id === currentBookingTime.doctor.doctorId;
            });
            if (!foundDoctor) {
                return bookingTimeMap;
            }
            var ref1;
            var bookingTimeInfo = (ref1 = bookingTimeMap.get(bookingTime.startTimeSlotValue)) !== null && ref1 !== void 0 ? ref1 : {
                doctors: [],
                bookingTime: bookingTime
            };
            var updatedBookingTimeInfo = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, bookingTimeInfo), {
                doctors: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(bookingTimeInfo.doctors).concat([
                    foundDoctor
                ])
            });
            bookingTimeMap.set(bookingTime.startTimeSlotValue, updatedBookingTimeInfo);
        });
        return bookingTimeMap;
    }, new Map())) !== null && ref !== void 0 ? ref : new Map();
    var ref1;
    var filteredTimeSlotDoctorListMap = (ref1 = doctorUnavailableTimes.reduce(function(bookingTimeMap, currentBookingTime) {
        currentBookingTime.bookingTimes.forEach(function(bookingTime) {
            var ref;
            var getBookingTimeInfo = (ref = bookingTimeMap.get(bookingTime.startTimeSlotValue)) !== null && ref !== void 0 ? ref : {
                doctors: [],
                bookingTime: bookingTime
            };
            var filteredBookingTimeInfo = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, getBookingTimeInfo), {
                doctors: getBookingTimeInfo.doctors.filter(function(doctor) {
                    return doctor.id !== currentBookingTime.doctor.doctorId;
                })
            });
            bookingTimeMap.set(bookingTime.startTimeSlotValue, filteredBookingTimeInfo);
        });
        return bookingTimeMap;
    }, allDoctorListMap)) !== null && ref1 !== void 0 ? ref1 : new Map();
    return filteredTimeSlotDoctorListMap;
};


/***/ }),

/***/ 50635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ parseNearbyPharmacySortsAndFiltersWithSubFilters; },
/* harmony export */   "I4": function() { return /* binding */ parseNearbyPharmacySearchTabsVo; },
/* harmony export */   "Nd": function() { return /* binding */ parsePharmacyPriceTagType; },
/* harmony export */   "XN": function() { return /* binding */ parsePharmacyTagType; },
/* harmony export */   "YJ": function() { return /* binding */ parsePickupListOfNearbyPharmacy; },
/* harmony export */   "Yd": function() { return /* binding */ parseRawPharmacyReview; },
/* harmony export */   "af": function() { return /* binding */ parseGeneralListOfNearbyPharmacy; },
/* harmony export */   "r5": function() { return /* binding */ parsePharmacyReviewTagVo; },
/* harmony export */   "uf": function() { return /* binding */ parseNearbyPharmacyDetailV3ByUserVo; },
/* harmony export */   "wZ": function() { return /* binding */ parsePharmacyMainTagType; }
/* harmony export */ });
/* unused harmony export parseToNearbyPharmacyMedicineVo */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75203);
/* harmony import */ var _models_review_review__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84958);
/* harmony import */ var _services_pharmacy_TreatmentMedicineService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81723);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72271);
/* harmony import */ var _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6271);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4611);








// 타입 변환 매퍼 함수
var mapToPharmacyFilterMode = function(mode) {
    switch(mode){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterMode.List */ .T4Y.List:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyFilterMode.List */ .LR.List;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterMode.Toggle */ .T4Y.Toggle:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyFilterMode.Toggle */ .LR.Toggle;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterMode.Range */ .T4Y.Range:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyFilterMode.Range */ .LR.Range;
        default:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyFilterMode.Toggle */ .LR.Toggle;
    }
};
var mapToPharmacySearchFilterType = function(type) {
    switch(type){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.ConfirmedDispensation */ .A1u.ConfirmedDispensation:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.ConfirmedDispensation */ .aT.ConfirmedDispensation;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.DispensationProbability */ .A1u.DispensationProbability:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.DispensationProbability */ .aT.DispensationProbability;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.HandlingMedicine */ .A1u.HandlingMedicine:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.HandlingMedicine */ .aT.HandlingMedicine;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.HighDispensationProbability */ .A1u.HighDispensationProbability:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.HighDispensationProbability */ .aT.HighDispensationProbability;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.IncludeDiagnosisPrice */ .A1u.IncludeDiagnosisPrice:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.IncludeDiagnosisPrice */ .aT.IncludeDiagnosisPrice;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.IsOpenAtLateNight */ .A1u.IsOpenAtLateNight:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.IsOpenAtLateNight */ .aT.IsOpenAtLateNight;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.IsOpenEveryDay */ .A1u.IsOpenEveryDay:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.IsOpenEveryDay */ .aT.IsOpenEveryDay;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.Now */ .A1u.Now:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.Now */ .aT.Now;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.Operating */ .A1u.Operating:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.Operating */ .aT.Operating;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.PossibleDispensation */ .A1u.PossibleDispensation:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.PossibleDispensation */ .aT.PossibleDispensation;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.RequestWithApp */ .A1u.RequestWithApp:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.RequestWithApp */ .aT.RequestWithApp;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyFilterType.SameMedicine */ .A1u.SameMedicine:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.SameMedicine */ .aT.SameMedicine;
        default:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchFilterType.DispensationProbability */ .aT.DispensationProbability;
    }
};
var mapToPharmacySortsVo = function(sort) {
    var sortType;
    switch(sort.type){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacySortType.Distance */ .f$c.Distance:
            sortType = _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchSortType.Distance */ .sZ.Distance;
            break;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacySortType.LowPrice */ .f$c.LowPrice:
            sortType = _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchSortType.LowPrice */ .sZ.LowPrice;
            break;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacySortType.QuickReceipt */ .f$c.QuickReceipt:
            sortType = _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchSortType.QuickReceipt */ .sZ.QuickReceipt;
            break;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacySortType.VisitCount */ .f$c.VisitCount:
            sortType = _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchSortType.VisitCount */ .sZ.VisitCount;
            break;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacySortType.MostReviews */ .f$c.MostReviews:
            sortType = _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchSortType.MostReviews */ .sZ.MostReviews;
            break;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacySortType.HighRating */ .f$c.HighRating:
            sortType = _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchSortType.HighRating */ .sZ.HighRating;
            break;
        default:
            sortType = _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .ENearbyPharmacySearchSortType.QuickReceipt */ .sZ.QuickReceipt;
    }
    return {
        title: sort.title,
        type: sortType
    };
};
var parsePharmacyMainTagType = function(type) {
    switch(type){
        case "HIGH_DISPENSATION_PROBABILITY":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyMainTagType.HighDispensationProbability */ .Sz.HighDispensationProbability;
        case "CONFIRMED_DISPENSATION":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyMainTagType.ConfirmedDispensation */ .Sz.ConfirmedDispensation;
        case "POSSIBLE_DISPENSATION":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyMainTagType.PossibleDispensation */ .Sz.PossibleDispensation;
        default:
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyMainTagType.Unknown */ .Sz.Unknown;
    }
};
var parsePharmacyTagType = function(type) {
    switch(type){
        case "IMMEDIATE_PAYMENT":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.ImmediatePayment */ .qV.ImmediatePayment;
        case "REQUEST_WITH_APP":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.RequestWithApp */ .qV.RequestWithApp;
        case "REQUEST_WITH_CALL":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.RequestWithCall */ .qV.RequestWithCall;
        case "OPEN_AT_LATE_NIGHT":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.OpenAtLateNight */ .qV.OpenAtLateNight;
        case "OPEN_EVERYDAY":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.OpenEveryday */ .qV.OpenEveryday;
        case "PEDIATRICS_MEDICINE":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.PediatricsMedicine */ .qV.PediatricsMedicine;
        case "PSYCHIATRY_MEDICINE":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.PsychiatryMedicine */ .qV.PsychiatryMedicine;
        case "RESERVATION_WITH_APP":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.ReservationWithApp */ .qV.ReservationWithApp;
        case "PRESCRIPTION_REJECT":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.PrescriptionReject */ .qV.PrescriptionReject;
        default:
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyTagType.Unknown */ .qV.Unknown;
    }
};
var parsePharmacyPriceTagType = function(type) {
    switch(type){
        case "VERIFIED_PRICE":
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyPriceTagType.verifiedPrice */ .Th.verifiedPrice;
        case "REPORTED_PRICE":
        default:
            return _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .EPharmacyPriceTagType.reportedPrice */ .Th.reportedPrice;
    }
};
var parsePharmacyReviewTagVo = function(data) {
    return data.pharmacyReviewTagsByRating.map(function(reviewTag) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, reviewTag);
    });
};
var getPharmacyOperationStatusV2 = function(pharmacyOperatingStatus) {
    switch(pharmacyOperatingStatus){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.Open */ .b07.Open:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.Open */ .sh.Open;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.Closed */ .b07.Closed:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.Closed */ .sh.Closed;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.DayOff */ .b07.DayOff:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.DayOff */ .sh.DayOff;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.ClosedSoon */ .b07.ClosedSoon:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.ClosedSoon */ .sh.ClosedSoon;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.Absent */ .b07.Absent:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.Absent */ .sh.Absent;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.BreakTime */ .b07.BreakTime:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.BreakTime */ .sh.BreakTime;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.BeforeOpen */ .b07.BeforeOpen:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.BeforeOpen */ .sh.BeforeOpen;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .PharmacyOperationStatusV2.Unknown */ .b07.Unknown:
        default:
            return _types_pharmacy__WEBPACK_IMPORTED_MODULE_4__/* .EPharmacyOperationType.Unknown */ .sh.Unknown;
    }
};
var parseGeneralListOfNearbyPharmacy = function(data) {
    var ref;
    var pharmacies = (ref = data.nearbyPharmacyV3ByUser) === null || ref === void 0 ? void 0 : ref.map(function(pharmacy) {
        var ref, ref1, ref2;
        var operationStatus = getPharmacyOperationStatusV2(pharmacy.operation.status);
        var _tel, _safetyNumber, _distanceInMeters, _roadAddress, _jibunAddress, _detailAddress, _display, ref3, ref4, ref5, ref6, _imageUrl, _imageUrl1, _imageUrl2, _imageUrl3, _diagnosisPrice;
        return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyModel */ .yI({
            tel: (_tel = pharmacy.contact.tel) !== null && _tel !== void 0 ? _tel : "",
            safetyNumber: (_safetyNumber = pharmacy.contact.safetyNumber) !== null && _safetyNumber !== void 0 ? _safetyNumber : "",
            distance: (_distanceInMeters = pharmacy.location.distanceInMeters) !== null && _distanceInMeters !== void 0 ? _distanceInMeters : 0,
            latitude: pharmacy.location.latitude,
            longitude: pharmacy.location.longitude,
            roadAddress: (_roadAddress = pharmacy.location.roadAddress) !== null && _roadAddress !== void 0 ? _roadAddress : "",
            jibunAddress: (_jibunAddress = pharmacy.location.jibunAddress) !== null && _jibunAddress !== void 0 ? _jibunAddress : null,
            detailAddress: (_detailAddress = pharmacy.location.detailAddress) !== null && _detailAddress !== void 0 ? _detailAddress : null,
            pharmacyName: pharmacy.location.pharmacyName,
            pharmacyId: pharmacy.pharmacyId,
            pharmacyPid: pharmacy.publicId,
            pickupCompletedCount: pharmacy.pickupCompletedCount,
            operationDisplay: (_display = pharmacy.operation.display) !== null && _display !== void 0 ? _display : null,
            operationStatus: operationStatus,
            pharmacyNextOperationHour: pharmacy.pharmacyNextOperationHour.map(function(nextOperationHour) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyNextOperationHourModel */ .Vy({
                    earliestAvailableReservationHour: nextOperationHour.earliestAvailableReservationHour,
                    earliestAvailableReservationHourString: nextOperationHour.earliestAvailableReservationHourString
                });
            }),
            pharmacyDispensableMedicinePrices: pharmacy.dispensableMedicines ? new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyDispensableMedicineModel */ .PZ({
                totalAmount: ((ref = pharmacy.dispensableMedicines) === null || ref === void 0 ? void 0 : ref.totalAmount) ? Number((ref1 = pharmacy.dispensableMedicines) === null || ref1 === void 0 ? void 0 : ref1.totalAmount) : null,
                dispensableMedicines: (ref2 = pharmacy.dispensableMedicines) === null || ref2 === void 0 ? void 0 : ref2.dispensableMedicines.map(function(medicine) {
                    var ref, ref1, ref2, ref7, ref8, ref9, ref10, ref11, ref12;
                    return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .DispensableMedicineModel */ .eo({
                        medicineId: Number((ref = medicine.pharmacyMedicine) === null || ref === void 0 ? void 0 : ref.medicineId),
                        treatmentMedicineName: (ref3 = (ref1 = medicine.pharmacyMedicine) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.treatmentMedicine) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref3 !== void 0 ? ref3 : "",
                        medicineName: (ref4 = (ref7 = medicine.pharmacyMedicine) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.medicine) === null || ref8 === void 0 ? void 0 : ref8.medicineName) !== null && ref4 !== void 0 ? ref4 : "",
                        userBasedStandard: (ref5 = (ref9 = medicine.pharmacyMedicine) === null || ref9 === void 0 ? void 0 : ref9.displayName) !== null && ref5 !== void 0 ? ref5 : "",
                        price: ((ref10 = medicine.pharmacyMedicine) === null || ref10 === void 0 ? void 0 : ref10.price) ? Number((ref11 = medicine.pharmacyMedicine) === null || ref11 === void 0 ? void 0 : ref11.price) : 0,
                        isSoldOut: false,
                        isAlternative: (ref6 = (ref12 = medicine.pharmacyMedicine) === null || ref12 === void 0 ? void 0 : ref12.isAlternativeMedicine) !== null && ref6 !== void 0 ? ref6 : false
                    });
                })
            }) : null,
            partnershipType: pharmacy.partnership,
            mainTags: pharmacy.attributesV3.mainTags.map(function(mainTag) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyMainTagModel */ .wF({
                    type: parsePharmacyMainTagType(mainTag.type),
                    imageUrl: (_imageUrl = mainTag.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : ""
                });
            }),
            badges: pharmacy.attributesV3.badges.map(function(badge) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyBadgeModel */ .Tq({
                    type: badge.type,
                    imageUrl: (_imageUrl1 = badge.imageUrl) !== null && _imageUrl1 !== void 0 ? _imageUrl1 : ""
                });
            }),
            tags: pharmacy.attributesV3.tags.map(function(tag) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyTagModel */ ._l({
                    type: parsePharmacyTagType(tag.type),
                    imageUrl: (_imageUrl2 = tag.imageUrl) !== null && _imageUrl2 !== void 0 ? _imageUrl2 : ""
                });
            }),
            priceTags: pharmacy.attributesV3.priceTags.map(function(tag) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyPriceTagModel */ .Gh({
                    type: parsePharmacyPriceTagType(tag.type),
                    imageUrl: (_imageUrl3 = tag.imageUrl) !== null && _imageUrl3 !== void 0 ? _imageUrl3 : ""
                });
            }),
            reviewSummary: {
                totalCount: pharmacy.reviewMeta.totalCount,
                averageRating: String(pharmacy.reviewMeta.averageRating)
            },
            diagnosisPrice: (_diagnosisPrice = pharmacy.diagnosisPrice) !== null && _diagnosisPrice !== void 0 ? _diagnosisPrice : null,
            isFavoritePharmacy: pharmacy.isFavoritePharmacy
        });
    });
    return pharmacies;
};
var parsePickupListOfNearbyPharmacy = function(data) {
    var ref;
    var pharmacies = (ref = data.nearbyPharmacyV3ByUser) === null || ref === void 0 ? void 0 : ref.map(function(pharmacy) {
        var ref, ref1, ref2, ref3, ref4;
        var operationStatus = getPharmacyOperationStatusV2(pharmacy.operation.status);
        var _tel, _safetyNumber, _faxNumber, _distanceInMeters, _roadAddress, _jibunAddress, _detailAddress, _display, ref5, ref6, ref7, ref8, _imageUrl, _imageUrl1, _imageUrl2, _imageUrl3;
        return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyModel */ .yI({
            tel: (_tel = pharmacy.contact.tel) !== null && _tel !== void 0 ? _tel : "",
            safetyNumber: (_safetyNumber = pharmacy.contact.safetyNumber) !== null && _safetyNumber !== void 0 ? _safetyNumber : "",
            faxNumber: (_faxNumber = pharmacy.contact.faxNumber) !== null && _faxNumber !== void 0 ? _faxNumber : "",
            distance: (_distanceInMeters = pharmacy.location.distanceInMeters) !== null && _distanceInMeters !== void 0 ? _distanceInMeters : 0,
            latitude: pharmacy.location.latitude,
            longitude: pharmacy.location.longitude,
            roadAddress: (_roadAddress = pharmacy.location.roadAddress) !== null && _roadAddress !== void 0 ? _roadAddress : "",
            jibunAddress: (_jibunAddress = pharmacy.location.jibunAddress) !== null && _jibunAddress !== void 0 ? _jibunAddress : null,
            detailAddress: (_detailAddress = pharmacy.location.detailAddress) !== null && _detailAddress !== void 0 ? _detailAddress : null,
            pharmacyName: pharmacy.location.pharmacyName,
            pharmacyId: pharmacy.pharmacyId,
            pharmacyPid: pharmacy.publicId,
            pickupCompletedCount: pharmacy.pickupCompletedCount,
            operationDisplay: (_display = pharmacy.operation.display) !== null && _display !== void 0 ? _display : null,
            operationStatus: operationStatus,
            pharmacyNextOperationHour: pharmacy.pharmacyNextOperationHour.map(function(nextOperationHour) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyNextOperationHourModel */ .Vy({
                    earliestAvailableReservationHour: nextOperationHour.earliestAvailableReservationHour,
                    earliestAvailableReservationHourString: nextOperationHour.earliestAvailableReservationHourString
                });
            }),
            pharmacyDispensableMedicinePrices: pharmacy.dispensableMedicines ? new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyDispensableMedicineModel */ .PZ({
                totalAmount: ((ref = pharmacy.dispensableMedicines) === null || ref === void 0 ? void 0 : ref.totalAmount) ? Number((ref1 = pharmacy.dispensableMedicines) === null || ref1 === void 0 ? void 0 : ref1.totalAmount) : null,
                dispensableMedicines: (ref2 = pharmacy.dispensableMedicines) === null || ref2 === void 0 ? void 0 : ref2.dispensableMedicines.map(function(medicine) {
                    var ref, ref1, ref2, ref3, ref4, ref9, ref10, ref11;
                    return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .DispensableMedicineModel */ .eo({
                        medicineId: Number((ref = medicine.pharmacyMedicine) === null || ref === void 0 ? void 0 : ref.medicineId),
                        treatmentMedicineName: (ref5 = (ref1 = medicine.pharmacyMedicine) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.treatmentMedicine) === null || ref2 === void 0 ? void 0 : ref2.name) !== null && ref5 !== void 0 ? ref5 : "",
                        medicineName: (ref6 = (ref3 = medicine.medicine) === null || ref3 === void 0 ? void 0 : ref3.medicineName) !== null && ref6 !== void 0 ? ref6 : "",
                        userBasedStandard: (ref7 = (ref4 = medicine.pharmacyMedicine) === null || ref4 === void 0 ? void 0 : ref4.displayName) !== null && ref7 !== void 0 ? ref7 : "",
                        price: ((ref9 = medicine.pharmacyMedicine) === null || ref9 === void 0 ? void 0 : ref9.price) ? Number((ref10 = medicine.pharmacyMedicine) === null || ref10 === void 0 ? void 0 : ref10.price) : 0,
                        isSoldOut: false,
                        isAlternative: (ref8 = (ref11 = medicine.pharmacyMedicine) === null || ref11 === void 0 ? void 0 : ref11.isAlternativeMedicine) !== null && ref8 !== void 0 ? ref8 : false
                    });
                })
            }) : null,
            partnershipType: pharmacy.partnership,
            mainTags: pharmacy.attributesV3.mainTags.map(function(mainTag) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyMainTagModel */ .wF({
                    type: parsePharmacyMainTagType(mainTag.type),
                    imageUrl: (_imageUrl = mainTag.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : ""
                });
            }),
            badges: pharmacy.attributesV3.badges.map(function(badge) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyBadgeModel */ .Tq({
                    type: badge.type,
                    imageUrl: (_imageUrl1 = badge.imageUrl) !== null && _imageUrl1 !== void 0 ? _imageUrl1 : ""
                });
            }),
            tags: pharmacy.attributesV3.tags.map(function(tag) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyTagModel */ ._l({
                    type: parsePharmacyTagType(tag.type),
                    imageUrl: (_imageUrl2 = tag.imageUrl) !== null && _imageUrl2 !== void 0 ? _imageUrl2 : ""
                });
            }),
            priceTags: pharmacy.attributesV3.priceTags.map(function(tag) {
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyPriceTagModel */ .Gh({
                    type: parsePharmacyPriceTagType(tag.type),
                    imageUrl: (_imageUrl3 = tag.imageUrl) !== null && _imageUrl3 !== void 0 ? _imageUrl3 : ""
                });
            }),
            reviewSummary: {
                totalCount: pharmacy.reviewMeta.totalCount,
                averageRating: String(pharmacy.reviewMeta.averageRating)
            },
            diagnosisPrice: null,
            recommendationScore: (ref3 = pharmacy.attributesV3) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.recommendationScore) === null || ref4 === void 0 ? void 0 : ref4.score,
            isFavoritePharmacy: pharmacy.isFavoritePharmacy
        });
    });
    return pharmacies;
};
var parseRawPharmacyReview = function(data) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
        pages: data.pages.map(function(el) {
            return el.pharmacyReviews.map(function(review) {
                var createdAtDate = review.createdAt ? new Date(review.createdAt) : null;
                var formattedDate = createdAtDate ? "".concat(createdAtDate.getFullYear(), ".").concat(String(createdAtDate.getMonth() + 1).padStart(2, "0"), ".").concat(String(createdAtDate.getDate()).padStart(2, "0")) : null;
                var _maskedHolderName, _targetCategoryName;
                return new _models_review_review__WEBPACK_IMPORTED_MODULE_1__/* .Review */ .Cq({
                    id: Number(review.id),
                    title: review.title,
                    content: review.content,
                    tags: review.reviewTags.map(function(reviewTag) {
                        return new _models_review_review__WEBPACK_IMPORTED_MODULE_1__/* .ReviewTag */ .Vj({
                            reviewId: Number(review.id),
                            tagId: Number(reviewTag.tag.tagId),
                            text: String(reviewTag.tag.text)
                        });
                    }),
                    rating: review.rating,
                    writer: (_maskedHolderName = review.maskedHolderName) !== null && _maskedHolderName !== void 0 ? _maskedHolderName : "",
                    createdAt: formattedDate,
                    diagnosisCategoryName: (_targetCategoryName = review.targetCategoryName) !== null && _targetCategoryName !== void 0 ? _targetCategoryName : "",
                    isLiked: false,
                    isPrivate: review.isPrivate,
                    likeCount: 0,
                    isBlockedByUser: false,
                    isCommentBlockedByUser: false,
                    userId: Number(review.reviewContext.reviewHolderId),
                    price: review.targetPrice ? (0,_utils_format__WEBPACK_IMPORTED_MODULE_5__/* .formatPriceComma */ .dM)(review.targetPrice) : null,
                    doctor: null,
                    comment: null
                });
            });
        })
    });
};
var parseNearbyPharmacySortsAndFiltersWithSubFilters = function(data) {
    var ref, ref1;
    var ref2, ref3;
    return {
        filters: (ref2 = (ref = data.pickupNearbyPharmacySearchTab) === null || ref === void 0 ? void 0 : ref.filters.map(function(filter) {
            var _activeIconUrl, _inactiveIconUrl, _description, _title, _activeIconUrl1, _inactiveIconUrl1, _description1, _title1;
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .NearbyPharmacyFilterModel */ .QJ({
                activeIconUrl: (_activeIconUrl = filter.activeIconUrl) !== null && _activeIconUrl !== void 0 ? _activeIconUrl : undefined,
                inactiveIconUrl: (_inactiveIconUrl = filter.inactiveIconUrl) !== null && _inactiveIconUrl !== void 0 ? _inactiveIconUrl : undefined,
                description: (_description = filter.description) !== null && _description !== void 0 ? _description : "",
                mode: mapToPharmacyFilterMode(filter.mode),
                title: (_title = filter.title) !== null && _title !== void 0 ? _title : "",
                type: mapToPharmacySearchFilterType(filter.type),
                subFilters: filter.subFilters.map(function(subFilter) {
                    return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .NearbyPharmacyFilterModel */ .QJ({
                        activeIconUrl: (_activeIconUrl1 = subFilter.activeIconUrl) !== null && _activeIconUrl1 !== void 0 ? _activeIconUrl1 : undefined,
                        inactiveIconUrl: (_inactiveIconUrl1 = subFilter.inactiveIconUrl) !== null && _inactiveIconUrl1 !== void 0 ? _inactiveIconUrl1 : undefined,
                        description: (_description1 = subFilter.description) !== null && _description1 !== void 0 ? _description1 : "",
                        mode: mapToPharmacyFilterMode(subFilter.mode),
                        title: (_title1 = subFilter.title) !== null && _title1 !== void 0 ? _title1 : "",
                        type: mapToPharmacySearchFilterType(subFilter.type),
                        subFilters: []
                    });
                })
            });
        })) !== null && ref2 !== void 0 ? ref2 : [],
        sorts: (ref3 = (ref1 = data.pickupNearbyPharmacySearchTab) === null || ref1 === void 0 ? void 0 : ref1.sortTypes.map(function(type) {
            return mapToPharmacySortsVo(type);
        })) !== null && ref3 !== void 0 ? ref3 : []
    };
};
var parseToNearbyPharmacyMedicineVo = function(data) {
    return data.treatmentMedicinesByTreatmentId.map(function(item) {
        var _description;
        return {
            treatmentMedicineId: item.id,
            treatmentId: item.treatmentId,
            name: item.name,
            description: (_description = item.description) !== null && _description !== void 0 ? _description : undefined,
            isNew: TreatmentMedicineService.isNewMedicine(item.id),
            dispensationUnits: item.dispensationUnits.map(function(dispensationUnit) {
                return {
                    isDefault: dispensationUnit.isDefault,
                    dispensationUnit: dispensationUnit.dispensationUnit,
                    dispensationUnitDisplayName: dispensationUnit.dispensationUnitDisplayName,
                    treatmentMedicineId: Number(dispensationUnit.treatmentMedicineId),
                    treatmentMedicineUnitId: Number(dispensationUnit.treatmentMedicineUnitId)
                };
            }),
            treatmentMedicineStrengths: []
        };
    });
};
var parseNearbyPharmacySearchTabsVo = function(data) {
    var _diagnosisTypeId;
    return data.generalNearbyPharmacySearchTabs.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, item), {
            diagnosisTypeId: (_diagnosisTypeId = item.diagnosisTypeId) !== null && _diagnosisTypeId !== void 0 ? _diagnosisTypeId : null,
            filters: item.filters.map(function(filter) {
                var _activeIconUrl, _inactiveIconUrl, _title, _description;
                return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .NearbyPharmacyFilterModel */ .QJ({
                    activeIconUrl: (_activeIconUrl = filter.activeIconUrl) !== null && _activeIconUrl !== void 0 ? _activeIconUrl : undefined,
                    inactiveIconUrl: (_inactiveIconUrl = filter.inactiveIconUrl) !== null && _inactiveIconUrl !== void 0 ? _inactiveIconUrl : undefined,
                    mode: mapToPharmacyFilterMode(filter.mode),
                    title: (_title = filter.title) !== null && _title !== void 0 ? _title : "",
                    description: (_description = filter.description) !== null && _description !== void 0 ? _description : "",
                    type: mapToPharmacySearchFilterType(filter.type),
                    subFilters: filter.subFilters.map(function(subFilter) {
                        var _activeIconUrl, _inactiveIconUrl, _description, _title;
                        return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .NearbyPharmacyFilterModel */ .QJ({
                            activeIconUrl: (_activeIconUrl = subFilter.activeIconUrl) !== null && _activeIconUrl !== void 0 ? _activeIconUrl : undefined,
                            inactiveIconUrl: (_inactiveIconUrl = subFilter.inactiveIconUrl) !== null && _inactiveIconUrl !== void 0 ? _inactiveIconUrl : undefined,
                            description: (_description = subFilter.description) !== null && _description !== void 0 ? _description : "",
                            mode: mapToPharmacyFilterMode(subFilter.mode),
                            title: (_title = subFilter.title) !== null && _title !== void 0 ? _title : "",
                            type: mapToPharmacySearchFilterType(subFilter.type),
                            subFilters: []
                        });
                    })
                });
            }),
            sortTypes: item.sortTypes.map(function(type) {
                return mapToPharmacySortsVo(type);
            }),
            treatmentMedicines: item.treatmentMedicines.map(function(medicine) {
                var _description;
                return {
                    treatmentMedicineId: medicine.id,
                    treatmentId: medicine.treatmentId,
                    name: medicine.name,
                    description: (_description = medicine.description) !== null && _description !== void 0 ? _description : undefined,
                    isNew: _services_pharmacy_TreatmentMedicineService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isNewMedicine */ .Z.isNewMedicine(medicine.id),
                    treatmentMedicineStrengths: medicine.treatmentMedicineStrengths.map(function(strength) {
                        return {
                            treatmentMedicineStrengthId: strength.treatmentMedicineStrengthId,
                            treatmentMedicineId: strength.treatmentMedicineId,
                            unit: strength.unit,
                            isDefault: strength.isDefault
                        };
                    }),
                    dispensationUnits: medicine.dispensationUnits.map(function(unit) {
                        return {
                            isDefault: unit.isDefault,
                            dispensationUnit: unit.dispensationUnit,
                            dispensationUnitDisplayName: unit.dispensationUnitDisplayName,
                            treatmentMedicineId: Number(unit.treatmentMedicineId),
                            treatmentMedicineUnitId: Number(unit.treatmentMedicineUnitId)
                        };
                    })
                };
            })
        });
    });
};
var parseNearbyPharmacyDetailV3ByUserVo = function(data) {
    if (!data.nearbyPharmacyDetailByPublicId) return;
    var pharmacy = data.nearbyPharmacyDetailByPublicId;
    var operationStatus = getPharmacyOperationStatusV2(pharmacy.operation.status);
    var _roadAddress, _jibunAddress, _detailAddress, _display, _tel, _safetyNumber, _imageUrl, _imageUrl1, _imageUrl2, _imageUrl3, ref;
    return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyModel */ .yI({
        pharmacyPid: pharmacy.publicId,
        roadAddress: (_roadAddress = pharmacy.location.roadAddress) !== null && _roadAddress !== void 0 ? _roadAddress : null,
        jibunAddress: (_jibunAddress = pharmacy.location.jibunAddress) !== null && _jibunAddress !== void 0 ? _jibunAddress : null,
        detailAddress: (_detailAddress = pharmacy.location.detailAddress) !== null && _detailAddress !== void 0 ? _detailAddress : null,
        reviewSummary: pharmacy.reviewMeta,
        distance: pharmacy.location.distanceInMeters,
        latitude: pharmacy.location.latitude,
        longitude: pharmacy.location.longitude,
        pharmacyId: pharmacy.pharmacyId,
        pharmacyName: pharmacy.location.pharmacyName,
        pickupCompletedCount: pharmacy.pickupCompletedCount,
        operationDisplay: (_display = pharmacy.operation.display) !== null && _display !== void 0 ? _display : "",
        operationStatus: operationStatus,
        tel: (_tel = pharmacy.contact.tel) !== null && _tel !== void 0 ? _tel : null,
        safetyNumber: (_safetyNumber = pharmacy.contact.safetyNumber) !== null && _safetyNumber !== void 0 ? _safetyNumber : null,
        partnershipType: pharmacy.partnership,
        mainTags: pharmacy.attributesV3.mainTags.map(function(mainTag) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyMainTagModel */ .wF({
                type: parsePharmacyMainTagType(mainTag.type),
                imageUrl: (_imageUrl = mainTag.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : ""
            });
        }),
        badges: pharmacy.attributesV3.badges.map(function(badge) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyBadgeModel */ .Tq({
                type: badge.type,
                imageUrl: (_imageUrl1 = badge.imageUrl) !== null && _imageUrl1 !== void 0 ? _imageUrl1 : ""
            });
        }),
        tags: pharmacy.attributesV3.tags.map(function(tag) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyTagModel */ ._l({
                type: parsePharmacyTagType(tag.type),
                imageUrl: (_imageUrl2 = tag.imageUrl) !== null && _imageUrl2 !== void 0 ? _imageUrl2 : ""
            });
        }),
        priceTags: pharmacy.attributesV3.priceTags.map(function(tag) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyPriceTagModel */ .Gh({
                type: parsePharmacyPriceTagType(tag.type),
                imageUrl: (_imageUrl3 = tag.imageUrl) !== null && _imageUrl3 !== void 0 ? _imageUrl3 : ""
            });
        }),
        pharmacyNextOperationHour: pharmacy.pharmacyNextOperationHour.map(function(nextOperationHour) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyNextOperationHourModel */ .Vy({
                earliestAvailableReservationHour: nextOperationHour.earliestAvailableReservationHour,
                earliestAvailableReservationHourString: nextOperationHour.earliestAvailableReservationHourString
            });
        }),
        diagnosisPrice: null,
        reviews: pharmacy.numberOfReviewsByRating.map(function(review) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyReviewModel */ .mR({
                rating: review.rating,
                count: review.count
            });
        }),
        todayDuty: pharmacy.operation.todayDuty ? new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyDutyModel */ .h({
            weekDay: pharmacy.operation.todayDuty.weekDay,
            isClosed: pharmacy.operation.todayDuty.isClosed,
            openTime: pharmacy.operation.todayDuty.openTime.slice(0, -3),
            closeTime: pharmacy.operation.todayDuty.closeTime.slice(0, -3),
            hasBreakTime: pharmacy.operation.todayDuty.hasBreakTime,
            breakStartTime: pharmacy.operation.todayDuty.breakStartTime.slice(0, -3),
            breakEndTime: pharmacy.operation.todayDuty.breakEndTime.slice(0, -3)
        }) : null,
        pharmacyDuties: (ref = pharmacy.operation.duties.map(function(duty) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .PharmacyDutyModel */ .h({
                weekDay: duty.weekDay,
                isClosed: duty.isClosed,
                openTime: duty.openTime.slice(0, -3),
                closeTime: duty.closeTime.slice(0, -3),
                hasBreakTime: duty.hasBreakTime,
                breakStartTime: duty.breakStartTime.slice(0, -3),
                breakEndTime: duty.breakEndTime.slice(0, -3)
            });
        })) !== null && ref !== void 0 ? ref : [],
        prescribedMedicineInfoWithDoseDays: pharmacy.prescribedMedicineInfoWithDoseDays.map(function(medicine) {
            return new _models_pharmacy__WEBPACK_IMPORTED_MODULE_0__/* .MedicineInfoWithDoseDaysModel */ .fR({
                medicineSummary: medicine.medicineSummary ? {
                    medicineId: medicine.medicineSummary.medicineId,
                    medicineName: medicine.medicineSummary.medicineName,
                    medicineImageUrl: medicine.medicineSummary.medicineImageUrl,
                    hasDetailInfo: medicine.medicineSummary.hasDetailInfo,
                    pharmaceuticalEffectLiteracy: medicine.medicineSummary.pharmaceuticalEffectLiteracy,
                    medicinePid: medicine.medicineSummary.publicId,
                    medicineStockStatus: {
                        status: medicine.medicineSummary.medicineDispensability.dispensabilityStatus,
                        imageUrl: medicine.medicineSummary.medicineDispensability.iconImageUrl
                    }
                } : null
            });
        }),
        isFavoritePharmacy: pharmacy.isFavoritePharmacy
    });
};


/***/ }),

/***/ 23144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ SearchHospitalService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _constants_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13805);



var SearchHospitalService = /*#__PURE__*/ function() {
    "use strict";
    function SearchHospitalService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SearchHospitalService);
    }
    SearchHospitalService.updateCoordinate = function updateCoordinate(coordinate, updatedCoordinate) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, coordinate, updatedCoordinate);
    };
    SearchHospitalService.initializeUserSigunguDongli = function initializeUserSigunguDongli() {
        return {
            sigungu: "서초구",
            dongLi: "서초동"
        };
    };
    SearchHospitalService.initializeUserCoordinate = function initializeUserCoordinate() {
        return {
            latitude: _constants_map__WEBPACK_IMPORTED_MODULE_2__/* .DOCTOR_NOW_COMPANY_LATITUDE */ .q,
            longitude: _constants_map__WEBPACK_IMPORTED_MODULE_2__/* .DOCTOR_NOW_COMPANY_LONGITUDE */ .y
        };
    };
    SearchHospitalService.parseGetAddressByLocation = function parseGetAddressByLocation(data) {
        if (!data.getAddressByLocation) {
            return null;
        }
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data.getAddressByLocation);
    };
    SearchHospitalService.parseHospitalAddressByLocation = function parseHospitalAddressByLocation(data) {
        var hospitalAddress = SearchHospitalService.parseGetAddressByLocation(data);
        if (!hospitalAddress) {
            return SearchHospitalService.initializeUserSigunguDongli();
        }
        return {
            sigungu: hospitalAddress.sigungu,
            dongLi: hospitalAddress.dongLi
        };
    };
    SearchHospitalService.parseKoreaAddressV2 = function parseKoreaAddressV2(data) {
        return data.searchKoreaAddressV2.map(function(address) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, address);
        });
    };
    return SearchHospitalService;
}();


/***/ }),

/***/ 81723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);

var TreatmentMedicineService = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentMedicineService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, TreatmentMedicineService);
    }
    TreatmentMedicineService.isWegovy = function isWegovy(treatmentMedicineId) {
        return this.WEGOVY_ID === treatmentMedicineId;
    };
    TreatmentMedicineService.isNewMedicine = function isNewMedicine(treatmentMedicineId) {
        return this.isWegovy(treatmentMedicineId);
    };
    return TreatmentMedicineService;
}();
TreatmentMedicineService.WEGOVY_ID = "18";
/* harmony default export */ __webpack_exports__["Z"] = (TreatmentMedicineService);


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tq": function() { return /* binding */ AuthorType; },
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "pO": function() { return /* binding */ EDoctorCareer; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony export CoreCategoryType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
    AuthorType["MEDICAL_PROFESSIONAL_EDITOR"] = "MEDICAL_PROFESSIONAL_EDITOR";
    AuthorType["GENERAL_EDITOR"] = "GENERAL_EDITOR";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));
var EDoctorCareer;
(function(EDoctorCareer) {
    EDoctorCareer["CURRENT"] = "CURRENT";
    EDoctorCareer["PAST"] = "PAST";
    EDoctorCareer["GRADUATION"] = "GRADUATION";
    EDoctorCareer["COMPLETION"] = "COMPLETION";
})(EDoctorCareer || (EDoctorCareer = {}));


/***/ }),

/***/ 50728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ EGeneralSearchFeatureType; },
/* harmony export */   "Bf": function() { return /* binding */ EQuestionAccessibleType; },
/* harmony export */   "DD": function() { return /* binding */ EIntegratedSearchTabType; },
/* harmony export */   "Dp": function() { return /* binding */ EGeneralSearchSnippetType; },
/* harmony export */   "E": function() { return /* binding */ ERequestButtonType; },
/* harmony export */   "My": function() { return /* binding */ EProfessionalFieldType; },
/* harmony export */   "PF": function() { return /* binding */ EAnswererType; },
/* harmony export */   "nc": function() { return /* binding */ EAuthorType; },
/* harmony export */   "qv": function() { return /* binding */ EQuestionAnsweredStatus; },
/* harmony export */   "wo": function() { return /* binding */ EAnswerLikeType; }
/* harmony export */ });
var EAuthorType;
(function(EAuthorType) {
    EAuthorType["Ai"] = "AI";
    EAuthorType["Doctor"] = "DOCTOR";
    EAuthorType["GeneralEditor"] = "GENERAL_EDITOR";
    EAuthorType["MedicalProfessionalEditor"] = "MEDICAL_PROFESSIONAL_EDITOR";
    EAuthorType["Nurse"] = "NURSE";
})(EAuthorType || (EAuthorType = {}));
var EQuestionAnsweredStatus;
(function(EQuestionAnsweredStatus) {
    EQuestionAnsweredStatus["Answered"] = "ANSWERED";
    EQuestionAnsweredStatus["Answering"] = "ANSWERING";
    EQuestionAnsweredStatus["Checking"] = "CHECKING";
})(EQuestionAnsweredStatus || (EQuestionAnsweredStatus = {}));
var EProfessionalFieldType;
(function(EProfessionalFieldType) {
    EProfessionalFieldType["Department"] = "DEPARTMENT";
})(EProfessionalFieldType || (EProfessionalFieldType = {}));
var EQuestionAccessibleType;
(function(EQuestionAccessibleType) {
    EQuestionAccessibleType["All"] = "ALL";
    EQuestionAccessibleType["DoctorsAndMe"] = "DOCTORS_AND_ME";
    EQuestionAccessibleType["Me"] = "ME";
})(EQuestionAccessibleType || (EQuestionAccessibleType = {}));
var EAnswererType;
(function(EAnswererType) {
    EAnswererType["Ai"] = "AI";
    EAnswererType["Doctor"] = "DOCTOR";
    EAnswererType["Nurse"] = "NURSE";
})(EAnswererType || (EAnswererType = {}));
var EAnswerLikeType;
(function(EAnswerLikeType) {
    EAnswerLikeType["Dislike"] = "DISLIKE";
    EAnswerLikeType["Like"] = "LIKE";
})(EAnswerLikeType || (EAnswerLikeType = {}));
var EIntegratedSearchTabType;
(function(EIntegratedSearchTabType) {
    EIntegratedSearchTabType["All"] = "ALL";
    EIntegratedSearchTabType["Qna"] = "QNA";
    EIntegratedSearchTabType["Magazine"] = "MAGAZINE";
    EIntegratedSearchTabType["Doctor"] = "DOCTOR";
    EIntegratedSearchTabType["Hospital"] = "HOSPITAL";
    EIntegratedSearchTabType["MedicineDictionary"] = "MEDICINE_DICTIONARY";
    EIntegratedSearchTabType["DiseaseEncyclopedia"] = "DISEASE_ENCYCLOPEDIA";
})(EIntegratedSearchTabType || (EIntegratedSearchTabType = {}));
var ERequestButtonType;
(function(ERequestButtonType) {
    ERequestButtonType["BOTTOM"] = "bottom";
    ERequestButtonType["FLOATING"] = "floating";
})(ERequestButtonType || (ERequestButtonType = {}));
var EGeneralSearchSnippetType;
(function(EGeneralSearchSnippetType) {
    EGeneralSearchSnippetType["DeliveryGuide"] = "DELIVERY_GUIDE";
    EGeneralSearchSnippetType["FaceToFaceDiagnosis"] = "FACE_TO_FACE_DIAGNOSIS";
    EGeneralSearchSnippetType["FaceToFacePrescription"] = "FACE_TO_FACE_PRESCRIPTION";
    EGeneralSearchSnippetType["NonFaceToFaceDiagnosis"] = "NON_FACE_TO_FACE_DIAGNOSIS";
    EGeneralSearchSnippetType["NonFaceToFacePrescription"] = "NON_FACE_TO_FACE_PRESCRIPTION";
})(EGeneralSearchSnippetType || (EGeneralSearchSnippetType = {}));
var EGeneralSearchFeatureType;
(function(EGeneralSearchFeatureType) {
    EGeneralSearchFeatureType["DietInjection"] = "DIET_INJECTION";
    EGeneralSearchFeatureType["EmergencyContraceptive"] = "EMERGENCY_CONTRACEPTIVE";
    EGeneralSearchFeatureType["FindPharmacy"] = "FIND_PHARMACY";
})(EGeneralSearchFeatureType || (EGeneralSearchFeatureType = {}));


/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ setImageUrl; },
/* harmony export */   "Kp": function() { return /* binding */ resizingImg; },
/* harmony export */   "NR": function() { return /* binding */ convertedHeicSingleImage; },
/* harmony export */   "RW": function() { return /* binding */ convertHeic; },
/* harmony export */   "VM": function() { return /* binding */ onCompressImage; }
/* harmony export */ });
/* unused harmony exports isImage, redirectPostImage */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);
/* eslint-disable @typescript-eslint/no-var-requires */ 



var convertHeic = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var heic2any, blob, newImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23))
                    ];
                case 1:
                    heic2any = _state.sent().default;
                    return [
                        4,
                        heic2any({
                            blob: file,
                            toType: "image/jpeg",
                            quality: 0.8
                        })
                    ];
                case 2:
                    blob = _state.sent();
                    newImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        newImage
                    ];
            }
        });
    });
    return function convertHeic(file) {
        return _ref.apply(this, arguments);
    };
}();
var convertedHeicSingleImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(originFile) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!originFile.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(originFile)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        2,
                        originFile
                    ];
            }
        });
    });
    return function convertedHeicSingleImage(originFile) {
        return _ref.apply(this, arguments);
    };
}();
var setImageUrl = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var convertedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!file.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(file)
                    ];
                case 1:
                    convertedImage = _state.sent();
                    return [
                        2,
                        Object.assign(convertedImage, {
                            blobUrl: URL.createObjectURL(convertedImage)
                        })
                    ];
                case 2:
                    return [
                        2,
                        Object.assign(file, {
                            blobUrl: URL.createObjectURL(file)
                        })
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function setImageUrl(file) {
        return _ref.apply(this, arguments);
    };
}();
var onCompressImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file, options) {
        var imageCompression, blob, compressedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 221).then(__webpack_require__.bind(__webpack_require__, 40221))
                    ];
                case 1:
                    imageCompression = _state.sent().default;
                    return [
                        4,
                        imageCompression(file, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options))
                    ];
                case 2:
                    blob = _state.sent();
                    compressedImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        compressedImage
                    ];
            }
        });
    });
    return function onCompressImage(file, options) {
        return _ref.apply(this, arguments);
    };
}();
var resizingImg = function(param) {
    var originUrl = param.originUrl, width = param.width, height = param.height, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    return "".concat(originUrl, "?w=").concat(width, "&h=").concat(height, "&q=").concat(quality);
};
var isImage = function(image) {
    return image.type.includes("image");
};
var redirectPostImage = function(boardPostAttachmentId) {
    return "".concat(BFF_BASE_URL, "/api/v1/board/board-post-attachments/").concat(boardPostAttachmentId, "/redirect-to-signed-url");
};


/***/ }),

/***/ 36794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(50381));

var _excluded = ["text", "onCopy", "options", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  var _super = _createSuper(CopyToClipboard);

  function CopyToClipboard() {
    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var elem = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].cloneElement(elem, _objectSpread(_objectSpread({}, props), {}, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 72282:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(36794),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 91706:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2182,3063,9097,1498,8023,4059,4998,6982,7639,8391,2271,5615,5666,4611,5180,1822,1743,4365,9591,9535,5243,7151,5247,5203,8426,3305,6144,3153,6318,3650,8361,5505,9774,2888,179], function() { return __webpack_exec__(19494); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);